/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReviewBudgetRouteImport } from './routes/review-budget'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HandoffRouteImport } from './routes/handoff'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as PortalTokenRouteImport } from './routes/portal.$token'
import { Route as AuthTrialBalanceRouteImport } from './routes/_auth.trial-balance'
import { Route as AuthTmTicketsRouteImport } from './routes/_auth.tm-tickets'
import { Route as AuthTmInvoicesRouteImport } from './routes/_auth.tm-invoices'
import { Route as AuthTimeRouteImport } from './routes/_auth.time'
import { Route as AuthSubcontractsRouteImport } from './routes/_auth.subcontracts'
import { Route as AuthSubPayAppsRouteImport } from './routes/_auth.sub-pay-apps'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthSaasRouteImport } from './routes/_auth.saas'
import { Route as AuthRecurringJournalsRouteImport } from './routes/_auth.recurring-journals'
import { Route as AuthRecurringChargesRouteImport } from './routes/_auth.recurring-charges'
import { Route as AuthRecognitionRouteImport } from './routes/_auth.recognition'
import { Route as AuthRateSheetsRouteImport } from './routes/_auth.rate-sheets'
import { Route as AuthProjectsRouteImport } from './routes/_auth.projects'
import { Route as AuthProjectExecutiveRouteImport } from './routes/_auth.project-executive'
import { Route as AuthProgressBillingsRouteImport } from './routes/_auth.progress-billings'
import { Route as AuthPeriodsRouteImport } from './routes/_auth.periods'
import { Route as AuthPayrollL3RouteImport } from './routes/_auth.payroll-l3'
import { Route as AuthPayrollL2RouteImport } from './routes/_auth.payroll-l2'
import { Route as AuthPaymentsRouteImport } from './routes/_auth.payments'
import { Route as AuthOnboardingRouteImport } from './routes/_auth.onboarding'
import { Route as AuthLienWaiversRouteImport } from './routes/_auth.lien-waivers'
import { Route as AuthJournalsRouteImport } from './routes/_auth.journals'
import { Route as AuthJobCostRouteImport } from './routes/_auth.job-cost'
import { Route as AuthIntercompanyRouteImport } from './routes/_auth.intercompany'
import { Route as AuthIncomeStatementRouteImport } from './routes/_auth.income-statement'
import { Route as AuthImportsRouteImport } from './routes/_auth.imports'
import { Route as AuthHospitalityRouteImport } from './routes/_auth.hospitality'
import { Route as AuthHelpRouteImport } from './routes/_auth.help'
import { Route as AuthGlRouteImport } from './routes/_auth.gl'
import { Route as AuthFxRatesRouteImport } from './routes/_auth.fx-rates'
import { Route as AuthExpensesRouteImport } from './routes/_auth.expenses'
import { Route as AuthEquipmentRouteImport } from './routes/_auth.equipment'
import { Route as AuthEnterpriseAccountingRouteImport } from './routes/_auth.enterprise-accounting'
import { Route as AuthEmployeesRouteImport } from './routes/_auth.employees'
import { Route as AuthDataMigrationRouteImport } from './routes/_auth.data-migration'
import { Route as AuthCostCodesRouteImport } from './routes/_auth.cost-codes'
import { Route as AuthCostCodeTemplatesRouteImport } from './routes/_auth.cost-code-templates'
import { Route as AuthContractToCashRouteImport } from './routes/_auth.contract-to-cash'
import { Route as AuthContactsRouteImport } from './routes/_auth.contacts'
import { Route as AuthComplianceRouteImport } from './routes/_auth.compliance'
import { Route as AuthCloseRouteImport } from './routes/_auth.close'
import { Route as AuthChatHistoryRouteImport } from './routes/_auth.chat-history'
import { Route as AuthChatRouteImport } from './routes/_auth.chat'
import { Route as AuthChangeOrdersRouteImport } from './routes/_auth.change-orders'
import { Route as AuthCfoAdvisorRouteImport } from './routes/_auth.cfo-advisor'
import { Route as AuthCashFlowRouteImport } from './routes/_auth.cash-flow'
import { Route as AuthCapTableRouteImport } from './routes/_auth.cap-table'
import { Route as AuthBillsIntakeRouteImport } from './routes/_auth.bills-intake'
import { Route as AuthBankAccountsRouteImport } from './routes/_auth.bank-accounts'
import { Route as AuthBalanceSheetRouteImport } from './routes/_auth.balance-sheet'
import { Route as AuthAuditLogRouteImport } from './routes/_auth.audit-log'
import { Route as AuthAssetsRouteImport } from './routes/_auth.assets'
import { Route as AuthArRouteImport } from './routes/_auth.ar'
import { Route as AuthApprovalsRouteImport } from './routes/_auth.approvals'
import { Route as AuthApiSpendRouteImport } from './routes/_auth.api-spend'
import { Route as AuthApRouteImport } from './routes/_auth.ap'
import { Route as AuthAgentsRouteImport } from './routes/_auth.agents'
import { Route as AuthAccountsRouteImport } from './routes/_auth.accounts'
import { Route as AuthVendorsIndexRouteImport } from './routes/_auth.vendors.index'
import { Route as AuthTmTicketsIndexRouteImport } from './routes/_auth.tm-tickets.index'
import { Route as AuthTmInvoicesIndexRouteImport } from './routes/_auth.tm-invoices.index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth.settings.index'
import { Route as AuthSaasIndexRouteImport } from './routes/_auth.saas.index'
import { Route as AuthReportsIndexRouteImport } from './routes/_auth.reports.index'
import { Route as AuthRateSheetsIndexRouteImport } from './routes/_auth.rate-sheets.index'
import { Route as AuthPurchaseOrdersIndexRouteImport } from './routes/_auth.purchase-orders.index'
import { Route as AuthProjectsIndexRouteImport } from './routes/_auth.projects.index'
import { Route as AuthProgressBillingsIndexRouteImport } from './routes/_auth.progress-billings.index'
import { Route as AuthPeriodsIndexRouteImport } from './routes/_auth.periods.index'
import { Route as AuthPayrollL3IndexRouteImport } from './routes/_auth.payroll-l3.index'
import { Route as AuthPaymentsIndexRouteImport } from './routes/_auth.payments.index'
import { Route as AuthOnboardingIndexRouteImport } from './routes/_auth.onboarding.index'
import { Route as AuthJournalsIndexRouteImport } from './routes/_auth.journals.index'
import { Route as AuthInvoicesIndexRouteImport } from './routes/_auth.invoices.index'
import { Route as AuthIntercompanyIndexRouteImport } from './routes/_auth.intercompany.index'
import { Route as AuthHospitalityIndexRouteImport } from './routes/_auth.hospitality.index'
import { Route as AuthEquipmentIndexRouteImport } from './routes/_auth.equipment.index'
import { Route as AuthCustomersIndexRouteImport } from './routes/_auth.customers.index'
import { Route as AuthContractsIndexRouteImport } from './routes/_auth.contracts.index'
import { Route as AuthContractWorkPackagesIndexRouteImport } from './routes/_auth.contract-work-packages.index'
import { Route as AuthConcretePlantIndexRouteImport } from './routes/_auth.concrete-plant.index'
import { Route as AuthCloseIndexRouteImport } from './routes/_auth.close.index'
import { Route as AuthBankRecIndexRouteImport } from './routes/_auth.bank-rec.index'
import { Route as AuthBankAccountsIndexRouteImport } from './routes/_auth.bank-accounts.index'
import { Route as AuthApprovalsIndexRouteImport } from './routes/_auth.approvals.index'
import { Route as AuthVendorsMergeToolRouteImport } from './routes/_auth.vendors.merge-tool'
import { Route as AuthVendorsVendorIdRouteImport } from './routes/_auth.vendors.$vendorId'
import { Route as AuthTmTicketsNewRouteImport } from './routes/_auth.tm-tickets.new'
import { Route as AuthTmTicketsTicketIdRouteImport } from './routes/_auth.tm-tickets.$ticketId'
import { Route as AuthTmInvoicesNewRouteImport } from './routes/_auth.tm-invoices.new'
import { Route as AuthTmInvoicesInvoiceIdRouteImport } from './routes/_auth.tm-invoices.$invoiceId'
import { Route as AuthSubPayAppsPayAppIdRouteImport } from './routes/_auth.sub-pay-apps.$payAppId'
import { Route as AuthSettingsTeamRouteImport } from './routes/_auth.settings.team'
import { Route as AuthSettingsTaxRouteImport } from './routes/_auth.settings.tax'
import { Route as AuthSettingsShopifyRouteImport } from './routes/_auth.settings.shopify'
import { Route as AuthSettingsProfileRouteImport } from './routes/_auth.settings.profile'
import { Route as AuthSettingsNumberingRouteImport } from './routes/_auth.settings.numbering'
import { Route as AuthSettingsMcpRouteImport } from './routes/_auth.settings.mcp'
import { Route as AuthSettingsIntegrationsRouteImport } from './routes/_auth.settings.integrations'
import { Route as AuthSettingsImportsQuickbooksRouteImport } from './routes/_auth.settings.imports-quickbooks'
import { Route as AuthSettingsEntitiesRouteImport } from './routes/_auth.settings.entities'
import { Route as AuthSettingsDimensionsRouteImport } from './routes/_auth.settings.dimensions'
import { Route as AuthSettingsCurrencyRouteImport } from './routes/_auth.settings.currency'
import { Route as AuthSettingsCrmRouteImport } from './routes/_auth.settings.crm'
import { Route as AuthSettingsBankConnectionsRouteImport } from './routes/_auth.settings.bank-connections'
import { Route as AuthSettingsBackupsRouteImport } from './routes/_auth.settings.backups'
import { Route as AuthSettingsApiKeysRouteImport } from './routes/_auth.settings.api-keys'
import { Route as AuthSettingsApiCostsRouteImport } from './routes/_auth.settings.api-costs'
import { Route as AuthSettingsAboutRouteImport } from './routes/_auth.settings.about'
import { Route as AuthSaasVendorWatchRouteImport } from './routes/_auth.saas.vendor-watch'
import { Route as AuthSaasVariableConsiderationRouteImport } from './routes/_auth.saas.variable-consideration'
import { Route as AuthSaasPayrollSyncRouteImport } from './routes/_auth.saas.payroll-sync'
import { Route as AuthSaasMetricsRouteImport } from './routes/_auth.saas.metrics'
import { Route as AuthSaasCrmRouteImport } from './routes/_auth.saas.crm'
import { Route as AuthSaasCohortsRouteImport } from './routes/_auth.saas.cohorts'
import { Route as AuthReportsWipRouteImport } from './routes/_auth.reports.wip'
import { Route as AuthReportsTaxDepreciationRouteImport } from './routes/_auth.reports.tax-depreciation'
import { Route as AuthReportsSubRetentionRouteImport } from './routes/_auth.reports.sub-retention'
import { Route as AuthReportsSubPayAppAgingRouteImport } from './routes/_auth.reports.sub-pay-app-aging'
import { Route as AuthReportsSubDrawHistoryRouteImport } from './routes/_auth.reports.sub-draw-history'
import { Route as AuthReportsCostCodeRollupRouteImport } from './routes/_auth.reports.cost-code-rollup'
import { Route as AuthReportsConsolidatedRouteImport } from './routes/_auth.reports.consolidated'
import { Route as AuthReportsCommittedCostRouteImport } from './routes/_auth.reports.committed-cost'
import { Route as AuthReportsChartsRouteImport } from './routes/_auth.reports.charts'
import { Route as AuthReportsBuildRouteImport } from './routes/_auth.reports.build'
import { Route as AuthReportsBookTaxDifferenceRouteImport } from './routes/_auth.reports.book-tax-difference'
import { Route as AuthReportsAssetRollforwardRouteImport } from './routes/_auth.reports.asset-rollforward'
import { Route as AuthReportsArAgingRouteImport } from './routes/_auth.reports.ar-aging'
import { Route as AuthReportsApAgingRouteImport } from './routes/_auth.reports.ap-aging'
import { Route as AuthReportsReportIdRouteImport } from './routes/_auth.reports.$reportId'
import { Route as AuthRateSheetsNewRouteImport } from './routes/_auth.rate-sheets.new'
import { Route as AuthRateSheetsRateSheetIdRouteImport } from './routes/_auth.rate-sheets.$rateSheetId'
import { Route as AuthPurchaseOrdersNewRouteImport } from './routes/_auth.purchase-orders.new'
import { Route as AuthPurchaseOrdersPoIdRouteImport } from './routes/_auth.purchase-orders.$poId'
import { Route as AuthProjectsProjectIdRouteImport } from './routes/_auth.projects.$projectId'
import { Route as AuthProgressBillingsPbIdRouteImport } from './routes/_auth.progress-billings.$pbId'
import { Route as AuthPayrollYearEndRouteImport } from './routes/_auth.payroll.year-end'
import { Route as AuthPayrollTaxDepositsRouteImport } from './routes/_auth.payroll.tax-deposits'
import { Route as AuthPayrollSetupRouteImport } from './routes/_auth.payroll.setup'
import { Route as AuthPayrollPayRunsRouteImport } from './routes/_auth.payroll.pay-runs'
import { Route as AuthPayrollIrisSubmissionsRouteImport } from './routes/_auth.payroll.iris-submissions'
import { Route as AuthPayrollEmployeesRouteImport } from './routes/_auth.payroll.employees'
import { Route as AuthPayrollEarningCodesRouteImport } from './routes/_auth.payroll.earning-codes'
import { Route as AuthPayrollDeductionCodesRouteImport } from './routes/_auth.payroll.deduction-codes'
import { Route as AuthPayrollContractorsRouteImport } from './routes/_auth.payroll.contractors'
import { Route as AuthPayrollL4WageDeterminationsRouteImport } from './routes/_auth.payroll-l4.wage-determinations'
import { Route as AuthPayrollL4SubmissionsRouteImport } from './routes/_auth.payroll-l4.submissions'
import { Route as AuthPayrollL4ComplianceRouteImport } from './routes/_auth.payroll-l4.compliance'
import { Route as AuthPayrollL4CertifiedPayrollReportsRouteImport } from './routes/_auth.payroll-l4.certified-payroll-reports'
import { Route as AuthPayrollL4ApprenticeProgramsRouteImport } from './routes/_auth.payroll-l4.apprentice-programs'
import { Route as AuthPayrollL3WorkingRulesRouteImport } from './routes/_auth.payroll-l3.working-rules'
import { Route as AuthPayrollL3RemittanceRouteImport } from './routes/_auth.payroll-l3.remittance'
import { Route as AuthPayrollL3MembershipsRouteImport } from './routes/_auth.payroll-l3.memberships'
import { Route as AuthPayrollL3GlSetupRouteImport } from './routes/_auth.payroll-l3.gl-setup'
import { Route as AuthPayrollL3FringeFundsRouteImport } from './routes/_auth.payroll-l3.fringe-funds'
import { Route as AuthPayrollL3ContractsRouteImport } from './routes/_auth.payroll-l3.contracts'
import { Route as AuthPayrollL3ComplianceAlertsRouteImport } from './routes/_auth.payroll-l3.compliance-alerts'
import { Route as AuthPayrollL3ClassificationQueueRouteImport } from './routes/_auth.payroll-l3.classification-queue'
import { Route as AuthPayrollL3CbasRouteImport } from './routes/_auth.payroll-l3.cbas'
import { Route as AuthPayrollL3ApprenticeComplianceRouteImport } from './routes/_auth.payroll-l3.apprentice-compliance'
import { Route as AuthPayrollL2WorkersCompRouteImport } from './routes/_auth.payroll-l2.workers-comp'
import { Route as AuthPayrollL2TimesheetFeedRouteImport } from './routes/_auth.payroll-l2.timesheet-feed'
import { Route as AuthPayrollL2RetroPayRouteImport } from './routes/_auth.payroll-l2.retro-pay'
import { Route as AuthPayrollL2OtRulesRouteImport } from './routes/_auth.payroll-l2.ot-rules'
import { Route as AuthPayrollL2FormsRouteImport } from './routes/_auth.payroll-l2.forms'
import { Route as AuthPayrollL2FlaggedRouteImport } from './routes/_auth.payroll-l2.flagged'
import { Route as AuthPayrollL2ExpensesRouteImport } from './routes/_auth.payroll-l2.expenses'
import { Route as AuthPayrollL2EquipmentRouteImport } from './routes/_auth.payroll-l2.equipment'
import { Route as AuthPayrollL2DifferentialsRouteImport } from './routes/_auth.payroll-l2.differentials'
import { Route as AuthPayrollL2CraftsRouteImport } from './routes/_auth.payroll-l2.crafts'
import { Route as AuthPayrollL2BurdenRouteImport } from './routes/_auth.payroll-l2.burden'
import { Route as AuthPayrollL2AnomaliesRouteImport } from './routes/_auth.payroll-l2.anomalies'
import { Route as AuthPayrollL2AllowancesRouteImport } from './routes/_auth.payroll-l2.allowances'
import { Route as AuthPaymentsCheckRunRouteImport } from './routes/_auth.payments.check-run'
import { Route as AuthPaymentsPaymentIdRouteImport } from './routes/_auth.payments.$paymentId'
import { Route as AuthOnboardingSetupRouteImport } from './routes/_auth.onboarding.setup'
import { Route as AuthOnboardingCompleteRouteImport } from './routes/_auth.onboarding.complete'
import { Route as AuthLienWaiversTemplatesRouteImport } from './routes/_auth.lien-waivers_.templates'
import { Route as AuthJournalsNewRouteImport } from './routes/_auth.journals.new'
import { Route as AuthJournalsJournalIdRouteImport } from './routes/_auth.journals.$journalId'
import { Route as AuthIntercompanyTransactionsRouteImport } from './routes/_auth.intercompany.transactions'
import { Route as AuthHospitalityTitle31RouteImport } from './routes/_auth.hospitality.title-31'
import { Route as AuthHospitalityRevenueCentersRouteImport } from './routes/_auth.hospitality.revenue-centers'
import { Route as AuthHospitalityNightAuditRouteImport } from './routes/_auth.hospitality.night-audit'
import { Route as AuthHospitalityLodgingRouteImport } from './routes/_auth.hospitality.lodging'
import { Route as AuthHospitalityGamingTaxRouteImport } from './routes/_auth.hospitality.gaming-tax'
import { Route as AuthHospitalityGamingRouteImport } from './routes/_auth.hospitality.gaming'
import { Route as AuthHospitalityFpaRouteImport } from './routes/_auth.hospitality.fpa'
import { Route as AuthHospitalityFnbRouteImport } from './routes/_auth.hospitality.fnb'
import { Route as AuthHospitalityFlashRouteImport } from './routes/_auth.hospitality.flash'
import { Route as AuthHospitalityFilingsRouteImport } from './routes/_auth.hospitality.filings'
import { Route as AuthFpaBudgetRouteImport } from './routes/_auth.fpa.budget'
import { Route as AuthEquipmentRentalLinksRouteImport } from './routes/_auth.equipment.rental-links'
import { Route as AuthEquipmentCostPostingsRouteImport } from './routes/_auth.equipment.cost-postings'
import { Route as AuthEquipmentCostPostingRouteImport } from './routes/_auth.equipment.cost-posting'
import { Route as AuthEquipmentEquipmentIdRouteImport } from './routes/_auth.equipment.$equipmentId'
import { Route as AuthDirectExpenseNewRouteImport } from './routes/_auth.direct-expense.new'
import { Route as AuthCustomersCustomerIdRouteImport } from './routes/_auth.customers.$customerId'
import { Route as AuthContractsContractIdRouteImport } from './routes/_auth.contracts.$contractId'
import { Route as AuthContractWorkPackagesPackageIdRouteImport } from './routes/_auth.contract-work-packages.$packageId'
import { Route as AuthConcretePlantOperationsRouteImport } from './routes/_auth.concrete-plant.operations'
import { Route as AuthConcretePlantMaterialToMarginRouteImport } from './routes/_auth.concrete-plant.material-to-margin'
import { Route as AuthConcretePlantLoadToCashRouteImport } from './routes/_auth.concrete-plant.load-to-cash'
import { Route as AuthCloseTemplatesRouteImport } from './routes/_auth.close.templates'
import { Route as AuthClosePeriodIdRouteImport } from './routes/_auth.close.$periodId'
import { Route as AuthBankRecRecIdRouteImport } from './routes/_auth.bank-rec.$recId'
import { Route as AuthBankAccountsBankAccountIdRouteImport } from './routes/_auth.bank-accounts.$bankAccountId'
import { Route as AuthApprovalsPoliciesRouteImport } from './routes/_auth.approvals.policies'
import { Route as AuthApprovalsAnalyticsRouteImport } from './routes/_auth.approvals.analytics'
import { Route as AuthApAutopilotRouteImport } from './routes/_auth.ap.autopilot'
import { Route as AuthAdminUsageRouteImport } from './routes/_auth.admin.usage'
import { Route as AuthVendorsVendorIdIndexRouteImport } from './routes/_auth.vendors.$vendorId.index'
import { Route as AuthHospitalityLodgingIndexRouteImport } from './routes/_auth.hospitality.lodging.index'
import { Route as AuthEquipmentCostPostingsIndexRouteImport } from './routes/_auth.equipment.cost-postings.index'
import { Route as AuthVendorsVendorIdSubcontractsRouteImport } from './routes/_auth.vendors.$vendorId.subcontracts'
import { Route as AuthVendorsVendorIdQualificationRouteImport } from './routes/_auth.vendors.$vendorId.qualification'
import { Route as AuthVendorsVendorIdPosRouteImport } from './routes/_auth.vendors.$vendorId.pos'
import { Route as AuthVendorsVendorIdPaymentsRouteImport } from './routes/_auth.vendors.$vendorId.payments'
import { Route as AuthVendorsVendorIdLienWaiversRouteImport } from './routes/_auth.vendors.$vendorId.lien-waivers'
import { Route as AuthVendorsVendorIdAutopilotRouteImport } from './routes/_auth.vendors.$vendorId.autopilot'
import { Route as AuthVendorsVendorIdAddressesRouteImport } from './routes/_auth.vendors.$vendorId.addresses'
import { Route as AuthVendorsVendorIdActivityRouteImport } from './routes/_auth.vendors.$vendorId.activity'
import { Route as AuthSettingsPermissionsMeRouteImport } from './routes/_auth.settings.permissions.me'
import { Route as AuthSaasSubscriptionsSubIdRouteImport } from './routes/_auth.saas.subscriptions.$subId'
import { Route as AuthSaasPlansPlanIdRouteImport } from './routes/_auth.saas.plans.$planId'
import { Route as AuthProjectsProjectIdGmpRouteImport } from './routes/_auth.projects.$projectId.gmp'
import { Route as AuthPeriodsPeriodIdChecklistRouteImport } from './routes/_auth.periods.$periodId.checklist'
import { Route as AuthPayrollPayRunsPayRunIdRouteImport } from './routes/_auth.payroll.pay-runs_.$payRunId'
import { Route as AuthPayrollEmployeesEmployeeIdRouteImport } from './routes/_auth.payroll.employees_.$employeeId'
import { Route as AuthPayrollContractorsContractorIdRouteImport } from './routes/_auth.payroll.contractors_.$contractorId'
import { Route as AuthPayrollL4WageDeterminationsWdIdRouteImport } from './routes/_auth.payroll-l4.wage-determinations_.$wdId'
import { Route as AuthPayrollL4CertifiedPayrollReportsReportIdRouteImport } from './routes/_auth.payroll-l4.certified-payroll-reports_.$reportId'
import { Route as AuthPayrollL2LaborEventEventIdRouteImport } from './routes/_auth.payroll-l2.labor-event_.$eventId'
import { Route as AuthPayrollL2ExpensesNewRouteImport } from './routes/_auth.payroll-l2.expenses_.new'
import { Route as AuthPayrollL2EarnedValueProjectIdRouteImport } from './routes/_auth.payroll-l2.earned-value_.$projectId'
import { Route as AuthPayrollL2ComplianceGatePayRunIdRouteImport } from './routes/_auth.payroll-l2.compliance-gate_.$payRunId'
import { Route as AuthInvoicesArNewRouteImport } from './routes/_auth.invoices.ar.new'
import { Route as AuthInvoicesArInvoiceIdRouteImport } from './routes/_auth.invoices.ar.$invoiceId'
import { Route as AuthInvoicesApNewRouteImport } from './routes/_auth.invoices.ap.new'
import { Route as AuthInvoicesApInvoiceIdRouteImport } from './routes/_auth.invoices.ap.$invoiceId'
import { Route as AuthHospitalityLodgingFolioArRouteImport } from './routes/_auth.hospitality.lodging.folio-ar'
import { Route as AuthHospitalityGamingMarkersRouteImport } from './routes/_auth.hospitality.gaming.markers'
import { Route as AuthHospitalityGamingFloorRouteImport } from './routes/_auth.hospitality.gaming.floor'
import { Route as AuthHospitalityFnbTroncRouteImport } from './routes/_auth.hospitality.fnb.tronc'
import { Route as AuthHospitalityFnbPerformanceRouteImport } from './routes/_auth.hospitality.fnb.performance'
import { Route as AuthHelpDocsSplatRouteImport } from './routes/_auth.help_.docs.$'
import { Route as AuthEquipmentReportsVarianceRouteImport } from './routes/_auth.equipment.reports.variance'
import { Route as AuthEquipmentReportsCostByJobRouteImport } from './routes/_auth.equipment.reports.cost-by-job'
import { Route as AuthEquipmentCostPostingsPostingIdRouteImport } from './routes/_auth.equipment.cost-postings.$postingId'
import { Route as AuthPayrollEmployeesEmployeeIdIndexRouteImport } from './routes/_auth.payroll.employees_.$employeeId.index'
import { Route as AuthPayrollYearEndW3YearRouteImport } from './routes/_auth.payroll.year-end_.w3.$year'
import { Route as AuthPayrollYearEndW2YearRouteImport } from './routes/_auth.payroll.year-end_.w2.$year'
import { Route as AuthPayrollYearEnd940YearRouteImport } from './routes/_auth.payroll.year-end_.940.$year'
import { Route as AuthPayrollYearEnd1099NecYearRouteImport } from './routes/_auth.payroll.year-end_.1099-nec.$year'
import { Route as AuthPayrollYearEnd1099MiscYearRouteImport } from './routes/_auth.payroll.year-end_.1099-misc.$year'
import { Route as AuthPayrollEmployeesEmployeeIdW4RouteImport } from './routes/_auth.payroll.employees_.$employeeId.w4'
import { Route as AuthPayrollL2EmployeesEmployeeIdRatesRouteImport } from './routes/_auth.payroll-l2.employees_.$employeeId.rates'
import { Route as AuthPayrollYearEnd941YearQuarterRouteImport } from './routes/_auth.payroll.year-end_.941.$year.$quarter'

const ReviewBudgetRoute = ReviewBudgetRouteImport.update({
  id: '/review-budget',
  path: '/review-budget',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HandoffRoute = HandoffRouteImport.update({
  id: '/handoff',
  path: '/handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const PortalTokenRoute = PortalTokenRouteImport.update({
  id: '/portal/$token',
  path: '/portal/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTrialBalanceRoute = AuthTrialBalanceRouteImport.update({
  id: '/trial-balance',
  path: '/trial-balance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTmTicketsRoute = AuthTmTicketsRouteImport.update({
  id: '/tm-tickets',
  path: '/tm-tickets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTmInvoicesRoute = AuthTmInvoicesRouteImport.update({
  id: '/tm-invoices',
  path: '/tm-invoices',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTimeRoute = AuthTimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubcontractsRoute = AuthSubcontractsRouteImport.update({
  id: '/subcontracts',
  path: '/subcontracts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubPayAppsRoute = AuthSubPayAppsRouteImport.update({
  id: '/sub-pay-apps',
  path: '/sub-pay-apps',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSaasRoute = AuthSaasRouteImport.update({
  id: '/saas',
  path: '/saas',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecurringJournalsRoute = AuthRecurringJournalsRouteImport.update({
  id: '/recurring-journals',
  path: '/recurring-journals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecurringChargesRoute = AuthRecurringChargesRouteImport.update({
  id: '/recurring-charges',
  path: '/recurring-charges',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecognitionRoute = AuthRecognitionRouteImport.update({
  id: '/recognition',
  path: '/recognition',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRateSheetsRoute = AuthRateSheetsRouteImport.update({
  id: '/rate-sheets',
  path: '/rate-sheets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsRoute = AuthProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectExecutiveRoute = AuthProjectExecutiveRouteImport.update({
  id: '/project-executive',
  path: '/project-executive',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProgressBillingsRoute = AuthProgressBillingsRouteImport.update({
  id: '/progress-billings',
  path: '/progress-billings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPeriodsRoute = AuthPeriodsRouteImport.update({
  id: '/periods',
  path: '/periods',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollL3Route = AuthPayrollL3RouteImport.update({
  id: '/payroll-l3',
  path: '/payroll-l3',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollL2Route = AuthPayrollL2RouteImport.update({
  id: '/payroll-l2',
  path: '/payroll-l2',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsRoute = AuthPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLienWaiversRoute = AuthLienWaiversRouteImport.update({
  id: '/lien-waivers',
  path: '/lien-waivers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalsRoute = AuthJournalsRouteImport.update({
  id: '/journals',
  path: '/journals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJobCostRoute = AuthJobCostRouteImport.update({
  id: '/job-cost',
  path: '/job-cost',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIntercompanyRoute = AuthIntercompanyRouteImport.update({
  id: '/intercompany',
  path: '/intercompany',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIncomeStatementRoute = AuthIncomeStatementRouteImport.update({
  id: '/income-statement',
  path: '/income-statement',
  getParentRoute: () => AuthRoute,
} as any)
const AuthImportsRoute = AuthImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHospitalityRoute = AuthHospitalityRouteImport.update({
  id: '/hospitality',
  path: '/hospitality',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpRoute = AuthHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGlRoute = AuthGlRouteImport.update({
  id: '/gl',
  path: '/gl',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFxRatesRoute = AuthFxRatesRouteImport.update({
  id: '/fx-rates',
  path: '/fx-rates',
  getParentRoute: () => AuthRoute,
} as any)
const AuthExpensesRoute = AuthExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEquipmentRoute = AuthEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEnterpriseAccountingRoute =
  AuthEnterpriseAccountingRouteImport.update({
    id: '/enterprise-accounting',
    path: '/enterprise-accounting',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEmployeesRoute = AuthEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDataMigrationRoute = AuthDataMigrationRouteImport.update({
  id: '/data-migration',
  path: '/data-migration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCostCodesRoute = AuthCostCodesRouteImport.update({
  id: '/cost-codes',
  path: '/cost-codes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCostCodeTemplatesRoute = AuthCostCodeTemplatesRouteImport.update({
  id: '/cost-code-templates',
  path: '/cost-code-templates',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractToCashRoute = AuthContractToCashRouteImport.update({
  id: '/contract-to-cash',
  path: '/contract-to-cash',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsRoute = AuthContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthComplianceRoute = AuthComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCloseRoute = AuthCloseRouteImport.update({
  id: '/close',
  path: '/close',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChatHistoryRoute = AuthChatHistoryRouteImport.update({
  id: '/chat-history',
  path: '/chat-history',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChatRoute = AuthChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangeOrdersRoute = AuthChangeOrdersRouteImport.update({
  id: '/change-orders',
  path: '/change-orders',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCfoAdvisorRoute = AuthCfoAdvisorRouteImport.update({
  id: '/cfo-advisor',
  path: '/cfo-advisor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCashFlowRoute = AuthCashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCapTableRoute = AuthCapTableRouteImport.update({
  id: '/cap-table',
  path: '/cap-table',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillsIntakeRoute = AuthBillsIntakeRouteImport.update({
  id: '/bills-intake',
  path: '/bills-intake',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankAccountsRoute = AuthBankAccountsRouteImport.update({
  id: '/bank-accounts',
  path: '/bank-accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBalanceSheetRoute = AuthBalanceSheetRouteImport.update({
  id: '/balance-sheet',
  path: '/balance-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditLogRoute = AuthAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssetsRoute = AuthAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthArRoute = AuthArRouteImport.update({
  id: '/ar',
  path: '/ar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApprovalsRoute = AuthApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApiSpendRoute = AuthApiSpendRouteImport.update({
  id: '/api-spend',
  path: '/api-spend',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApRoute = AuthApRouteImport.update({
  id: '/ap',
  path: '/ap',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsRoute = AuthAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountsRoute = AuthAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorsIndexRoute = AuthVendorsIndexRouteImport.update({
  id: '/vendors/',
  path: '/vendors/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTmTicketsIndexRoute = AuthTmTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTmTicketsRoute,
} as any)
const AuthTmInvoicesIndexRoute = AuthTmInvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTmInvoicesRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSaasIndexRoute = AuthSaasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthReportsIndexRoute = AuthReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRateSheetsIndexRoute = AuthRateSheetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRateSheetsRoute,
} as any)
const AuthPurchaseOrdersIndexRoute = AuthPurchaseOrdersIndexRouteImport.update({
  id: '/purchase-orders/',
  path: '/purchase-orders/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsIndexRoute = AuthProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProjectsRoute,
} as any)
const AuthProgressBillingsIndexRoute =
  AuthProgressBillingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProgressBillingsRoute,
  } as any)
const AuthPeriodsIndexRoute = AuthPeriodsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPeriodsRoute,
} as any)
const AuthPayrollL3IndexRoute = AuthPayrollL3IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPayrollL3Route,
} as any)
const AuthPaymentsIndexRoute = AuthPaymentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPaymentsRoute,
} as any)
const AuthOnboardingIndexRoute = AuthOnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOnboardingRoute,
} as any)
const AuthJournalsIndexRoute = AuthJournalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthJournalsRoute,
} as any)
const AuthInvoicesIndexRoute = AuthInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIntercompanyIndexRoute = AuthIntercompanyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthIntercompanyRoute,
} as any)
const AuthHospitalityIndexRoute = AuthHospitalityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthEquipmentIndexRoute = AuthEquipmentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEquipmentRoute,
} as any)
const AuthCustomersIndexRoute = AuthCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractsIndexRoute = AuthContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractWorkPackagesIndexRoute =
  AuthContractWorkPackagesIndexRouteImport.update({
    id: '/contract-work-packages/',
    path: '/contract-work-packages/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConcretePlantIndexRoute = AuthConcretePlantIndexRouteImport.update({
  id: '/concrete-plant/',
  path: '/concrete-plant/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCloseIndexRoute = AuthCloseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCloseRoute,
} as any)
const AuthBankRecIndexRoute = AuthBankRecIndexRouteImport.update({
  id: '/bank-rec/',
  path: '/bank-rec/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankAccountsIndexRoute = AuthBankAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBankAccountsRoute,
} as any)
const AuthApprovalsIndexRoute = AuthApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthApprovalsRoute,
} as any)
const AuthVendorsMergeToolRoute = AuthVendorsMergeToolRouteImport.update({
  id: '/vendors/merge-tool',
  path: '/vendors/merge-tool',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorsVendorIdRoute = AuthVendorsVendorIdRouteImport.update({
  id: '/vendors/$vendorId',
  path: '/vendors/$vendorId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTmTicketsNewRoute = AuthTmTicketsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthTmTicketsRoute,
} as any)
const AuthTmTicketsTicketIdRoute = AuthTmTicketsTicketIdRouteImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => AuthTmTicketsRoute,
} as any)
const AuthTmInvoicesNewRoute = AuthTmInvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthTmInvoicesRoute,
} as any)
const AuthTmInvoicesInvoiceIdRoute = AuthTmInvoicesInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => AuthTmInvoicesRoute,
} as any)
const AuthSubPayAppsPayAppIdRoute = AuthSubPayAppsPayAppIdRouteImport.update({
  id: '/$payAppId',
  path: '/$payAppId',
  getParentRoute: () => AuthSubPayAppsRoute,
} as any)
const AuthSettingsTeamRoute = AuthSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsTaxRoute = AuthSettingsTaxRouteImport.update({
  id: '/tax',
  path: '/tax',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsShopifyRoute = AuthSettingsShopifyRouteImport.update({
  id: '/shopify',
  path: '/shopify',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsNumberingRoute = AuthSettingsNumberingRouteImport.update({
  id: '/numbering',
  path: '/numbering',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsMcpRoute = AuthSettingsMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsIntegrationsRoute =
  AuthSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsImportsQuickbooksRoute =
  AuthSettingsImportsQuickbooksRouteImport.update({
    id: '/imports-quickbooks',
    path: '/imports-quickbooks',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsEntitiesRoute = AuthSettingsEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsDimensionsRoute = AuthSettingsDimensionsRouteImport.update({
  id: '/dimensions',
  path: '/dimensions',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsCurrencyRoute = AuthSettingsCurrencyRouteImport.update({
  id: '/currency',
  path: '/currency',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsCrmRoute = AuthSettingsCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsBankConnectionsRoute =
  AuthSettingsBankConnectionsRouteImport.update({
    id: '/bank-connections',
    path: '/bank-connections',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsBackupsRoute = AuthSettingsBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsApiKeysRoute = AuthSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsApiCostsRoute = AuthSettingsApiCostsRouteImport.update({
  id: '/api-costs',
  path: '/api-costs',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsAboutRoute = AuthSettingsAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSaasVendorWatchRoute = AuthSaasVendorWatchRouteImport.update({
  id: '/vendor-watch',
  path: '/vendor-watch',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthSaasVariableConsiderationRoute =
  AuthSaasVariableConsiderationRouteImport.update({
    id: '/variable-consideration',
    path: '/variable-consideration',
    getParentRoute: () => AuthSaasRoute,
  } as any)
const AuthSaasPayrollSyncRoute = AuthSaasPayrollSyncRouteImport.update({
  id: '/payroll-sync',
  path: '/payroll-sync',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthSaasMetricsRoute = AuthSaasMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthSaasCrmRoute = AuthSaasCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthSaasCohortsRoute = AuthSaasCohortsRouteImport.update({
  id: '/cohorts',
  path: '/cohorts',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthReportsWipRoute = AuthReportsWipRouteImport.update({
  id: '/reports/wip',
  path: '/reports/wip',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsTaxDepreciationRoute =
  AuthReportsTaxDepreciationRouteImport.update({
    id: '/reports/tax-depreciation',
    path: '/reports/tax-depreciation',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsSubRetentionRoute = AuthReportsSubRetentionRouteImport.update({
  id: '/reports/sub-retention',
  path: '/reports/sub-retention',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsSubPayAppAgingRoute =
  AuthReportsSubPayAppAgingRouteImport.update({
    id: '/reports/sub-pay-app-aging',
    path: '/reports/sub-pay-app-aging',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsSubDrawHistoryRoute =
  AuthReportsSubDrawHistoryRouteImport.update({
    id: '/reports/sub-draw-history',
    path: '/reports/sub-draw-history',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsCostCodeRollupRoute =
  AuthReportsCostCodeRollupRouteImport.update({
    id: '/reports/cost-code-rollup',
    path: '/reports/cost-code-rollup',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsConsolidatedRoute = AuthReportsConsolidatedRouteImport.update({
  id: '/reports/consolidated',
  path: '/reports/consolidated',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsCommittedCostRoute =
  AuthReportsCommittedCostRouteImport.update({
    id: '/reports/committed-cost',
    path: '/reports/committed-cost',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsChartsRoute = AuthReportsChartsRouteImport.update({
  id: '/reports/charts',
  path: '/reports/charts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsBuildRoute = AuthReportsBuildRouteImport.update({
  id: '/reports/build',
  path: '/reports/build',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsBookTaxDifferenceRoute =
  AuthReportsBookTaxDifferenceRouteImport.update({
    id: '/reports/book-tax-difference',
    path: '/reports/book-tax-difference',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsAssetRollforwardRoute =
  AuthReportsAssetRollforwardRouteImport.update({
    id: '/reports/asset-rollforward',
    path: '/reports/asset-rollforward',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsArAgingRoute = AuthReportsArAgingRouteImport.update({
  id: '/reports/ar-aging',
  path: '/reports/ar-aging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsApAgingRoute = AuthReportsApAgingRouteImport.update({
  id: '/reports/ap-aging',
  path: '/reports/ap-aging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsReportIdRoute = AuthReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRateSheetsNewRoute = AuthRateSheetsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthRateSheetsRoute,
} as any)
const AuthRateSheetsRateSheetIdRoute =
  AuthRateSheetsRateSheetIdRouteImport.update({
    id: '/$rateSheetId',
    path: '/$rateSheetId',
    getParentRoute: () => AuthRateSheetsRoute,
  } as any)
const AuthPurchaseOrdersNewRoute = AuthPurchaseOrdersNewRouteImport.update({
  id: '/purchase-orders/new',
  path: '/purchase-orders/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPurchaseOrdersPoIdRoute = AuthPurchaseOrdersPoIdRouteImport.update({
  id: '/purchase-orders/$poId',
  path: '/purchase-orders/$poId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsProjectIdRoute = AuthProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => AuthProjectsRoute,
} as any)
const AuthProgressBillingsPbIdRoute =
  AuthProgressBillingsPbIdRouteImport.update({
    id: '/$pbId',
    path: '/$pbId',
    getParentRoute: () => AuthProgressBillingsRoute,
  } as any)
const AuthPayrollYearEndRoute = AuthPayrollYearEndRouteImport.update({
  id: '/payroll/year-end',
  path: '/payroll/year-end',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollTaxDepositsRoute = AuthPayrollTaxDepositsRouteImport.update({
  id: '/payroll/tax-deposits',
  path: '/payroll/tax-deposits',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollSetupRoute = AuthPayrollSetupRouteImport.update({
  id: '/payroll/setup',
  path: '/payroll/setup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollPayRunsRoute = AuthPayrollPayRunsRouteImport.update({
  id: '/payroll/pay-runs',
  path: '/payroll/pay-runs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollIrisSubmissionsRoute =
  AuthPayrollIrisSubmissionsRouteImport.update({
    id: '/payroll/iris-submissions',
    path: '/payroll/iris-submissions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollEmployeesRoute = AuthPayrollEmployeesRouteImport.update({
  id: '/payroll/employees',
  path: '/payroll/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollEarningCodesRoute = AuthPayrollEarningCodesRouteImport.update({
  id: '/payroll/earning-codes',
  path: '/payroll/earning-codes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollDeductionCodesRoute =
  AuthPayrollDeductionCodesRouteImport.update({
    id: '/payroll/deduction-codes',
    path: '/payroll/deduction-codes',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollContractorsRoute = AuthPayrollContractorsRouteImport.update({
  id: '/payroll/contractors',
  path: '/payroll/contractors',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollL4WageDeterminationsRoute =
  AuthPayrollL4WageDeterminationsRouteImport.update({
    id: '/payroll-l4/wage-determinations',
    path: '/payroll-l4/wage-determinations',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL4SubmissionsRoute =
  AuthPayrollL4SubmissionsRouteImport.update({
    id: '/payroll-l4/submissions',
    path: '/payroll-l4/submissions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL4ComplianceRoute = AuthPayrollL4ComplianceRouteImport.update({
  id: '/payroll-l4/compliance',
  path: '/payroll-l4/compliance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollL4CertifiedPayrollReportsRoute =
  AuthPayrollL4CertifiedPayrollReportsRouteImport.update({
    id: '/payroll-l4/certified-payroll-reports',
    path: '/payroll-l4/certified-payroll-reports',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL4ApprenticeProgramsRoute =
  AuthPayrollL4ApprenticeProgramsRouteImport.update({
    id: '/payroll-l4/apprentice-programs',
    path: '/payroll-l4/apprentice-programs',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL3WorkingRulesRoute =
  AuthPayrollL3WorkingRulesRouteImport.update({
    id: '/working-rules',
    path: '/working-rules',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL3RemittanceRoute = AuthPayrollL3RemittanceRouteImport.update({
  id: '/remittance',
  path: '/remittance',
  getParentRoute: () => AuthPayrollL3Route,
} as any)
const AuthPayrollL3MembershipsRoute =
  AuthPayrollL3MembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL3GlSetupRoute = AuthPayrollL3GlSetupRouteImport.update({
  id: '/gl-setup',
  path: '/gl-setup',
  getParentRoute: () => AuthPayrollL3Route,
} as any)
const AuthPayrollL3FringeFundsRoute =
  AuthPayrollL3FringeFundsRouteImport.update({
    id: '/fringe-funds',
    path: '/fringe-funds',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL3ContractsRoute = AuthPayrollL3ContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AuthPayrollL3Route,
} as any)
const AuthPayrollL3ComplianceAlertsRoute =
  AuthPayrollL3ComplianceAlertsRouteImport.update({
    id: '/compliance-alerts',
    path: '/compliance-alerts',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL3ClassificationQueueRoute =
  AuthPayrollL3ClassificationQueueRouteImport.update({
    id: '/classification-queue',
    path: '/classification-queue',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL3CbasRoute = AuthPayrollL3CbasRouteImport.update({
  id: '/cbas',
  path: '/cbas',
  getParentRoute: () => AuthPayrollL3Route,
} as any)
const AuthPayrollL3ApprenticeComplianceRoute =
  AuthPayrollL3ApprenticeComplianceRouteImport.update({
    id: '/apprentice-compliance',
    path: '/apprentice-compliance',
    getParentRoute: () => AuthPayrollL3Route,
  } as any)
const AuthPayrollL2WorkersCompRoute =
  AuthPayrollL2WorkersCompRouteImport.update({
    id: '/workers-comp',
    path: '/workers-comp',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2TimesheetFeedRoute =
  AuthPayrollL2TimesheetFeedRouteImport.update({
    id: '/timesheet-feed',
    path: '/timesheet-feed',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2RetroPayRoute = AuthPayrollL2RetroPayRouteImport.update({
  id: '/retro-pay',
  path: '/retro-pay',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2OtRulesRoute = AuthPayrollL2OtRulesRouteImport.update({
  id: '/ot-rules',
  path: '/ot-rules',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2FormsRoute = AuthPayrollL2FormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2FlaggedRoute = AuthPayrollL2FlaggedRouteImport.update({
  id: '/flagged',
  path: '/flagged',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2ExpensesRoute = AuthPayrollL2ExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2EquipmentRoute = AuthPayrollL2EquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2DifferentialsRoute =
  AuthPayrollL2DifferentialsRouteImport.update({
    id: '/differentials',
    path: '/differentials',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2CraftsRoute = AuthPayrollL2CraftsRouteImport.update({
  id: '/crafts',
  path: '/crafts',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2BurdenRoute = AuthPayrollL2BurdenRouteImport.update({
  id: '/burden',
  path: '/burden',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2AnomaliesRoute = AuthPayrollL2AnomaliesRouteImport.update({
  id: '/anomalies',
  path: '/anomalies',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPayrollL2AllowancesRoute = AuthPayrollL2AllowancesRouteImport.update({
  id: '/allowances',
  path: '/allowances',
  getParentRoute: () => AuthPayrollL2Route,
} as any)
const AuthPaymentsCheckRunRoute = AuthPaymentsCheckRunRouteImport.update({
  id: '/check-run',
  path: '/check-run',
  getParentRoute: () => AuthPaymentsRoute,
} as any)
const AuthPaymentsPaymentIdRoute = AuthPaymentsPaymentIdRouteImport.update({
  id: '/$paymentId',
  path: '/$paymentId',
  getParentRoute: () => AuthPaymentsRoute,
} as any)
const AuthOnboardingSetupRoute = AuthOnboardingSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthOnboardingRoute,
} as any)
const AuthOnboardingCompleteRoute = AuthOnboardingCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => AuthOnboardingRoute,
} as any)
const AuthLienWaiversTemplatesRoute =
  AuthLienWaiversTemplatesRouteImport.update({
    id: '/lien-waivers_/templates',
    path: '/lien-waivers/templates',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthJournalsNewRoute = AuthJournalsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthJournalsRoute,
} as any)
const AuthJournalsJournalIdRoute = AuthJournalsJournalIdRouteImport.update({
  id: '/$journalId',
  path: '/$journalId',
  getParentRoute: () => AuthJournalsRoute,
} as any)
const AuthIntercompanyTransactionsRoute =
  AuthIntercompanyTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthIntercompanyRoute,
  } as any)
const AuthHospitalityTitle31Route = AuthHospitalityTitle31RouteImport.update({
  id: '/title-31',
  path: '/title-31',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityRevenueCentersRoute =
  AuthHospitalityRevenueCentersRouteImport.update({
    id: '/revenue-centers',
    path: '/revenue-centers',
    getParentRoute: () => AuthHospitalityRoute,
  } as any)
const AuthHospitalityNightAuditRoute =
  AuthHospitalityNightAuditRouteImport.update({
    id: '/night-audit',
    path: '/night-audit',
    getParentRoute: () => AuthHospitalityRoute,
  } as any)
const AuthHospitalityLodgingRoute = AuthHospitalityLodgingRouteImport.update({
  id: '/lodging',
  path: '/lodging',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityGamingTaxRoute =
  AuthHospitalityGamingTaxRouteImport.update({
    id: '/gaming-tax',
    path: '/gaming-tax',
    getParentRoute: () => AuthHospitalityRoute,
  } as any)
const AuthHospitalityGamingRoute = AuthHospitalityGamingRouteImport.update({
  id: '/gaming',
  path: '/gaming',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityFpaRoute = AuthHospitalityFpaRouteImport.update({
  id: '/fpa',
  path: '/fpa',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityFnbRoute = AuthHospitalityFnbRouteImport.update({
  id: '/fnb',
  path: '/fnb',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityFlashRoute = AuthHospitalityFlashRouteImport.update({
  id: '/flash',
  path: '/flash',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthHospitalityFilingsRoute = AuthHospitalityFilingsRouteImport.update({
  id: '/filings',
  path: '/filings',
  getParentRoute: () => AuthHospitalityRoute,
} as any)
const AuthFpaBudgetRoute = AuthFpaBudgetRouteImport.update({
  id: '/fpa/budget',
  path: '/fpa/budget',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEquipmentRentalLinksRoute =
  AuthEquipmentRentalLinksRouteImport.update({
    id: '/rental-links',
    path: '/rental-links',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthEquipmentCostPostingsRoute =
  AuthEquipmentCostPostingsRouteImport.update({
    id: '/cost-postings',
    path: '/cost-postings',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthEquipmentCostPostingRoute =
  AuthEquipmentCostPostingRouteImport.update({
    id: '/cost-posting',
    path: '/cost-posting',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthEquipmentEquipmentIdRoute =
  AuthEquipmentEquipmentIdRouteImport.update({
    id: '/$equipmentId',
    path: '/$equipmentId',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthDirectExpenseNewRoute = AuthDirectExpenseNewRouteImport.update({
  id: '/direct-expense/new',
  path: '/direct-expense/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersCustomerIdRoute = AuthCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractsContractIdRoute = AuthContractsContractIdRouteImport.update({
  id: '/contracts/$contractId',
  path: '/contracts/$contractId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContractWorkPackagesPackageIdRoute =
  AuthContractWorkPackagesPackageIdRouteImport.update({
    id: '/contract-work-packages/$packageId',
    path: '/contract-work-packages/$packageId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConcretePlantOperationsRoute =
  AuthConcretePlantOperationsRouteImport.update({
    id: '/concrete-plant/operations',
    path: '/concrete-plant/operations',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConcretePlantMaterialToMarginRoute =
  AuthConcretePlantMaterialToMarginRouteImport.update({
    id: '/concrete-plant/material-to-margin',
    path: '/concrete-plant/material-to-margin',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConcretePlantLoadToCashRoute =
  AuthConcretePlantLoadToCashRouteImport.update({
    id: '/concrete-plant/load-to-cash',
    path: '/concrete-plant/load-to-cash',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCloseTemplatesRoute = AuthCloseTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthCloseRoute,
} as any)
const AuthClosePeriodIdRoute = AuthClosePeriodIdRouteImport.update({
  id: '/$periodId',
  path: '/$periodId',
  getParentRoute: () => AuthCloseRoute,
} as any)
const AuthBankRecRecIdRoute = AuthBankRecRecIdRouteImport.update({
  id: '/bank-rec/$recId',
  path: '/bank-rec/$recId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankAccountsBankAccountIdRoute =
  AuthBankAccountsBankAccountIdRouteImport.update({
    id: '/$bankAccountId',
    path: '/$bankAccountId',
    getParentRoute: () => AuthBankAccountsRoute,
  } as any)
const AuthApprovalsPoliciesRoute = AuthApprovalsPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AuthApprovalsRoute,
} as any)
const AuthApprovalsAnalyticsRoute = AuthApprovalsAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthApprovalsRoute,
} as any)
const AuthApAutopilotRoute = AuthApAutopilotRouteImport.update({
  id: '/autopilot',
  path: '/autopilot',
  getParentRoute: () => AuthApRoute,
} as any)
const AuthAdminUsageRoute = AuthAdminUsageRouteImport.update({
  id: '/admin/usage',
  path: '/admin/usage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorsVendorIdIndexRoute =
  AuthVendorsVendorIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthHospitalityLodgingIndexRoute =
  AuthHospitalityLodgingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthHospitalityLodgingRoute,
  } as any)
const AuthEquipmentCostPostingsIndexRoute =
  AuthEquipmentCostPostingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthEquipmentCostPostingsRoute,
  } as any)
const AuthVendorsVendorIdSubcontractsRoute =
  AuthVendorsVendorIdSubcontractsRouteImport.update({
    id: '/subcontracts',
    path: '/subcontracts',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdQualificationRoute =
  AuthVendorsVendorIdQualificationRouteImport.update({
    id: '/qualification',
    path: '/qualification',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdPosRoute = AuthVendorsVendorIdPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AuthVendorsVendorIdRoute,
} as any)
const AuthVendorsVendorIdPaymentsRoute =
  AuthVendorsVendorIdPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdLienWaiversRoute =
  AuthVendorsVendorIdLienWaiversRouteImport.update({
    id: '/lien-waivers',
    path: '/lien-waivers',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdAutopilotRoute =
  AuthVendorsVendorIdAutopilotRouteImport.update({
    id: '/autopilot',
    path: '/autopilot',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdAddressesRoute =
  AuthVendorsVendorIdAddressesRouteImport.update({
    id: '/addresses',
    path: '/addresses',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthVendorsVendorIdActivityRoute =
  AuthVendorsVendorIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthVendorsVendorIdRoute,
  } as any)
const AuthSettingsPermissionsMeRoute =
  AuthSettingsPermissionsMeRouteImport.update({
    id: '/permissions/me',
    path: '/permissions/me',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSaasSubscriptionsSubIdRoute =
  AuthSaasSubscriptionsSubIdRouteImport.update({
    id: '/subscriptions/$subId',
    path: '/subscriptions/$subId',
    getParentRoute: () => AuthSaasRoute,
  } as any)
const AuthSaasPlansPlanIdRoute = AuthSaasPlansPlanIdRouteImport.update({
  id: '/plans/$planId',
  path: '/plans/$planId',
  getParentRoute: () => AuthSaasRoute,
} as any)
const AuthProjectsProjectIdGmpRoute =
  AuthProjectsProjectIdGmpRouteImport.update({
    id: '/gmp',
    path: '/gmp',
    getParentRoute: () => AuthProjectsProjectIdRoute,
  } as any)
const AuthPeriodsPeriodIdChecklistRoute =
  AuthPeriodsPeriodIdChecklistRouteImport.update({
    id: '/$periodId/checklist',
    path: '/$periodId/checklist',
    getParentRoute: () => AuthPeriodsRoute,
  } as any)
const AuthPayrollPayRunsPayRunIdRoute =
  AuthPayrollPayRunsPayRunIdRouteImport.update({
    id: '/payroll/pay-runs_/$payRunId',
    path: '/payroll/pay-runs/$payRunId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollEmployeesEmployeeIdRoute =
  AuthPayrollEmployeesEmployeeIdRouteImport.update({
    id: '/payroll/employees_/$employeeId',
    path: '/payroll/employees/$employeeId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollContractorsContractorIdRoute =
  AuthPayrollContractorsContractorIdRouteImport.update({
    id: '/payroll/contractors_/$contractorId',
    path: '/payroll/contractors/$contractorId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL4WageDeterminationsWdIdRoute =
  AuthPayrollL4WageDeterminationsWdIdRouteImport.update({
    id: '/payroll-l4/wage-determinations_/$wdId',
    path: '/payroll-l4/wage-determinations/$wdId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL4CertifiedPayrollReportsReportIdRoute =
  AuthPayrollL4CertifiedPayrollReportsReportIdRouteImport.update({
    id: '/payroll-l4/certified-payroll-reports_/$reportId',
    path: '/payroll-l4/certified-payroll-reports/$reportId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollL2LaborEventEventIdRoute =
  AuthPayrollL2LaborEventEventIdRouteImport.update({
    id: '/labor-event_/$eventId',
    path: '/labor-event/$eventId',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2ExpensesNewRoute =
  AuthPayrollL2ExpensesNewRouteImport.update({
    id: '/expenses_/new',
    path: '/expenses/new',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2EarnedValueProjectIdRoute =
  AuthPayrollL2EarnedValueProjectIdRouteImport.update({
    id: '/earned-value_/$projectId',
    path: '/earned-value/$projectId',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollL2ComplianceGatePayRunIdRoute =
  AuthPayrollL2ComplianceGatePayRunIdRouteImport.update({
    id: '/compliance-gate_/$payRunId',
    path: '/compliance-gate/$payRunId',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthInvoicesArNewRoute = AuthInvoicesArNewRouteImport.update({
  id: '/invoices/ar/new',
  path: '/invoices/ar/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesArInvoiceIdRoute = AuthInvoicesArInvoiceIdRouteImport.update({
  id: '/invoices/ar/$invoiceId',
  path: '/invoices/ar/$invoiceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesApNewRoute = AuthInvoicesApNewRouteImport.update({
  id: '/invoices/ap/new',
  path: '/invoices/ap/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesApInvoiceIdRoute = AuthInvoicesApInvoiceIdRouteImport.update({
  id: '/invoices/ap/$invoiceId',
  path: '/invoices/ap/$invoiceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHospitalityLodgingFolioArRoute =
  AuthHospitalityLodgingFolioArRouteImport.update({
    id: '/folio-ar',
    path: '/folio-ar',
    getParentRoute: () => AuthHospitalityLodgingRoute,
  } as any)
const AuthHospitalityGamingMarkersRoute =
  AuthHospitalityGamingMarkersRouteImport.update({
    id: '/markers',
    path: '/markers',
    getParentRoute: () => AuthHospitalityGamingRoute,
  } as any)
const AuthHospitalityGamingFloorRoute =
  AuthHospitalityGamingFloorRouteImport.update({
    id: '/floor',
    path: '/floor',
    getParentRoute: () => AuthHospitalityGamingRoute,
  } as any)
const AuthHospitalityFnbTroncRoute = AuthHospitalityFnbTroncRouteImport.update({
  id: '/tronc',
  path: '/tronc',
  getParentRoute: () => AuthHospitalityFnbRoute,
} as any)
const AuthHospitalityFnbPerformanceRoute =
  AuthHospitalityFnbPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthHospitalityFnbRoute,
  } as any)
const AuthHelpDocsSplatRoute = AuthHelpDocsSplatRouteImport.update({
  id: '/help_/docs/$',
  path: '/help/docs/$',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEquipmentReportsVarianceRoute =
  AuthEquipmentReportsVarianceRouteImport.update({
    id: '/reports/variance',
    path: '/reports/variance',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthEquipmentReportsCostByJobRoute =
  AuthEquipmentReportsCostByJobRouteImport.update({
    id: '/reports/cost-by-job',
    path: '/reports/cost-by-job',
    getParentRoute: () => AuthEquipmentRoute,
  } as any)
const AuthEquipmentCostPostingsPostingIdRoute =
  AuthEquipmentCostPostingsPostingIdRouteImport.update({
    id: '/$postingId',
    path: '/$postingId',
    getParentRoute: () => AuthEquipmentCostPostingsRoute,
  } as any)
const AuthPayrollEmployeesEmployeeIdIndexRoute =
  AuthPayrollEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPayrollEmployeesEmployeeIdRoute,
  } as any)
const AuthPayrollYearEndW3YearRoute =
  AuthPayrollYearEndW3YearRouteImport.update({
    id: '/payroll/year-end_/w3/$year',
    path: '/payroll/year-end/w3/$year',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollYearEndW2YearRoute =
  AuthPayrollYearEndW2YearRouteImport.update({
    id: '/payroll/year-end_/w2/$year',
    path: '/payroll/year-end/w2/$year',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollYearEnd940YearRoute =
  AuthPayrollYearEnd940YearRouteImport.update({
    id: '/payroll/year-end_/940/$year',
    path: '/payroll/year-end/940/$year',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollYearEnd1099NecYearRoute =
  AuthPayrollYearEnd1099NecYearRouteImport.update({
    id: '/payroll/year-end_/1099-nec/$year',
    path: '/payroll/year-end/1099-nec/$year',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollYearEnd1099MiscYearRoute =
  AuthPayrollYearEnd1099MiscYearRouteImport.update({
    id: '/payroll/year-end_/1099-misc/$year',
    path: '/payroll/year-end/1099-misc/$year',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPayrollEmployeesEmployeeIdW4Route =
  AuthPayrollEmployeesEmployeeIdW4RouteImport.update({
    id: '/w4',
    path: '/w4',
    getParentRoute: () => AuthPayrollEmployeesEmployeeIdRoute,
  } as any)
const AuthPayrollL2EmployeesEmployeeIdRatesRoute =
  AuthPayrollL2EmployeesEmployeeIdRatesRouteImport.update({
    id: '/employees_/$employeeId/rates',
    path: '/employees/$employeeId/rates',
    getParentRoute: () => AuthPayrollL2Route,
  } as any)
const AuthPayrollYearEnd941YearQuarterRoute =
  AuthPayrollYearEnd941YearQuarterRouteImport.update({
    id: '/payroll/year-end_/941/$year/$quarter',
    path: '/payroll/year-end/941/$year/$quarter',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof CallbackRoute
  '/handoff': typeof HandoffRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/review-budget': typeof ReviewBudgetRoute
  '/accounts': typeof AuthAccountsRoute
  '/agents': typeof AuthAgentsRoute
  '/ap': typeof AuthApRouteWithChildren
  '/api-spend': typeof AuthApiSpendRoute
  '/approvals': typeof AuthApprovalsRouteWithChildren
  '/ar': typeof AuthArRoute
  '/assets': typeof AuthAssetsRoute
  '/audit-log': typeof AuthAuditLogRoute
  '/balance-sheet': typeof AuthBalanceSheetRoute
  '/bank-accounts': typeof AuthBankAccountsRouteWithChildren
  '/bills-intake': typeof AuthBillsIntakeRoute
  '/cap-table': typeof AuthCapTableRoute
  '/cash-flow': typeof AuthCashFlowRoute
  '/cfo-advisor': typeof AuthCfoAdvisorRoute
  '/change-orders': typeof AuthChangeOrdersRoute
  '/chat': typeof AuthChatRoute
  '/chat-history': typeof AuthChatHistoryRoute
  '/close': typeof AuthCloseRouteWithChildren
  '/compliance': typeof AuthComplianceRoute
  '/contacts': typeof AuthContactsRoute
  '/contract-to-cash': typeof AuthContractToCashRoute
  '/cost-code-templates': typeof AuthCostCodeTemplatesRoute
  '/cost-codes': typeof AuthCostCodesRoute
  '/data-migration': typeof AuthDataMigrationRoute
  '/employees': typeof AuthEmployeesRoute
  '/enterprise-accounting': typeof AuthEnterpriseAccountingRoute
  '/equipment': typeof AuthEquipmentRouteWithChildren
  '/expenses': typeof AuthExpensesRoute
  '/fx-rates': typeof AuthFxRatesRoute
  '/gl': typeof AuthGlRoute
  '/help': typeof AuthHelpRoute
  '/hospitality': typeof AuthHospitalityRouteWithChildren
  '/imports': typeof AuthImportsRoute
  '/income-statement': typeof AuthIncomeStatementRoute
  '/intercompany': typeof AuthIntercompanyRouteWithChildren
  '/job-cost': typeof AuthJobCostRoute
  '/journals': typeof AuthJournalsRouteWithChildren
  '/lien-waivers': typeof AuthLienWaiversRoute
  '/onboarding': typeof AuthOnboardingRouteWithChildren
  '/payments': typeof AuthPaymentsRouteWithChildren
  '/payroll-l2': typeof AuthPayrollL2RouteWithChildren
  '/payroll-l3': typeof AuthPayrollL3RouteWithChildren
  '/periods': typeof AuthPeriodsRouteWithChildren
  '/progress-billings': typeof AuthProgressBillingsRouteWithChildren
  '/project-executive': typeof AuthProjectExecutiveRoute
  '/projects': typeof AuthProjectsRouteWithChildren
  '/rate-sheets': typeof AuthRateSheetsRouteWithChildren
  '/recognition': typeof AuthRecognitionRoute
  '/recurring-charges': typeof AuthRecurringChargesRoute
  '/recurring-journals': typeof AuthRecurringJournalsRoute
  '/saas': typeof AuthSaasRouteWithChildren
  '/settings': typeof AuthSettingsRouteWithChildren
  '/sub-pay-apps': typeof AuthSubPayAppsRouteWithChildren
  '/subcontracts': typeof AuthSubcontractsRoute
  '/time': typeof AuthTimeRoute
  '/tm-invoices': typeof AuthTmInvoicesRouteWithChildren
  '/tm-tickets': typeof AuthTmTicketsRouteWithChildren
  '/trial-balance': typeof AuthTrialBalanceRoute
  '/portal/$token': typeof PortalTokenRoute
  '/admin/usage': typeof AuthAdminUsageRoute
  '/ap/autopilot': typeof AuthApAutopilotRoute
  '/approvals/analytics': typeof AuthApprovalsAnalyticsRoute
  '/approvals/policies': typeof AuthApprovalsPoliciesRoute
  '/bank-accounts/$bankAccountId': typeof AuthBankAccountsBankAccountIdRoute
  '/bank-rec/$recId': typeof AuthBankRecRecIdRoute
  '/close/$periodId': typeof AuthClosePeriodIdRoute
  '/close/templates': typeof AuthCloseTemplatesRoute
  '/concrete-plant/load-to-cash': typeof AuthConcretePlantLoadToCashRoute
  '/concrete-plant/material-to-margin': typeof AuthConcretePlantMaterialToMarginRoute
  '/concrete-plant/operations': typeof AuthConcretePlantOperationsRoute
  '/contract-work-packages/$packageId': typeof AuthContractWorkPackagesPackageIdRoute
  '/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/direct-expense/new': typeof AuthDirectExpenseNewRoute
  '/equipment/$equipmentId': typeof AuthEquipmentEquipmentIdRoute
  '/equipment/cost-posting': typeof AuthEquipmentCostPostingRoute
  '/equipment/cost-postings': typeof AuthEquipmentCostPostingsRouteWithChildren
  '/equipment/rental-links': typeof AuthEquipmentRentalLinksRoute
  '/fpa/budget': typeof AuthFpaBudgetRoute
  '/hospitality/filings': typeof AuthHospitalityFilingsRoute
  '/hospitality/flash': typeof AuthHospitalityFlashRoute
  '/hospitality/fnb': typeof AuthHospitalityFnbRouteWithChildren
  '/hospitality/fpa': typeof AuthHospitalityFpaRoute
  '/hospitality/gaming': typeof AuthHospitalityGamingRouteWithChildren
  '/hospitality/gaming-tax': typeof AuthHospitalityGamingTaxRoute
  '/hospitality/lodging': typeof AuthHospitalityLodgingRouteWithChildren
  '/hospitality/night-audit': typeof AuthHospitalityNightAuditRoute
  '/hospitality/revenue-centers': typeof AuthHospitalityRevenueCentersRoute
  '/hospitality/title-31': typeof AuthHospitalityTitle31Route
  '/intercompany/transactions': typeof AuthIntercompanyTransactionsRoute
  '/journals/$journalId': typeof AuthJournalsJournalIdRoute
  '/journals/new': typeof AuthJournalsNewRoute
  '/lien-waivers/templates': typeof AuthLienWaiversTemplatesRoute
  '/onboarding/complete': typeof AuthOnboardingCompleteRoute
  '/onboarding/setup': typeof AuthOnboardingSetupRoute
  '/payments/$paymentId': typeof AuthPaymentsPaymentIdRoute
  '/payments/check-run': typeof AuthPaymentsCheckRunRoute
  '/payroll-l2/allowances': typeof AuthPayrollL2AllowancesRoute
  '/payroll-l2/anomalies': typeof AuthPayrollL2AnomaliesRoute
  '/payroll-l2/burden': typeof AuthPayrollL2BurdenRoute
  '/payroll-l2/crafts': typeof AuthPayrollL2CraftsRoute
  '/payroll-l2/differentials': typeof AuthPayrollL2DifferentialsRoute
  '/payroll-l2/equipment': typeof AuthPayrollL2EquipmentRoute
  '/payroll-l2/expenses': typeof AuthPayrollL2ExpensesRoute
  '/payroll-l2/flagged': typeof AuthPayrollL2FlaggedRoute
  '/payroll-l2/forms': typeof AuthPayrollL2FormsRoute
  '/payroll-l2/ot-rules': typeof AuthPayrollL2OtRulesRoute
  '/payroll-l2/retro-pay': typeof AuthPayrollL2RetroPayRoute
  '/payroll-l2/timesheet-feed': typeof AuthPayrollL2TimesheetFeedRoute
  '/payroll-l2/workers-comp': typeof AuthPayrollL2WorkersCompRoute
  '/payroll-l3/apprentice-compliance': typeof AuthPayrollL3ApprenticeComplianceRoute
  '/payroll-l3/cbas': typeof AuthPayrollL3CbasRoute
  '/payroll-l3/classification-queue': typeof AuthPayrollL3ClassificationQueueRoute
  '/payroll-l3/compliance-alerts': typeof AuthPayrollL3ComplianceAlertsRoute
  '/payroll-l3/contracts': typeof AuthPayrollL3ContractsRoute
  '/payroll-l3/fringe-funds': typeof AuthPayrollL3FringeFundsRoute
  '/payroll-l3/gl-setup': typeof AuthPayrollL3GlSetupRoute
  '/payroll-l3/memberships': typeof AuthPayrollL3MembershipsRoute
  '/payroll-l3/remittance': typeof AuthPayrollL3RemittanceRoute
  '/payroll-l3/working-rules': typeof AuthPayrollL3WorkingRulesRoute
  '/payroll-l4/apprentice-programs': typeof AuthPayrollL4ApprenticeProgramsRoute
  '/payroll-l4/certified-payroll-reports': typeof AuthPayrollL4CertifiedPayrollReportsRoute
  '/payroll-l4/compliance': typeof AuthPayrollL4ComplianceRoute
  '/payroll-l4/submissions': typeof AuthPayrollL4SubmissionsRoute
  '/payroll-l4/wage-determinations': typeof AuthPayrollL4WageDeterminationsRoute
  '/payroll/contractors': typeof AuthPayrollContractorsRoute
  '/payroll/deduction-codes': typeof AuthPayrollDeductionCodesRoute
  '/payroll/earning-codes': typeof AuthPayrollEarningCodesRoute
  '/payroll/employees': typeof AuthPayrollEmployeesRoute
  '/payroll/iris-submissions': typeof AuthPayrollIrisSubmissionsRoute
  '/payroll/pay-runs': typeof AuthPayrollPayRunsRoute
  '/payroll/setup': typeof AuthPayrollSetupRoute
  '/payroll/tax-deposits': typeof AuthPayrollTaxDepositsRoute
  '/payroll/year-end': typeof AuthPayrollYearEndRoute
  '/progress-billings/$pbId': typeof AuthProgressBillingsPbIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/purchase-orders/$poId': typeof AuthPurchaseOrdersPoIdRoute
  '/purchase-orders/new': typeof AuthPurchaseOrdersNewRoute
  '/rate-sheets/$rateSheetId': typeof AuthRateSheetsRateSheetIdRoute
  '/rate-sheets/new': typeof AuthRateSheetsNewRoute
  '/reports/$reportId': typeof AuthReportsReportIdRoute
  '/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/reports/asset-rollforward': typeof AuthReportsAssetRollforwardRoute
  '/reports/book-tax-difference': typeof AuthReportsBookTaxDifferenceRoute
  '/reports/build': typeof AuthReportsBuildRoute
  '/reports/charts': typeof AuthReportsChartsRoute
  '/reports/committed-cost': typeof AuthReportsCommittedCostRoute
  '/reports/consolidated': typeof AuthReportsConsolidatedRoute
  '/reports/cost-code-rollup': typeof AuthReportsCostCodeRollupRoute
  '/reports/sub-draw-history': typeof AuthReportsSubDrawHistoryRoute
  '/reports/sub-pay-app-aging': typeof AuthReportsSubPayAppAgingRoute
  '/reports/sub-retention': typeof AuthReportsSubRetentionRoute
  '/reports/tax-depreciation': typeof AuthReportsTaxDepreciationRoute
  '/reports/wip': typeof AuthReportsWipRoute
  '/saas/cohorts': typeof AuthSaasCohortsRoute
  '/saas/crm': typeof AuthSaasCrmRoute
  '/saas/metrics': typeof AuthSaasMetricsRoute
  '/saas/payroll-sync': typeof AuthSaasPayrollSyncRoute
  '/saas/variable-consideration': typeof AuthSaasVariableConsiderationRoute
  '/saas/vendor-watch': typeof AuthSaasVendorWatchRoute
  '/settings/about': typeof AuthSettingsAboutRoute
  '/settings/api-costs': typeof AuthSettingsApiCostsRoute
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/backups': typeof AuthSettingsBackupsRoute
  '/settings/bank-connections': typeof AuthSettingsBankConnectionsRoute
  '/settings/crm': typeof AuthSettingsCrmRoute
  '/settings/currency': typeof AuthSettingsCurrencyRoute
  '/settings/dimensions': typeof AuthSettingsDimensionsRoute
  '/settings/entities': typeof AuthSettingsEntitiesRoute
  '/settings/imports-quickbooks': typeof AuthSettingsImportsQuickbooksRoute
  '/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/settings/mcp': typeof AuthSettingsMcpRoute
  '/settings/numbering': typeof AuthSettingsNumberingRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/shopify': typeof AuthSettingsShopifyRoute
  '/settings/tax': typeof AuthSettingsTaxRoute
  '/settings/team': typeof AuthSettingsTeamRoute
  '/sub-pay-apps/$payAppId': typeof AuthSubPayAppsPayAppIdRoute
  '/tm-invoices/$invoiceId': typeof AuthTmInvoicesInvoiceIdRoute
  '/tm-invoices/new': typeof AuthTmInvoicesNewRoute
  '/tm-tickets/$ticketId': typeof AuthTmTicketsTicketIdRoute
  '/tm-tickets/new': typeof AuthTmTicketsNewRoute
  '/vendors/$vendorId': typeof AuthVendorsVendorIdRouteWithChildren
  '/vendors/merge-tool': typeof AuthVendorsMergeToolRoute
  '/approvals/': typeof AuthApprovalsIndexRoute
  '/bank-accounts/': typeof AuthBankAccountsIndexRoute
  '/bank-rec/': typeof AuthBankRecIndexRoute
  '/close/': typeof AuthCloseIndexRoute
  '/concrete-plant/': typeof AuthConcretePlantIndexRoute
  '/contract-work-packages/': typeof AuthContractWorkPackagesIndexRoute
  '/contracts/': typeof AuthContractsIndexRoute
  '/customers/': typeof AuthCustomersIndexRoute
  '/equipment/': typeof AuthEquipmentIndexRoute
  '/hospitality/': typeof AuthHospitalityIndexRoute
  '/intercompany/': typeof AuthIntercompanyIndexRoute
  '/invoices/': typeof AuthInvoicesIndexRoute
  '/journals/': typeof AuthJournalsIndexRoute
  '/onboarding/': typeof AuthOnboardingIndexRoute
  '/payments/': typeof AuthPaymentsIndexRoute
  '/payroll-l3/': typeof AuthPayrollL3IndexRoute
  '/periods/': typeof AuthPeriodsIndexRoute
  '/progress-billings/': typeof AuthProgressBillingsIndexRoute
  '/projects/': typeof AuthProjectsIndexRoute
  '/purchase-orders/': typeof AuthPurchaseOrdersIndexRoute
  '/rate-sheets/': typeof AuthRateSheetsIndexRoute
  '/reports/': typeof AuthReportsIndexRoute
  '/saas/': typeof AuthSaasIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/tm-invoices/': typeof AuthTmInvoicesIndexRoute
  '/tm-tickets/': typeof AuthTmTicketsIndexRoute
  '/vendors/': typeof AuthVendorsIndexRoute
  '/equipment/cost-postings/$postingId': typeof AuthEquipmentCostPostingsPostingIdRoute
  '/equipment/reports/cost-by-job': typeof AuthEquipmentReportsCostByJobRoute
  '/equipment/reports/variance': typeof AuthEquipmentReportsVarianceRoute
  '/help/docs/$': typeof AuthHelpDocsSplatRoute
  '/hospitality/fnb/performance': typeof AuthHospitalityFnbPerformanceRoute
  '/hospitality/fnb/tronc': typeof AuthHospitalityFnbTroncRoute
  '/hospitality/gaming/floor': typeof AuthHospitalityGamingFloorRoute
  '/hospitality/gaming/markers': typeof AuthHospitalityGamingMarkersRoute
  '/hospitality/lodging/folio-ar': typeof AuthHospitalityLodgingFolioArRoute
  '/invoices/ap/$invoiceId': typeof AuthInvoicesApInvoiceIdRoute
  '/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/invoices/ar/$invoiceId': typeof AuthInvoicesArInvoiceIdRoute
  '/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/payroll-l2/compliance-gate/$payRunId': typeof AuthPayrollL2ComplianceGatePayRunIdRoute
  '/payroll-l2/earned-value/$projectId': typeof AuthPayrollL2EarnedValueProjectIdRoute
  '/payroll-l2/expenses/new': typeof AuthPayrollL2ExpensesNewRoute
  '/payroll-l2/labor-event/$eventId': typeof AuthPayrollL2LaborEventEventIdRoute
  '/payroll-l4/certified-payroll-reports/$reportId': typeof AuthPayrollL4CertifiedPayrollReportsReportIdRoute
  '/payroll-l4/wage-determinations/$wdId': typeof AuthPayrollL4WageDeterminationsWdIdRoute
  '/payroll/contractors/$contractorId': typeof AuthPayrollContractorsContractorIdRoute
  '/payroll/employees/$employeeId': typeof AuthPayrollEmployeesEmployeeIdRouteWithChildren
  '/payroll/pay-runs/$payRunId': typeof AuthPayrollPayRunsPayRunIdRoute
  '/periods/$periodId/checklist': typeof AuthPeriodsPeriodIdChecklistRoute
  '/projects/$projectId/gmp': typeof AuthProjectsProjectIdGmpRoute
  '/saas/plans/$planId': typeof AuthSaasPlansPlanIdRoute
  '/saas/subscriptions/$subId': typeof AuthSaasSubscriptionsSubIdRoute
  '/settings/permissions/me': typeof AuthSettingsPermissionsMeRoute
  '/vendors/$vendorId/activity': typeof AuthVendorsVendorIdActivityRoute
  '/vendors/$vendorId/addresses': typeof AuthVendorsVendorIdAddressesRoute
  '/vendors/$vendorId/autopilot': typeof AuthVendorsVendorIdAutopilotRoute
  '/vendors/$vendorId/lien-waivers': typeof AuthVendorsVendorIdLienWaiversRoute
  '/vendors/$vendorId/payments': typeof AuthVendorsVendorIdPaymentsRoute
  '/vendors/$vendorId/pos': typeof AuthVendorsVendorIdPosRoute
  '/vendors/$vendorId/qualification': typeof AuthVendorsVendorIdQualificationRoute
  '/vendors/$vendorId/subcontracts': typeof AuthVendorsVendorIdSubcontractsRoute
  '/equipment/cost-postings/': typeof AuthEquipmentCostPostingsIndexRoute
  '/hospitality/lodging/': typeof AuthHospitalityLodgingIndexRoute
  '/vendors/$vendorId/': typeof AuthVendorsVendorIdIndexRoute
  '/payroll-l2/employees/$employeeId/rates': typeof AuthPayrollL2EmployeesEmployeeIdRatesRoute
  '/payroll/employees/$employeeId/w4': typeof AuthPayrollEmployeesEmployeeIdW4Route
  '/payroll/year-end/1099-misc/$year': typeof AuthPayrollYearEnd1099MiscYearRoute
  '/payroll/year-end/1099-nec/$year': typeof AuthPayrollYearEnd1099NecYearRoute
  '/payroll/year-end/940/$year': typeof AuthPayrollYearEnd940YearRoute
  '/payroll/year-end/w2/$year': typeof AuthPayrollYearEndW2YearRoute
  '/payroll/year-end/w3/$year': typeof AuthPayrollYearEndW3YearRoute
  '/payroll/employees/$employeeId/': typeof AuthPayrollEmployeesEmployeeIdIndexRoute
  '/payroll/year-end/941/$year/$quarter': typeof AuthPayrollYearEnd941YearQuarterRoute
}
export interface FileRoutesByTo {
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof CallbackRoute
  '/handoff': typeof HandoffRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/review-budget': typeof ReviewBudgetRoute
  '/accounts': typeof AuthAccountsRoute
  '/agents': typeof AuthAgentsRoute
  '/ap': typeof AuthApRouteWithChildren
  '/api-spend': typeof AuthApiSpendRoute
  '/ar': typeof AuthArRoute
  '/assets': typeof AuthAssetsRoute
  '/audit-log': typeof AuthAuditLogRoute
  '/balance-sheet': typeof AuthBalanceSheetRoute
  '/bills-intake': typeof AuthBillsIntakeRoute
  '/cap-table': typeof AuthCapTableRoute
  '/cash-flow': typeof AuthCashFlowRoute
  '/cfo-advisor': typeof AuthCfoAdvisorRoute
  '/change-orders': typeof AuthChangeOrdersRoute
  '/chat': typeof AuthChatRoute
  '/chat-history': typeof AuthChatHistoryRoute
  '/compliance': typeof AuthComplianceRoute
  '/contacts': typeof AuthContactsRoute
  '/contract-to-cash': typeof AuthContractToCashRoute
  '/cost-code-templates': typeof AuthCostCodeTemplatesRoute
  '/cost-codes': typeof AuthCostCodesRoute
  '/data-migration': typeof AuthDataMigrationRoute
  '/employees': typeof AuthEmployeesRoute
  '/enterprise-accounting': typeof AuthEnterpriseAccountingRoute
  '/expenses': typeof AuthExpensesRoute
  '/fx-rates': typeof AuthFxRatesRoute
  '/gl': typeof AuthGlRoute
  '/help': typeof AuthHelpRoute
  '/imports': typeof AuthImportsRoute
  '/income-statement': typeof AuthIncomeStatementRoute
  '/job-cost': typeof AuthJobCostRoute
  '/lien-waivers': typeof AuthLienWaiversRoute
  '/payroll-l2': typeof AuthPayrollL2RouteWithChildren
  '/project-executive': typeof AuthProjectExecutiveRoute
  '/recognition': typeof AuthRecognitionRoute
  '/recurring-charges': typeof AuthRecurringChargesRoute
  '/recurring-journals': typeof AuthRecurringJournalsRoute
  '/sub-pay-apps': typeof AuthSubPayAppsRouteWithChildren
  '/subcontracts': typeof AuthSubcontractsRoute
  '/time': typeof AuthTimeRoute
  '/trial-balance': typeof AuthTrialBalanceRoute
  '/portal/$token': typeof PortalTokenRoute
  '/': typeof AuthIndexRoute
  '/admin/usage': typeof AuthAdminUsageRoute
  '/ap/autopilot': typeof AuthApAutopilotRoute
  '/approvals/analytics': typeof AuthApprovalsAnalyticsRoute
  '/approvals/policies': typeof AuthApprovalsPoliciesRoute
  '/bank-accounts/$bankAccountId': typeof AuthBankAccountsBankAccountIdRoute
  '/bank-rec/$recId': typeof AuthBankRecRecIdRoute
  '/close/$periodId': typeof AuthClosePeriodIdRoute
  '/close/templates': typeof AuthCloseTemplatesRoute
  '/concrete-plant/load-to-cash': typeof AuthConcretePlantLoadToCashRoute
  '/concrete-plant/material-to-margin': typeof AuthConcretePlantMaterialToMarginRoute
  '/concrete-plant/operations': typeof AuthConcretePlantOperationsRoute
  '/contract-work-packages/$packageId': typeof AuthContractWorkPackagesPackageIdRoute
  '/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/direct-expense/new': typeof AuthDirectExpenseNewRoute
  '/equipment/$equipmentId': typeof AuthEquipmentEquipmentIdRoute
  '/equipment/cost-posting': typeof AuthEquipmentCostPostingRoute
  '/equipment/rental-links': typeof AuthEquipmentRentalLinksRoute
  '/fpa/budget': typeof AuthFpaBudgetRoute
  '/hospitality/filings': typeof AuthHospitalityFilingsRoute
  '/hospitality/flash': typeof AuthHospitalityFlashRoute
  '/hospitality/fnb': typeof AuthHospitalityFnbRouteWithChildren
  '/hospitality/fpa': typeof AuthHospitalityFpaRoute
  '/hospitality/gaming': typeof AuthHospitalityGamingRouteWithChildren
  '/hospitality/gaming-tax': typeof AuthHospitalityGamingTaxRoute
  '/hospitality/night-audit': typeof AuthHospitalityNightAuditRoute
  '/hospitality/revenue-centers': typeof AuthHospitalityRevenueCentersRoute
  '/hospitality/title-31': typeof AuthHospitalityTitle31Route
  '/intercompany/transactions': typeof AuthIntercompanyTransactionsRoute
  '/journals/$journalId': typeof AuthJournalsJournalIdRoute
  '/journals/new': typeof AuthJournalsNewRoute
  '/lien-waivers/templates': typeof AuthLienWaiversTemplatesRoute
  '/onboarding/complete': typeof AuthOnboardingCompleteRoute
  '/onboarding/setup': typeof AuthOnboardingSetupRoute
  '/payments/$paymentId': typeof AuthPaymentsPaymentIdRoute
  '/payments/check-run': typeof AuthPaymentsCheckRunRoute
  '/payroll-l2/allowances': typeof AuthPayrollL2AllowancesRoute
  '/payroll-l2/anomalies': typeof AuthPayrollL2AnomaliesRoute
  '/payroll-l2/burden': typeof AuthPayrollL2BurdenRoute
  '/payroll-l2/crafts': typeof AuthPayrollL2CraftsRoute
  '/payroll-l2/differentials': typeof AuthPayrollL2DifferentialsRoute
  '/payroll-l2/equipment': typeof AuthPayrollL2EquipmentRoute
  '/payroll-l2/expenses': typeof AuthPayrollL2ExpensesRoute
  '/payroll-l2/flagged': typeof AuthPayrollL2FlaggedRoute
  '/payroll-l2/forms': typeof AuthPayrollL2FormsRoute
  '/payroll-l2/ot-rules': typeof AuthPayrollL2OtRulesRoute
  '/payroll-l2/retro-pay': typeof AuthPayrollL2RetroPayRoute
  '/payroll-l2/timesheet-feed': typeof AuthPayrollL2TimesheetFeedRoute
  '/payroll-l2/workers-comp': typeof AuthPayrollL2WorkersCompRoute
  '/payroll-l3/apprentice-compliance': typeof AuthPayrollL3ApprenticeComplianceRoute
  '/payroll-l3/cbas': typeof AuthPayrollL3CbasRoute
  '/payroll-l3/classification-queue': typeof AuthPayrollL3ClassificationQueueRoute
  '/payroll-l3/compliance-alerts': typeof AuthPayrollL3ComplianceAlertsRoute
  '/payroll-l3/contracts': typeof AuthPayrollL3ContractsRoute
  '/payroll-l3/fringe-funds': typeof AuthPayrollL3FringeFundsRoute
  '/payroll-l3/gl-setup': typeof AuthPayrollL3GlSetupRoute
  '/payroll-l3/memberships': typeof AuthPayrollL3MembershipsRoute
  '/payroll-l3/remittance': typeof AuthPayrollL3RemittanceRoute
  '/payroll-l3/working-rules': typeof AuthPayrollL3WorkingRulesRoute
  '/payroll-l4/apprentice-programs': typeof AuthPayrollL4ApprenticeProgramsRoute
  '/payroll-l4/certified-payroll-reports': typeof AuthPayrollL4CertifiedPayrollReportsRoute
  '/payroll-l4/compliance': typeof AuthPayrollL4ComplianceRoute
  '/payroll-l4/submissions': typeof AuthPayrollL4SubmissionsRoute
  '/payroll-l4/wage-determinations': typeof AuthPayrollL4WageDeterminationsRoute
  '/payroll/contractors': typeof AuthPayrollContractorsRoute
  '/payroll/deduction-codes': typeof AuthPayrollDeductionCodesRoute
  '/payroll/earning-codes': typeof AuthPayrollEarningCodesRoute
  '/payroll/employees': typeof AuthPayrollEmployeesRoute
  '/payroll/iris-submissions': typeof AuthPayrollIrisSubmissionsRoute
  '/payroll/pay-runs': typeof AuthPayrollPayRunsRoute
  '/payroll/setup': typeof AuthPayrollSetupRoute
  '/payroll/tax-deposits': typeof AuthPayrollTaxDepositsRoute
  '/payroll/year-end': typeof AuthPayrollYearEndRoute
  '/progress-billings/$pbId': typeof AuthProgressBillingsPbIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/purchase-orders/$poId': typeof AuthPurchaseOrdersPoIdRoute
  '/purchase-orders/new': typeof AuthPurchaseOrdersNewRoute
  '/rate-sheets/$rateSheetId': typeof AuthRateSheetsRateSheetIdRoute
  '/rate-sheets/new': typeof AuthRateSheetsNewRoute
  '/reports/$reportId': typeof AuthReportsReportIdRoute
  '/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/reports/asset-rollforward': typeof AuthReportsAssetRollforwardRoute
  '/reports/book-tax-difference': typeof AuthReportsBookTaxDifferenceRoute
  '/reports/build': typeof AuthReportsBuildRoute
  '/reports/charts': typeof AuthReportsChartsRoute
  '/reports/committed-cost': typeof AuthReportsCommittedCostRoute
  '/reports/consolidated': typeof AuthReportsConsolidatedRoute
  '/reports/cost-code-rollup': typeof AuthReportsCostCodeRollupRoute
  '/reports/sub-draw-history': typeof AuthReportsSubDrawHistoryRoute
  '/reports/sub-pay-app-aging': typeof AuthReportsSubPayAppAgingRoute
  '/reports/sub-retention': typeof AuthReportsSubRetentionRoute
  '/reports/tax-depreciation': typeof AuthReportsTaxDepreciationRoute
  '/reports/wip': typeof AuthReportsWipRoute
  '/saas/cohorts': typeof AuthSaasCohortsRoute
  '/saas/crm': typeof AuthSaasCrmRoute
  '/saas/metrics': typeof AuthSaasMetricsRoute
  '/saas/payroll-sync': typeof AuthSaasPayrollSyncRoute
  '/saas/variable-consideration': typeof AuthSaasVariableConsiderationRoute
  '/saas/vendor-watch': typeof AuthSaasVendorWatchRoute
  '/settings/about': typeof AuthSettingsAboutRoute
  '/settings/api-costs': typeof AuthSettingsApiCostsRoute
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/backups': typeof AuthSettingsBackupsRoute
  '/settings/bank-connections': typeof AuthSettingsBankConnectionsRoute
  '/settings/crm': typeof AuthSettingsCrmRoute
  '/settings/currency': typeof AuthSettingsCurrencyRoute
  '/settings/dimensions': typeof AuthSettingsDimensionsRoute
  '/settings/entities': typeof AuthSettingsEntitiesRoute
  '/settings/imports-quickbooks': typeof AuthSettingsImportsQuickbooksRoute
  '/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/settings/mcp': typeof AuthSettingsMcpRoute
  '/settings/numbering': typeof AuthSettingsNumberingRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/shopify': typeof AuthSettingsShopifyRoute
  '/settings/tax': typeof AuthSettingsTaxRoute
  '/settings/team': typeof AuthSettingsTeamRoute
  '/sub-pay-apps/$payAppId': typeof AuthSubPayAppsPayAppIdRoute
  '/tm-invoices/$invoiceId': typeof AuthTmInvoicesInvoiceIdRoute
  '/tm-invoices/new': typeof AuthTmInvoicesNewRoute
  '/tm-tickets/$ticketId': typeof AuthTmTicketsTicketIdRoute
  '/tm-tickets/new': typeof AuthTmTicketsNewRoute
  '/vendors/merge-tool': typeof AuthVendorsMergeToolRoute
  '/approvals': typeof AuthApprovalsIndexRoute
  '/bank-accounts': typeof AuthBankAccountsIndexRoute
  '/bank-rec': typeof AuthBankRecIndexRoute
  '/close': typeof AuthCloseIndexRoute
  '/concrete-plant': typeof AuthConcretePlantIndexRoute
  '/contract-work-packages': typeof AuthContractWorkPackagesIndexRoute
  '/contracts': typeof AuthContractsIndexRoute
  '/customers': typeof AuthCustomersIndexRoute
  '/equipment': typeof AuthEquipmentIndexRoute
  '/hospitality': typeof AuthHospitalityIndexRoute
  '/intercompany': typeof AuthIntercompanyIndexRoute
  '/invoices': typeof AuthInvoicesIndexRoute
  '/journals': typeof AuthJournalsIndexRoute
  '/onboarding': typeof AuthOnboardingIndexRoute
  '/payments': typeof AuthPaymentsIndexRoute
  '/payroll-l3': typeof AuthPayrollL3IndexRoute
  '/periods': typeof AuthPeriodsIndexRoute
  '/progress-billings': typeof AuthProgressBillingsIndexRoute
  '/projects': typeof AuthProjectsIndexRoute
  '/purchase-orders': typeof AuthPurchaseOrdersIndexRoute
  '/rate-sheets': typeof AuthRateSheetsIndexRoute
  '/reports': typeof AuthReportsIndexRoute
  '/saas': typeof AuthSaasIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/tm-invoices': typeof AuthTmInvoicesIndexRoute
  '/tm-tickets': typeof AuthTmTicketsIndexRoute
  '/vendors': typeof AuthVendorsIndexRoute
  '/equipment/cost-postings/$postingId': typeof AuthEquipmentCostPostingsPostingIdRoute
  '/equipment/reports/cost-by-job': typeof AuthEquipmentReportsCostByJobRoute
  '/equipment/reports/variance': typeof AuthEquipmentReportsVarianceRoute
  '/help/docs/$': typeof AuthHelpDocsSplatRoute
  '/hospitality/fnb/performance': typeof AuthHospitalityFnbPerformanceRoute
  '/hospitality/fnb/tronc': typeof AuthHospitalityFnbTroncRoute
  '/hospitality/gaming/floor': typeof AuthHospitalityGamingFloorRoute
  '/hospitality/gaming/markers': typeof AuthHospitalityGamingMarkersRoute
  '/hospitality/lodging/folio-ar': typeof AuthHospitalityLodgingFolioArRoute
  '/invoices/ap/$invoiceId': typeof AuthInvoicesApInvoiceIdRoute
  '/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/invoices/ar/$invoiceId': typeof AuthInvoicesArInvoiceIdRoute
  '/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/payroll-l2/compliance-gate/$payRunId': typeof AuthPayrollL2ComplianceGatePayRunIdRoute
  '/payroll-l2/earned-value/$projectId': typeof AuthPayrollL2EarnedValueProjectIdRoute
  '/payroll-l2/expenses/new': typeof AuthPayrollL2ExpensesNewRoute
  '/payroll-l2/labor-event/$eventId': typeof AuthPayrollL2LaborEventEventIdRoute
  '/payroll-l4/certified-payroll-reports/$reportId': typeof AuthPayrollL4CertifiedPayrollReportsReportIdRoute
  '/payroll-l4/wage-determinations/$wdId': typeof AuthPayrollL4WageDeterminationsWdIdRoute
  '/payroll/contractors/$contractorId': typeof AuthPayrollContractorsContractorIdRoute
  '/payroll/pay-runs/$payRunId': typeof AuthPayrollPayRunsPayRunIdRoute
  '/periods/$periodId/checklist': typeof AuthPeriodsPeriodIdChecklistRoute
  '/projects/$projectId/gmp': typeof AuthProjectsProjectIdGmpRoute
  '/saas/plans/$planId': typeof AuthSaasPlansPlanIdRoute
  '/saas/subscriptions/$subId': typeof AuthSaasSubscriptionsSubIdRoute
  '/settings/permissions/me': typeof AuthSettingsPermissionsMeRoute
  '/vendors/$vendorId/activity': typeof AuthVendorsVendorIdActivityRoute
  '/vendors/$vendorId/addresses': typeof AuthVendorsVendorIdAddressesRoute
  '/vendors/$vendorId/autopilot': typeof AuthVendorsVendorIdAutopilotRoute
  '/vendors/$vendorId/lien-waivers': typeof AuthVendorsVendorIdLienWaiversRoute
  '/vendors/$vendorId/payments': typeof AuthVendorsVendorIdPaymentsRoute
  '/vendors/$vendorId/pos': typeof AuthVendorsVendorIdPosRoute
  '/vendors/$vendorId/qualification': typeof AuthVendorsVendorIdQualificationRoute
  '/vendors/$vendorId/subcontracts': typeof AuthVendorsVendorIdSubcontractsRoute
  '/equipment/cost-postings': typeof AuthEquipmentCostPostingsIndexRoute
  '/hospitality/lodging': typeof AuthHospitalityLodgingIndexRoute
  '/vendors/$vendorId': typeof AuthVendorsVendorIdIndexRoute
  '/payroll-l2/employees/$employeeId/rates': typeof AuthPayrollL2EmployeesEmployeeIdRatesRoute
  '/payroll/employees/$employeeId/w4': typeof AuthPayrollEmployeesEmployeeIdW4Route
  '/payroll/year-end/1099-misc/$year': typeof AuthPayrollYearEnd1099MiscYearRoute
  '/payroll/year-end/1099-nec/$year': typeof AuthPayrollYearEnd1099NecYearRoute
  '/payroll/year-end/940/$year': typeof AuthPayrollYearEnd940YearRoute
  '/payroll/year-end/w2/$year': typeof AuthPayrollYearEndW2YearRoute
  '/payroll/year-end/w3/$year': typeof AuthPayrollYearEndW3YearRoute
  '/payroll/employees/$employeeId': typeof AuthPayrollEmployeesEmployeeIdIndexRoute
  '/payroll/year-end/941/$year/$quarter': typeof AuthPayrollYearEnd941YearQuarterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof CallbackRoute
  '/handoff': typeof HandoffRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/review-budget': typeof ReviewBudgetRoute
  '/_auth/accounts': typeof AuthAccountsRoute
  '/_auth/agents': typeof AuthAgentsRoute
  '/_auth/ap': typeof AuthApRouteWithChildren
  '/_auth/api-spend': typeof AuthApiSpendRoute
  '/_auth/approvals': typeof AuthApprovalsRouteWithChildren
  '/_auth/ar': typeof AuthArRoute
  '/_auth/assets': typeof AuthAssetsRoute
  '/_auth/audit-log': typeof AuthAuditLogRoute
  '/_auth/balance-sheet': typeof AuthBalanceSheetRoute
  '/_auth/bank-accounts': typeof AuthBankAccountsRouteWithChildren
  '/_auth/bills-intake': typeof AuthBillsIntakeRoute
  '/_auth/cap-table': typeof AuthCapTableRoute
  '/_auth/cash-flow': typeof AuthCashFlowRoute
  '/_auth/cfo-advisor': typeof AuthCfoAdvisorRoute
  '/_auth/change-orders': typeof AuthChangeOrdersRoute
  '/_auth/chat': typeof AuthChatRoute
  '/_auth/chat-history': typeof AuthChatHistoryRoute
  '/_auth/close': typeof AuthCloseRouteWithChildren
  '/_auth/compliance': typeof AuthComplianceRoute
  '/_auth/contacts': typeof AuthContactsRoute
  '/_auth/contract-to-cash': typeof AuthContractToCashRoute
  '/_auth/cost-code-templates': typeof AuthCostCodeTemplatesRoute
  '/_auth/cost-codes': typeof AuthCostCodesRoute
  '/_auth/data-migration': typeof AuthDataMigrationRoute
  '/_auth/employees': typeof AuthEmployeesRoute
  '/_auth/enterprise-accounting': typeof AuthEnterpriseAccountingRoute
  '/_auth/equipment': typeof AuthEquipmentRouteWithChildren
  '/_auth/expenses': typeof AuthExpensesRoute
  '/_auth/fx-rates': typeof AuthFxRatesRoute
  '/_auth/gl': typeof AuthGlRoute
  '/_auth/help': typeof AuthHelpRoute
  '/_auth/hospitality': typeof AuthHospitalityRouteWithChildren
  '/_auth/imports': typeof AuthImportsRoute
  '/_auth/income-statement': typeof AuthIncomeStatementRoute
  '/_auth/intercompany': typeof AuthIntercompanyRouteWithChildren
  '/_auth/job-cost': typeof AuthJobCostRoute
  '/_auth/journals': typeof AuthJournalsRouteWithChildren
  '/_auth/lien-waivers': typeof AuthLienWaiversRoute
  '/_auth/onboarding': typeof AuthOnboardingRouteWithChildren
  '/_auth/payments': typeof AuthPaymentsRouteWithChildren
  '/_auth/payroll-l2': typeof AuthPayrollL2RouteWithChildren
  '/_auth/payroll-l3': typeof AuthPayrollL3RouteWithChildren
  '/_auth/periods': typeof AuthPeriodsRouteWithChildren
  '/_auth/progress-billings': typeof AuthProgressBillingsRouteWithChildren
  '/_auth/project-executive': typeof AuthProjectExecutiveRoute
  '/_auth/projects': typeof AuthProjectsRouteWithChildren
  '/_auth/rate-sheets': typeof AuthRateSheetsRouteWithChildren
  '/_auth/recognition': typeof AuthRecognitionRoute
  '/_auth/recurring-charges': typeof AuthRecurringChargesRoute
  '/_auth/recurring-journals': typeof AuthRecurringJournalsRoute
  '/_auth/saas': typeof AuthSaasRouteWithChildren
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/_auth/sub-pay-apps': typeof AuthSubPayAppsRouteWithChildren
  '/_auth/subcontracts': typeof AuthSubcontractsRoute
  '/_auth/time': typeof AuthTimeRoute
  '/_auth/tm-invoices': typeof AuthTmInvoicesRouteWithChildren
  '/_auth/tm-tickets': typeof AuthTmTicketsRouteWithChildren
  '/_auth/trial-balance': typeof AuthTrialBalanceRoute
  '/portal/$token': typeof PortalTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/usage': typeof AuthAdminUsageRoute
  '/_auth/ap/autopilot': typeof AuthApAutopilotRoute
  '/_auth/approvals/analytics': typeof AuthApprovalsAnalyticsRoute
  '/_auth/approvals/policies': typeof AuthApprovalsPoliciesRoute
  '/_auth/bank-accounts/$bankAccountId': typeof AuthBankAccountsBankAccountIdRoute
  '/_auth/bank-rec/$recId': typeof AuthBankRecRecIdRoute
  '/_auth/close/$periodId': typeof AuthClosePeriodIdRoute
  '/_auth/close/templates': typeof AuthCloseTemplatesRoute
  '/_auth/concrete-plant/load-to-cash': typeof AuthConcretePlantLoadToCashRoute
  '/_auth/concrete-plant/material-to-margin': typeof AuthConcretePlantMaterialToMarginRoute
  '/_auth/concrete-plant/operations': typeof AuthConcretePlantOperationsRoute
  '/_auth/contract-work-packages/$packageId': typeof AuthContractWorkPackagesPackageIdRoute
  '/_auth/contracts/$contractId': typeof AuthContractsContractIdRoute
  '/_auth/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/_auth/direct-expense/new': typeof AuthDirectExpenseNewRoute
  '/_auth/equipment/$equipmentId': typeof AuthEquipmentEquipmentIdRoute
  '/_auth/equipment/cost-posting': typeof AuthEquipmentCostPostingRoute
  '/_auth/equipment/cost-postings': typeof AuthEquipmentCostPostingsRouteWithChildren
  '/_auth/equipment/rental-links': typeof AuthEquipmentRentalLinksRoute
  '/_auth/fpa/budget': typeof AuthFpaBudgetRoute
  '/_auth/hospitality/filings': typeof AuthHospitalityFilingsRoute
  '/_auth/hospitality/flash': typeof AuthHospitalityFlashRoute
  '/_auth/hospitality/fnb': typeof AuthHospitalityFnbRouteWithChildren
  '/_auth/hospitality/fpa': typeof AuthHospitalityFpaRoute
  '/_auth/hospitality/gaming': typeof AuthHospitalityGamingRouteWithChildren
  '/_auth/hospitality/gaming-tax': typeof AuthHospitalityGamingTaxRoute
  '/_auth/hospitality/lodging': typeof AuthHospitalityLodgingRouteWithChildren
  '/_auth/hospitality/night-audit': typeof AuthHospitalityNightAuditRoute
  '/_auth/hospitality/revenue-centers': typeof AuthHospitalityRevenueCentersRoute
  '/_auth/hospitality/title-31': typeof AuthHospitalityTitle31Route
  '/_auth/intercompany/transactions': typeof AuthIntercompanyTransactionsRoute
  '/_auth/journals/$journalId': typeof AuthJournalsJournalIdRoute
  '/_auth/journals/new': typeof AuthJournalsNewRoute
  '/_auth/lien-waivers_/templates': typeof AuthLienWaiversTemplatesRoute
  '/_auth/onboarding/complete': typeof AuthOnboardingCompleteRoute
  '/_auth/onboarding/setup': typeof AuthOnboardingSetupRoute
  '/_auth/payments/$paymentId': typeof AuthPaymentsPaymentIdRoute
  '/_auth/payments/check-run': typeof AuthPaymentsCheckRunRoute
  '/_auth/payroll-l2/allowances': typeof AuthPayrollL2AllowancesRoute
  '/_auth/payroll-l2/anomalies': typeof AuthPayrollL2AnomaliesRoute
  '/_auth/payroll-l2/burden': typeof AuthPayrollL2BurdenRoute
  '/_auth/payroll-l2/crafts': typeof AuthPayrollL2CraftsRoute
  '/_auth/payroll-l2/differentials': typeof AuthPayrollL2DifferentialsRoute
  '/_auth/payroll-l2/equipment': typeof AuthPayrollL2EquipmentRoute
  '/_auth/payroll-l2/expenses': typeof AuthPayrollL2ExpensesRoute
  '/_auth/payroll-l2/flagged': typeof AuthPayrollL2FlaggedRoute
  '/_auth/payroll-l2/forms': typeof AuthPayrollL2FormsRoute
  '/_auth/payroll-l2/ot-rules': typeof AuthPayrollL2OtRulesRoute
  '/_auth/payroll-l2/retro-pay': typeof AuthPayrollL2RetroPayRoute
  '/_auth/payroll-l2/timesheet-feed': typeof AuthPayrollL2TimesheetFeedRoute
  '/_auth/payroll-l2/workers-comp': typeof AuthPayrollL2WorkersCompRoute
  '/_auth/payroll-l3/apprentice-compliance': typeof AuthPayrollL3ApprenticeComplianceRoute
  '/_auth/payroll-l3/cbas': typeof AuthPayrollL3CbasRoute
  '/_auth/payroll-l3/classification-queue': typeof AuthPayrollL3ClassificationQueueRoute
  '/_auth/payroll-l3/compliance-alerts': typeof AuthPayrollL3ComplianceAlertsRoute
  '/_auth/payroll-l3/contracts': typeof AuthPayrollL3ContractsRoute
  '/_auth/payroll-l3/fringe-funds': typeof AuthPayrollL3FringeFundsRoute
  '/_auth/payroll-l3/gl-setup': typeof AuthPayrollL3GlSetupRoute
  '/_auth/payroll-l3/memberships': typeof AuthPayrollL3MembershipsRoute
  '/_auth/payroll-l3/remittance': typeof AuthPayrollL3RemittanceRoute
  '/_auth/payroll-l3/working-rules': typeof AuthPayrollL3WorkingRulesRoute
  '/_auth/payroll-l4/apprentice-programs': typeof AuthPayrollL4ApprenticeProgramsRoute
  '/_auth/payroll-l4/certified-payroll-reports': typeof AuthPayrollL4CertifiedPayrollReportsRoute
  '/_auth/payroll-l4/compliance': typeof AuthPayrollL4ComplianceRoute
  '/_auth/payroll-l4/submissions': typeof AuthPayrollL4SubmissionsRoute
  '/_auth/payroll-l4/wage-determinations': typeof AuthPayrollL4WageDeterminationsRoute
  '/_auth/payroll/contractors': typeof AuthPayrollContractorsRoute
  '/_auth/payroll/deduction-codes': typeof AuthPayrollDeductionCodesRoute
  '/_auth/payroll/earning-codes': typeof AuthPayrollEarningCodesRoute
  '/_auth/payroll/employees': typeof AuthPayrollEmployeesRoute
  '/_auth/payroll/iris-submissions': typeof AuthPayrollIrisSubmissionsRoute
  '/_auth/payroll/pay-runs': typeof AuthPayrollPayRunsRoute
  '/_auth/payroll/setup': typeof AuthPayrollSetupRoute
  '/_auth/payroll/tax-deposits': typeof AuthPayrollTaxDepositsRoute
  '/_auth/payroll/year-end': typeof AuthPayrollYearEndRoute
  '/_auth/progress-billings/$pbId': typeof AuthProgressBillingsPbIdRoute
  '/_auth/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/_auth/purchase-orders/$poId': typeof AuthPurchaseOrdersPoIdRoute
  '/_auth/purchase-orders/new': typeof AuthPurchaseOrdersNewRoute
  '/_auth/rate-sheets/$rateSheetId': typeof AuthRateSheetsRateSheetIdRoute
  '/_auth/rate-sheets/new': typeof AuthRateSheetsNewRoute
  '/_auth/reports/$reportId': typeof AuthReportsReportIdRoute
  '/_auth/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/_auth/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/_auth/reports/asset-rollforward': typeof AuthReportsAssetRollforwardRoute
  '/_auth/reports/book-tax-difference': typeof AuthReportsBookTaxDifferenceRoute
  '/_auth/reports/build': typeof AuthReportsBuildRoute
  '/_auth/reports/charts': typeof AuthReportsChartsRoute
  '/_auth/reports/committed-cost': typeof AuthReportsCommittedCostRoute
  '/_auth/reports/consolidated': typeof AuthReportsConsolidatedRoute
  '/_auth/reports/cost-code-rollup': typeof AuthReportsCostCodeRollupRoute
  '/_auth/reports/sub-draw-history': typeof AuthReportsSubDrawHistoryRoute
  '/_auth/reports/sub-pay-app-aging': typeof AuthReportsSubPayAppAgingRoute
  '/_auth/reports/sub-retention': typeof AuthReportsSubRetentionRoute
  '/_auth/reports/tax-depreciation': typeof AuthReportsTaxDepreciationRoute
  '/_auth/reports/wip': typeof AuthReportsWipRoute
  '/_auth/saas/cohorts': typeof AuthSaasCohortsRoute
  '/_auth/saas/crm': typeof AuthSaasCrmRoute
  '/_auth/saas/metrics': typeof AuthSaasMetricsRoute
  '/_auth/saas/payroll-sync': typeof AuthSaasPayrollSyncRoute
  '/_auth/saas/variable-consideration': typeof AuthSaasVariableConsiderationRoute
  '/_auth/saas/vendor-watch': typeof AuthSaasVendorWatchRoute
  '/_auth/settings/about': typeof AuthSettingsAboutRoute
  '/_auth/settings/api-costs': typeof AuthSettingsApiCostsRoute
  '/_auth/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/_auth/settings/backups': typeof AuthSettingsBackupsRoute
  '/_auth/settings/bank-connections': typeof AuthSettingsBankConnectionsRoute
  '/_auth/settings/crm': typeof AuthSettingsCrmRoute
  '/_auth/settings/currency': typeof AuthSettingsCurrencyRoute
  '/_auth/settings/dimensions': typeof AuthSettingsDimensionsRoute
  '/_auth/settings/entities': typeof AuthSettingsEntitiesRoute
  '/_auth/settings/imports-quickbooks': typeof AuthSettingsImportsQuickbooksRoute
  '/_auth/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/_auth/settings/mcp': typeof AuthSettingsMcpRoute
  '/_auth/settings/numbering': typeof AuthSettingsNumberingRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_auth/settings/shopify': typeof AuthSettingsShopifyRoute
  '/_auth/settings/tax': typeof AuthSettingsTaxRoute
  '/_auth/settings/team': typeof AuthSettingsTeamRoute
  '/_auth/sub-pay-apps/$payAppId': typeof AuthSubPayAppsPayAppIdRoute
  '/_auth/tm-invoices/$invoiceId': typeof AuthTmInvoicesInvoiceIdRoute
  '/_auth/tm-invoices/new': typeof AuthTmInvoicesNewRoute
  '/_auth/tm-tickets/$ticketId': typeof AuthTmTicketsTicketIdRoute
  '/_auth/tm-tickets/new': typeof AuthTmTicketsNewRoute
  '/_auth/vendors/$vendorId': typeof AuthVendorsVendorIdRouteWithChildren
  '/_auth/vendors/merge-tool': typeof AuthVendorsMergeToolRoute
  '/_auth/approvals/': typeof AuthApprovalsIndexRoute
  '/_auth/bank-accounts/': typeof AuthBankAccountsIndexRoute
  '/_auth/bank-rec/': typeof AuthBankRecIndexRoute
  '/_auth/close/': typeof AuthCloseIndexRoute
  '/_auth/concrete-plant/': typeof AuthConcretePlantIndexRoute
  '/_auth/contract-work-packages/': typeof AuthContractWorkPackagesIndexRoute
  '/_auth/contracts/': typeof AuthContractsIndexRoute
  '/_auth/customers/': typeof AuthCustomersIndexRoute
  '/_auth/equipment/': typeof AuthEquipmentIndexRoute
  '/_auth/hospitality/': typeof AuthHospitalityIndexRoute
  '/_auth/intercompany/': typeof AuthIntercompanyIndexRoute
  '/_auth/invoices/': typeof AuthInvoicesIndexRoute
  '/_auth/journals/': typeof AuthJournalsIndexRoute
  '/_auth/onboarding/': typeof AuthOnboardingIndexRoute
  '/_auth/payments/': typeof AuthPaymentsIndexRoute
  '/_auth/payroll-l3/': typeof AuthPayrollL3IndexRoute
  '/_auth/periods/': typeof AuthPeriodsIndexRoute
  '/_auth/progress-billings/': typeof AuthProgressBillingsIndexRoute
  '/_auth/projects/': typeof AuthProjectsIndexRoute
  '/_auth/purchase-orders/': typeof AuthPurchaseOrdersIndexRoute
  '/_auth/rate-sheets/': typeof AuthRateSheetsIndexRoute
  '/_auth/reports/': typeof AuthReportsIndexRoute
  '/_auth/saas/': typeof AuthSaasIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/tm-invoices/': typeof AuthTmInvoicesIndexRoute
  '/_auth/tm-tickets/': typeof AuthTmTicketsIndexRoute
  '/_auth/vendors/': typeof AuthVendorsIndexRoute
  '/_auth/equipment/cost-postings/$postingId': typeof AuthEquipmentCostPostingsPostingIdRoute
  '/_auth/equipment/reports/cost-by-job': typeof AuthEquipmentReportsCostByJobRoute
  '/_auth/equipment/reports/variance': typeof AuthEquipmentReportsVarianceRoute
  '/_auth/help_/docs/$': typeof AuthHelpDocsSplatRoute
  '/_auth/hospitality/fnb/performance': typeof AuthHospitalityFnbPerformanceRoute
  '/_auth/hospitality/fnb/tronc': typeof AuthHospitalityFnbTroncRoute
  '/_auth/hospitality/gaming/floor': typeof AuthHospitalityGamingFloorRoute
  '/_auth/hospitality/gaming/markers': typeof AuthHospitalityGamingMarkersRoute
  '/_auth/hospitality/lodging/folio-ar': typeof AuthHospitalityLodgingFolioArRoute
  '/_auth/invoices/ap/$invoiceId': typeof AuthInvoicesApInvoiceIdRoute
  '/_auth/invoices/ap/new': typeof AuthInvoicesApNewRoute
  '/_auth/invoices/ar/$invoiceId': typeof AuthInvoicesArInvoiceIdRoute
  '/_auth/invoices/ar/new': typeof AuthInvoicesArNewRoute
  '/_auth/payroll-l2/compliance-gate_/$payRunId': typeof AuthPayrollL2ComplianceGatePayRunIdRoute
  '/_auth/payroll-l2/earned-value_/$projectId': typeof AuthPayrollL2EarnedValueProjectIdRoute
  '/_auth/payroll-l2/expenses_/new': typeof AuthPayrollL2ExpensesNewRoute
  '/_auth/payroll-l2/labor-event_/$eventId': typeof AuthPayrollL2LaborEventEventIdRoute
  '/_auth/payroll-l4/certified-payroll-reports_/$reportId': typeof AuthPayrollL4CertifiedPayrollReportsReportIdRoute
  '/_auth/payroll-l4/wage-determinations_/$wdId': typeof AuthPayrollL4WageDeterminationsWdIdRoute
  '/_auth/payroll/contractors_/$contractorId': typeof AuthPayrollContractorsContractorIdRoute
  '/_auth/payroll/employees_/$employeeId': typeof AuthPayrollEmployeesEmployeeIdRouteWithChildren
  '/_auth/payroll/pay-runs_/$payRunId': typeof AuthPayrollPayRunsPayRunIdRoute
  '/_auth/periods/$periodId/checklist': typeof AuthPeriodsPeriodIdChecklistRoute
  '/_auth/projects/$projectId/gmp': typeof AuthProjectsProjectIdGmpRoute
  '/_auth/saas/plans/$planId': typeof AuthSaasPlansPlanIdRoute
  '/_auth/saas/subscriptions/$subId': typeof AuthSaasSubscriptionsSubIdRoute
  '/_auth/settings/permissions/me': typeof AuthSettingsPermissionsMeRoute
  '/_auth/vendors/$vendorId/activity': typeof AuthVendorsVendorIdActivityRoute
  '/_auth/vendors/$vendorId/addresses': typeof AuthVendorsVendorIdAddressesRoute
  '/_auth/vendors/$vendorId/autopilot': typeof AuthVendorsVendorIdAutopilotRoute
  '/_auth/vendors/$vendorId/lien-waivers': typeof AuthVendorsVendorIdLienWaiversRoute
  '/_auth/vendors/$vendorId/payments': typeof AuthVendorsVendorIdPaymentsRoute
  '/_auth/vendors/$vendorId/pos': typeof AuthVendorsVendorIdPosRoute
  '/_auth/vendors/$vendorId/qualification': typeof AuthVendorsVendorIdQualificationRoute
  '/_auth/vendors/$vendorId/subcontracts': typeof AuthVendorsVendorIdSubcontractsRoute
  '/_auth/equipment/cost-postings/': typeof AuthEquipmentCostPostingsIndexRoute
  '/_auth/hospitality/lodging/': typeof AuthHospitalityLodgingIndexRoute
  '/_auth/vendors/$vendorId/': typeof AuthVendorsVendorIdIndexRoute
  '/_auth/payroll-l2/employees_/$employeeId/rates': typeof AuthPayrollL2EmployeesEmployeeIdRatesRoute
  '/_auth/payroll/employees_/$employeeId/w4': typeof AuthPayrollEmployeesEmployeeIdW4Route
  '/_auth/payroll/year-end_/1099-misc/$year': typeof AuthPayrollYearEnd1099MiscYearRoute
  '/_auth/payroll/year-end_/1099-nec/$year': typeof AuthPayrollYearEnd1099NecYearRoute
  '/_auth/payroll/year-end_/940/$year': typeof AuthPayrollYearEnd940YearRoute
  '/_auth/payroll/year-end_/w2/$year': typeof AuthPayrollYearEndW2YearRoute
  '/_auth/payroll/year-end_/w3/$year': typeof AuthPayrollYearEndW3YearRoute
  '/_auth/payroll/employees_/$employeeId/': typeof AuthPayrollEmployeesEmployeeIdIndexRoute
  '/_auth/payroll/year-end_/941/$year/$quarter': typeof AuthPayrollYearEnd941YearQuarterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/callback'
    | '/handoff'
    | '/login'
    | '/reset-password'
    | '/review-budget'
    | '/accounts'
    | '/agents'
    | '/ap'
    | '/api-spend'
    | '/approvals'
    | '/ar'
    | '/assets'
    | '/audit-log'
    | '/balance-sheet'
    | '/bank-accounts'
    | '/bills-intake'
    | '/cap-table'
    | '/cash-flow'
    | '/cfo-advisor'
    | '/change-orders'
    | '/chat'
    | '/chat-history'
    | '/close'
    | '/compliance'
    | '/contacts'
    | '/contract-to-cash'
    | '/cost-code-templates'
    | '/cost-codes'
    | '/data-migration'
    | '/employees'
    | '/enterprise-accounting'
    | '/equipment'
    | '/expenses'
    | '/fx-rates'
    | '/gl'
    | '/help'
    | '/hospitality'
    | '/imports'
    | '/income-statement'
    | '/intercompany'
    | '/job-cost'
    | '/journals'
    | '/lien-waivers'
    | '/onboarding'
    | '/payments'
    | '/payroll-l2'
    | '/payroll-l3'
    | '/periods'
    | '/progress-billings'
    | '/project-executive'
    | '/projects'
    | '/rate-sheets'
    | '/recognition'
    | '/recurring-charges'
    | '/recurring-journals'
    | '/saas'
    | '/settings'
    | '/sub-pay-apps'
    | '/subcontracts'
    | '/time'
    | '/tm-invoices'
    | '/tm-tickets'
    | '/trial-balance'
    | '/portal/$token'
    | '/admin/usage'
    | '/ap/autopilot'
    | '/approvals/analytics'
    | '/approvals/policies'
    | '/bank-accounts/$bankAccountId'
    | '/bank-rec/$recId'
    | '/close/$periodId'
    | '/close/templates'
    | '/concrete-plant/load-to-cash'
    | '/concrete-plant/material-to-margin'
    | '/concrete-plant/operations'
    | '/contract-work-packages/$packageId'
    | '/contracts/$contractId'
    | '/customers/$customerId'
    | '/direct-expense/new'
    | '/equipment/$equipmentId'
    | '/equipment/cost-posting'
    | '/equipment/cost-postings'
    | '/equipment/rental-links'
    | '/fpa/budget'
    | '/hospitality/filings'
    | '/hospitality/flash'
    | '/hospitality/fnb'
    | '/hospitality/fpa'
    | '/hospitality/gaming'
    | '/hospitality/gaming-tax'
    | '/hospitality/lodging'
    | '/hospitality/night-audit'
    | '/hospitality/revenue-centers'
    | '/hospitality/title-31'
    | '/intercompany/transactions'
    | '/journals/$journalId'
    | '/journals/new'
    | '/lien-waivers/templates'
    | '/onboarding/complete'
    | '/onboarding/setup'
    | '/payments/$paymentId'
    | '/payments/check-run'
    | '/payroll-l2/allowances'
    | '/payroll-l2/anomalies'
    | '/payroll-l2/burden'
    | '/payroll-l2/crafts'
    | '/payroll-l2/differentials'
    | '/payroll-l2/equipment'
    | '/payroll-l2/expenses'
    | '/payroll-l2/flagged'
    | '/payroll-l2/forms'
    | '/payroll-l2/ot-rules'
    | '/payroll-l2/retro-pay'
    | '/payroll-l2/timesheet-feed'
    | '/payroll-l2/workers-comp'
    | '/payroll-l3/apprentice-compliance'
    | '/payroll-l3/cbas'
    | '/payroll-l3/classification-queue'
    | '/payroll-l3/compliance-alerts'
    | '/payroll-l3/contracts'
    | '/payroll-l3/fringe-funds'
    | '/payroll-l3/gl-setup'
    | '/payroll-l3/memberships'
    | '/payroll-l3/remittance'
    | '/payroll-l3/working-rules'
    | '/payroll-l4/apprentice-programs'
    | '/payroll-l4/certified-payroll-reports'
    | '/payroll-l4/compliance'
    | '/payroll-l4/submissions'
    | '/payroll-l4/wage-determinations'
    | '/payroll/contractors'
    | '/payroll/deduction-codes'
    | '/payroll/earning-codes'
    | '/payroll/employees'
    | '/payroll/iris-submissions'
    | '/payroll/pay-runs'
    | '/payroll/setup'
    | '/payroll/tax-deposits'
    | '/payroll/year-end'
    | '/progress-billings/$pbId'
    | '/projects/$projectId'
    | '/purchase-orders/$poId'
    | '/purchase-orders/new'
    | '/rate-sheets/$rateSheetId'
    | '/rate-sheets/new'
    | '/reports/$reportId'
    | '/reports/ap-aging'
    | '/reports/ar-aging'
    | '/reports/asset-rollforward'
    | '/reports/book-tax-difference'
    | '/reports/build'
    | '/reports/charts'
    | '/reports/committed-cost'
    | '/reports/consolidated'
    | '/reports/cost-code-rollup'
    | '/reports/sub-draw-history'
    | '/reports/sub-pay-app-aging'
    | '/reports/sub-retention'
    | '/reports/tax-depreciation'
    | '/reports/wip'
    | '/saas/cohorts'
    | '/saas/crm'
    | '/saas/metrics'
    | '/saas/payroll-sync'
    | '/saas/variable-consideration'
    | '/saas/vendor-watch'
    | '/settings/about'
    | '/settings/api-costs'
    | '/settings/api-keys'
    | '/settings/backups'
    | '/settings/bank-connections'
    | '/settings/crm'
    | '/settings/currency'
    | '/settings/dimensions'
    | '/settings/entities'
    | '/settings/imports-quickbooks'
    | '/settings/integrations'
    | '/settings/mcp'
    | '/settings/numbering'
    | '/settings/profile'
    | '/settings/shopify'
    | '/settings/tax'
    | '/settings/team'
    | '/sub-pay-apps/$payAppId'
    | '/tm-invoices/$invoiceId'
    | '/tm-invoices/new'
    | '/tm-tickets/$ticketId'
    | '/tm-tickets/new'
    | '/vendors/$vendorId'
    | '/vendors/merge-tool'
    | '/approvals/'
    | '/bank-accounts/'
    | '/bank-rec/'
    | '/close/'
    | '/concrete-plant/'
    | '/contract-work-packages/'
    | '/contracts/'
    | '/customers/'
    | '/equipment/'
    | '/hospitality/'
    | '/intercompany/'
    | '/invoices/'
    | '/journals/'
    | '/onboarding/'
    | '/payments/'
    | '/payroll-l3/'
    | '/periods/'
    | '/progress-billings/'
    | '/projects/'
    | '/purchase-orders/'
    | '/rate-sheets/'
    | '/reports/'
    | '/saas/'
    | '/settings/'
    | '/tm-invoices/'
    | '/tm-tickets/'
    | '/vendors/'
    | '/equipment/cost-postings/$postingId'
    | '/equipment/reports/cost-by-job'
    | '/equipment/reports/variance'
    | '/help/docs/$'
    | '/hospitality/fnb/performance'
    | '/hospitality/fnb/tronc'
    | '/hospitality/gaming/floor'
    | '/hospitality/gaming/markers'
    | '/hospitality/lodging/folio-ar'
    | '/invoices/ap/$invoiceId'
    | '/invoices/ap/new'
    | '/invoices/ar/$invoiceId'
    | '/invoices/ar/new'
    | '/payroll-l2/compliance-gate/$payRunId'
    | '/payroll-l2/earned-value/$projectId'
    | '/payroll-l2/expenses/new'
    | '/payroll-l2/labor-event/$eventId'
    | '/payroll-l4/certified-payroll-reports/$reportId'
    | '/payroll-l4/wage-determinations/$wdId'
    | '/payroll/contractors/$contractorId'
    | '/payroll/employees/$employeeId'
    | '/payroll/pay-runs/$payRunId'
    | '/periods/$periodId/checklist'
    | '/projects/$projectId/gmp'
    | '/saas/plans/$planId'
    | '/saas/subscriptions/$subId'
    | '/settings/permissions/me'
    | '/vendors/$vendorId/activity'
    | '/vendors/$vendorId/addresses'
    | '/vendors/$vendorId/autopilot'
    | '/vendors/$vendorId/lien-waivers'
    | '/vendors/$vendorId/payments'
    | '/vendors/$vendorId/pos'
    | '/vendors/$vendorId/qualification'
    | '/vendors/$vendorId/subcontracts'
    | '/equipment/cost-postings/'
    | '/hospitality/lodging/'
    | '/vendors/$vendorId/'
    | '/payroll-l2/employees/$employeeId/rates'
    | '/payroll/employees/$employeeId/w4'
    | '/payroll/year-end/1099-misc/$year'
    | '/payroll/year-end/1099-nec/$year'
    | '/payroll/year-end/940/$year'
    | '/payroll/year-end/w2/$year'
    | '/payroll/year-end/w3/$year'
    | '/payroll/employees/$employeeId/'
    | '/payroll/year-end/941/$year/$quarter'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invite'
    | '/callback'
    | '/handoff'
    | '/login'
    | '/reset-password'
    | '/review-budget'
    | '/accounts'
    | '/agents'
    | '/ap'
    | '/api-spend'
    | '/ar'
    | '/assets'
    | '/audit-log'
    | '/balance-sheet'
    | '/bills-intake'
    | '/cap-table'
    | '/cash-flow'
    | '/cfo-advisor'
    | '/change-orders'
    | '/chat'
    | '/chat-history'
    | '/compliance'
    | '/contacts'
    | '/contract-to-cash'
    | '/cost-code-templates'
    | '/cost-codes'
    | '/data-migration'
    | '/employees'
    | '/enterprise-accounting'
    | '/expenses'
    | '/fx-rates'
    | '/gl'
    | '/help'
    | '/imports'
    | '/income-statement'
    | '/job-cost'
    | '/lien-waivers'
    | '/payroll-l2'
    | '/project-executive'
    | '/recognition'
    | '/recurring-charges'
    | '/recurring-journals'
    | '/sub-pay-apps'
    | '/subcontracts'
    | '/time'
    | '/trial-balance'
    | '/portal/$token'
    | '/'
    | '/admin/usage'
    | '/ap/autopilot'
    | '/approvals/analytics'
    | '/approvals/policies'
    | '/bank-accounts/$bankAccountId'
    | '/bank-rec/$recId'
    | '/close/$periodId'
    | '/close/templates'
    | '/concrete-plant/load-to-cash'
    | '/concrete-plant/material-to-margin'
    | '/concrete-plant/operations'
    | '/contract-work-packages/$packageId'
    | '/contracts/$contractId'
    | '/customers/$customerId'
    | '/direct-expense/new'
    | '/equipment/$equipmentId'
    | '/equipment/cost-posting'
    | '/equipment/rental-links'
    | '/fpa/budget'
    | '/hospitality/filings'
    | '/hospitality/flash'
    | '/hospitality/fnb'
    | '/hospitality/fpa'
    | '/hospitality/gaming'
    | '/hospitality/gaming-tax'
    | '/hospitality/night-audit'
    | '/hospitality/revenue-centers'
    | '/hospitality/title-31'
    | '/intercompany/transactions'
    | '/journals/$journalId'
    | '/journals/new'
    | '/lien-waivers/templates'
    | '/onboarding/complete'
    | '/onboarding/setup'
    | '/payments/$paymentId'
    | '/payments/check-run'
    | '/payroll-l2/allowances'
    | '/payroll-l2/anomalies'
    | '/payroll-l2/burden'
    | '/payroll-l2/crafts'
    | '/payroll-l2/differentials'
    | '/payroll-l2/equipment'
    | '/payroll-l2/expenses'
    | '/payroll-l2/flagged'
    | '/payroll-l2/forms'
    | '/payroll-l2/ot-rules'
    | '/payroll-l2/retro-pay'
    | '/payroll-l2/timesheet-feed'
    | '/payroll-l2/workers-comp'
    | '/payroll-l3/apprentice-compliance'
    | '/payroll-l3/cbas'
    | '/payroll-l3/classification-queue'
    | '/payroll-l3/compliance-alerts'
    | '/payroll-l3/contracts'
    | '/payroll-l3/fringe-funds'
    | '/payroll-l3/gl-setup'
    | '/payroll-l3/memberships'
    | '/payroll-l3/remittance'
    | '/payroll-l3/working-rules'
    | '/payroll-l4/apprentice-programs'
    | '/payroll-l4/certified-payroll-reports'
    | '/payroll-l4/compliance'
    | '/payroll-l4/submissions'
    | '/payroll-l4/wage-determinations'
    | '/payroll/contractors'
    | '/payroll/deduction-codes'
    | '/payroll/earning-codes'
    | '/payroll/employees'
    | '/payroll/iris-submissions'
    | '/payroll/pay-runs'
    | '/payroll/setup'
    | '/payroll/tax-deposits'
    | '/payroll/year-end'
    | '/progress-billings/$pbId'
    | '/projects/$projectId'
    | '/purchase-orders/$poId'
    | '/purchase-orders/new'
    | '/rate-sheets/$rateSheetId'
    | '/rate-sheets/new'
    | '/reports/$reportId'
    | '/reports/ap-aging'
    | '/reports/ar-aging'
    | '/reports/asset-rollforward'
    | '/reports/book-tax-difference'
    | '/reports/build'
    | '/reports/charts'
    | '/reports/committed-cost'
    | '/reports/consolidated'
    | '/reports/cost-code-rollup'
    | '/reports/sub-draw-history'
    | '/reports/sub-pay-app-aging'
    | '/reports/sub-retention'
    | '/reports/tax-depreciation'
    | '/reports/wip'
    | '/saas/cohorts'
    | '/saas/crm'
    | '/saas/metrics'
    | '/saas/payroll-sync'
    | '/saas/variable-consideration'
    | '/saas/vendor-watch'
    | '/settings/about'
    | '/settings/api-costs'
    | '/settings/api-keys'
    | '/settings/backups'
    | '/settings/bank-connections'
    | '/settings/crm'
    | '/settings/currency'
    | '/settings/dimensions'
    | '/settings/entities'
    | '/settings/imports-quickbooks'
    | '/settings/integrations'
    | '/settings/mcp'
    | '/settings/numbering'
    | '/settings/profile'
    | '/settings/shopify'
    | '/settings/tax'
    | '/settings/team'
    | '/sub-pay-apps/$payAppId'
    | '/tm-invoices/$invoiceId'
    | '/tm-invoices/new'
    | '/tm-tickets/$ticketId'
    | '/tm-tickets/new'
    | '/vendors/merge-tool'
    | '/approvals'
    | '/bank-accounts'
    | '/bank-rec'
    | '/close'
    | '/concrete-plant'
    | '/contract-work-packages'
    | '/contracts'
    | '/customers'
    | '/equipment'
    | '/hospitality'
    | '/intercompany'
    | '/invoices'
    | '/journals'
    | '/onboarding'
    | '/payments'
    | '/payroll-l3'
    | '/periods'
    | '/progress-billings'
    | '/projects'
    | '/purchase-orders'
    | '/rate-sheets'
    | '/reports'
    | '/saas'
    | '/settings'
    | '/tm-invoices'
    | '/tm-tickets'
    | '/vendors'
    | '/equipment/cost-postings/$postingId'
    | '/equipment/reports/cost-by-job'
    | '/equipment/reports/variance'
    | '/help/docs/$'
    | '/hospitality/fnb/performance'
    | '/hospitality/fnb/tronc'
    | '/hospitality/gaming/floor'
    | '/hospitality/gaming/markers'
    | '/hospitality/lodging/folio-ar'
    | '/invoices/ap/$invoiceId'
    | '/invoices/ap/new'
    | '/invoices/ar/$invoiceId'
    | '/invoices/ar/new'
    | '/payroll-l2/compliance-gate/$payRunId'
    | '/payroll-l2/earned-value/$projectId'
    | '/payroll-l2/expenses/new'
    | '/payroll-l2/labor-event/$eventId'
    | '/payroll-l4/certified-payroll-reports/$reportId'
    | '/payroll-l4/wage-determinations/$wdId'
    | '/payroll/contractors/$contractorId'
    | '/payroll/pay-runs/$payRunId'
    | '/periods/$periodId/checklist'
    | '/projects/$projectId/gmp'
    | '/saas/plans/$planId'
    | '/saas/subscriptions/$subId'
    | '/settings/permissions/me'
    | '/vendors/$vendorId/activity'
    | '/vendors/$vendorId/addresses'
    | '/vendors/$vendorId/autopilot'
    | '/vendors/$vendorId/lien-waivers'
    | '/vendors/$vendorId/payments'
    | '/vendors/$vendorId/pos'
    | '/vendors/$vendorId/qualification'
    | '/vendors/$vendorId/subcontracts'
    | '/equipment/cost-postings'
    | '/hospitality/lodging'
    | '/vendors/$vendorId'
    | '/payroll-l2/employees/$employeeId/rates'
    | '/payroll/employees/$employeeId/w4'
    | '/payroll/year-end/1099-misc/$year'
    | '/payroll/year-end/1099-nec/$year'
    | '/payroll/year-end/940/$year'
    | '/payroll/year-end/w2/$year'
    | '/payroll/year-end/w3/$year'
    | '/payroll/employees/$employeeId'
    | '/payroll/year-end/941/$year/$quarter'
  id:
    | '__root__'
    | '/_auth'
    | '/accept-invite'
    | '/callback'
    | '/handoff'
    | '/login'
    | '/reset-password'
    | '/review-budget'
    | '/_auth/accounts'
    | '/_auth/agents'
    | '/_auth/ap'
    | '/_auth/api-spend'
    | '/_auth/approvals'
    | '/_auth/ar'
    | '/_auth/assets'
    | '/_auth/audit-log'
    | '/_auth/balance-sheet'
    | '/_auth/bank-accounts'
    | '/_auth/bills-intake'
    | '/_auth/cap-table'
    | '/_auth/cash-flow'
    | '/_auth/cfo-advisor'
    | '/_auth/change-orders'
    | '/_auth/chat'
    | '/_auth/chat-history'
    | '/_auth/close'
    | '/_auth/compliance'
    | '/_auth/contacts'
    | '/_auth/contract-to-cash'
    | '/_auth/cost-code-templates'
    | '/_auth/cost-codes'
    | '/_auth/data-migration'
    | '/_auth/employees'
    | '/_auth/enterprise-accounting'
    | '/_auth/equipment'
    | '/_auth/expenses'
    | '/_auth/fx-rates'
    | '/_auth/gl'
    | '/_auth/help'
    | '/_auth/hospitality'
    | '/_auth/imports'
    | '/_auth/income-statement'
    | '/_auth/intercompany'
    | '/_auth/job-cost'
    | '/_auth/journals'
    | '/_auth/lien-waivers'
    | '/_auth/onboarding'
    | '/_auth/payments'
    | '/_auth/payroll-l2'
    | '/_auth/payroll-l3'
    | '/_auth/periods'
    | '/_auth/progress-billings'
    | '/_auth/project-executive'
    | '/_auth/projects'
    | '/_auth/rate-sheets'
    | '/_auth/recognition'
    | '/_auth/recurring-charges'
    | '/_auth/recurring-journals'
    | '/_auth/saas'
    | '/_auth/settings'
    | '/_auth/sub-pay-apps'
    | '/_auth/subcontracts'
    | '/_auth/time'
    | '/_auth/tm-invoices'
    | '/_auth/tm-tickets'
    | '/_auth/trial-balance'
    | '/portal/$token'
    | '/_auth/'
    | '/_auth/admin/usage'
    | '/_auth/ap/autopilot'
    | '/_auth/approvals/analytics'
    | '/_auth/approvals/policies'
    | '/_auth/bank-accounts/$bankAccountId'
    | '/_auth/bank-rec/$recId'
    | '/_auth/close/$periodId'
    | '/_auth/close/templates'
    | '/_auth/concrete-plant/load-to-cash'
    | '/_auth/concrete-plant/material-to-margin'
    | '/_auth/concrete-plant/operations'
    | '/_auth/contract-work-packages/$packageId'
    | '/_auth/contracts/$contractId'
    | '/_auth/customers/$customerId'
    | '/_auth/direct-expense/new'
    | '/_auth/equipment/$equipmentId'
    | '/_auth/equipment/cost-posting'
    | '/_auth/equipment/cost-postings'
    | '/_auth/equipment/rental-links'
    | '/_auth/fpa/budget'
    | '/_auth/hospitality/filings'
    | '/_auth/hospitality/flash'
    | '/_auth/hospitality/fnb'
    | '/_auth/hospitality/fpa'
    | '/_auth/hospitality/gaming'
    | '/_auth/hospitality/gaming-tax'
    | '/_auth/hospitality/lodging'
    | '/_auth/hospitality/night-audit'
    | '/_auth/hospitality/revenue-centers'
    | '/_auth/hospitality/title-31'
    | '/_auth/intercompany/transactions'
    | '/_auth/journals/$journalId'
    | '/_auth/journals/new'
    | '/_auth/lien-waivers_/templates'
    | '/_auth/onboarding/complete'
    | '/_auth/onboarding/setup'
    | '/_auth/payments/$paymentId'
    | '/_auth/payments/check-run'
    | '/_auth/payroll-l2/allowances'
    | '/_auth/payroll-l2/anomalies'
    | '/_auth/payroll-l2/burden'
    | '/_auth/payroll-l2/crafts'
    | '/_auth/payroll-l2/differentials'
    | '/_auth/payroll-l2/equipment'
    | '/_auth/payroll-l2/expenses'
    | '/_auth/payroll-l2/flagged'
    | '/_auth/payroll-l2/forms'
    | '/_auth/payroll-l2/ot-rules'
    | '/_auth/payroll-l2/retro-pay'
    | '/_auth/payroll-l2/timesheet-feed'
    | '/_auth/payroll-l2/workers-comp'
    | '/_auth/payroll-l3/apprentice-compliance'
    | '/_auth/payroll-l3/cbas'
    | '/_auth/payroll-l3/classification-queue'
    | '/_auth/payroll-l3/compliance-alerts'
    | '/_auth/payroll-l3/contracts'
    | '/_auth/payroll-l3/fringe-funds'
    | '/_auth/payroll-l3/gl-setup'
    | '/_auth/payroll-l3/memberships'
    | '/_auth/payroll-l3/remittance'
    | '/_auth/payroll-l3/working-rules'
    | '/_auth/payroll-l4/apprentice-programs'
    | '/_auth/payroll-l4/certified-payroll-reports'
    | '/_auth/payroll-l4/compliance'
    | '/_auth/payroll-l4/submissions'
    | '/_auth/payroll-l4/wage-determinations'
    | '/_auth/payroll/contractors'
    | '/_auth/payroll/deduction-codes'
    | '/_auth/payroll/earning-codes'
    | '/_auth/payroll/employees'
    | '/_auth/payroll/iris-submissions'
    | '/_auth/payroll/pay-runs'
    | '/_auth/payroll/setup'
    | '/_auth/payroll/tax-deposits'
    | '/_auth/payroll/year-end'
    | '/_auth/progress-billings/$pbId'
    | '/_auth/projects/$projectId'
    | '/_auth/purchase-orders/$poId'
    | '/_auth/purchase-orders/new'
    | '/_auth/rate-sheets/$rateSheetId'
    | '/_auth/rate-sheets/new'
    | '/_auth/reports/$reportId'
    | '/_auth/reports/ap-aging'
    | '/_auth/reports/ar-aging'
    | '/_auth/reports/asset-rollforward'
    | '/_auth/reports/book-tax-difference'
    | '/_auth/reports/build'
    | '/_auth/reports/charts'
    | '/_auth/reports/committed-cost'
    | '/_auth/reports/consolidated'
    | '/_auth/reports/cost-code-rollup'
    | '/_auth/reports/sub-draw-history'
    | '/_auth/reports/sub-pay-app-aging'
    | '/_auth/reports/sub-retention'
    | '/_auth/reports/tax-depreciation'
    | '/_auth/reports/wip'
    | '/_auth/saas/cohorts'
    | '/_auth/saas/crm'
    | '/_auth/saas/metrics'
    | '/_auth/saas/payroll-sync'
    | '/_auth/saas/variable-consideration'
    | '/_auth/saas/vendor-watch'
    | '/_auth/settings/about'
    | '/_auth/settings/api-costs'
    | '/_auth/settings/api-keys'
    | '/_auth/settings/backups'
    | '/_auth/settings/bank-connections'
    | '/_auth/settings/crm'
    | '/_auth/settings/currency'
    | '/_auth/settings/dimensions'
    | '/_auth/settings/entities'
    | '/_auth/settings/imports-quickbooks'
    | '/_auth/settings/integrations'
    | '/_auth/settings/mcp'
    | '/_auth/settings/numbering'
    | '/_auth/settings/profile'
    | '/_auth/settings/shopify'
    | '/_auth/settings/tax'
    | '/_auth/settings/team'
    | '/_auth/sub-pay-apps/$payAppId'
    | '/_auth/tm-invoices/$invoiceId'
    | '/_auth/tm-invoices/new'
    | '/_auth/tm-tickets/$ticketId'
    | '/_auth/tm-tickets/new'
    | '/_auth/vendors/$vendorId'
    | '/_auth/vendors/merge-tool'
    | '/_auth/approvals/'
    | '/_auth/bank-accounts/'
    | '/_auth/bank-rec/'
    | '/_auth/close/'
    | '/_auth/concrete-plant/'
    | '/_auth/contract-work-packages/'
    | '/_auth/contracts/'
    | '/_auth/customers/'
    | '/_auth/equipment/'
    | '/_auth/hospitality/'
    | '/_auth/intercompany/'
    | '/_auth/invoices/'
    | '/_auth/journals/'
    | '/_auth/onboarding/'
    | '/_auth/payments/'
    | '/_auth/payroll-l3/'
    | '/_auth/periods/'
    | '/_auth/progress-billings/'
    | '/_auth/projects/'
    | '/_auth/purchase-orders/'
    | '/_auth/rate-sheets/'
    | '/_auth/reports/'
    | '/_auth/saas/'
    | '/_auth/settings/'
    | '/_auth/tm-invoices/'
    | '/_auth/tm-tickets/'
    | '/_auth/vendors/'
    | '/_auth/equipment/cost-postings/$postingId'
    | '/_auth/equipment/reports/cost-by-job'
    | '/_auth/equipment/reports/variance'
    | '/_auth/help_/docs/$'
    | '/_auth/hospitality/fnb/performance'
    | '/_auth/hospitality/fnb/tronc'
    | '/_auth/hospitality/gaming/floor'
    | '/_auth/hospitality/gaming/markers'
    | '/_auth/hospitality/lodging/folio-ar'
    | '/_auth/invoices/ap/$invoiceId'
    | '/_auth/invoices/ap/new'
    | '/_auth/invoices/ar/$invoiceId'
    | '/_auth/invoices/ar/new'
    | '/_auth/payroll-l2/compliance-gate_/$payRunId'
    | '/_auth/payroll-l2/earned-value_/$projectId'
    | '/_auth/payroll-l2/expenses_/new'
    | '/_auth/payroll-l2/labor-event_/$eventId'
    | '/_auth/payroll-l4/certified-payroll-reports_/$reportId'
    | '/_auth/payroll-l4/wage-determinations_/$wdId'
    | '/_auth/payroll/contractors_/$contractorId'
    | '/_auth/payroll/employees_/$employeeId'
    | '/_auth/payroll/pay-runs_/$payRunId'
    | '/_auth/periods/$periodId/checklist'
    | '/_auth/projects/$projectId/gmp'
    | '/_auth/saas/plans/$planId'
    | '/_auth/saas/subscriptions/$subId'
    | '/_auth/settings/permissions/me'
    | '/_auth/vendors/$vendorId/activity'
    | '/_auth/vendors/$vendorId/addresses'
    | '/_auth/vendors/$vendorId/autopilot'
    | '/_auth/vendors/$vendorId/lien-waivers'
    | '/_auth/vendors/$vendorId/payments'
    | '/_auth/vendors/$vendorId/pos'
    | '/_auth/vendors/$vendorId/qualification'
    | '/_auth/vendors/$vendorId/subcontracts'
    | '/_auth/equipment/cost-postings/'
    | '/_auth/hospitality/lodging/'
    | '/_auth/vendors/$vendorId/'
    | '/_auth/payroll-l2/employees_/$employeeId/rates'
    | '/_auth/payroll/employees_/$employeeId/w4'
    | '/_auth/payroll/year-end_/1099-misc/$year'
    | '/_auth/payroll/year-end_/1099-nec/$year'
    | '/_auth/payroll/year-end_/940/$year'
    | '/_auth/payroll/year-end_/w2/$year'
    | '/_auth/payroll/year-end_/w3/$year'
    | '/_auth/payroll/employees_/$employeeId/'
    | '/_auth/payroll/year-end_/941/$year/$quarter'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  CallbackRoute: typeof CallbackRoute
  HandoffRoute: typeof HandoffRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ReviewBudgetRoute: typeof ReviewBudgetRoute
  PortalTokenRoute: typeof PortalTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/review-budget': {
      id: '/review-budget'
      path: '/review-budget'
      fullPath: '/review-budget'
      preLoaderRoute: typeof ReviewBudgetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/handoff': {
      id: '/handoff'
      path: '/handoff'
      fullPath: '/handoff'
      preLoaderRoute: typeof HandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/portal/$token': {
      id: '/portal/$token'
      path: '/portal/$token'
      fullPath: '/portal/$token'
      preLoaderRoute: typeof PortalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/trial-balance': {
      id: '/_auth/trial-balance'
      path: '/trial-balance'
      fullPath: '/trial-balance'
      preLoaderRoute: typeof AuthTrialBalanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tm-tickets': {
      id: '/_auth/tm-tickets'
      path: '/tm-tickets'
      fullPath: '/tm-tickets'
      preLoaderRoute: typeof AuthTmTicketsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tm-invoices': {
      id: '/_auth/tm-invoices'
      path: '/tm-invoices'
      fullPath: '/tm-invoices'
      preLoaderRoute: typeof AuthTmInvoicesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/time': {
      id: '/_auth/time'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof AuthTimeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/subcontracts': {
      id: '/_auth/subcontracts'
      path: '/subcontracts'
      fullPath: '/subcontracts'
      preLoaderRoute: typeof AuthSubcontractsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sub-pay-apps': {
      id: '/_auth/sub-pay-apps'
      path: '/sub-pay-apps'
      fullPath: '/sub-pay-apps'
      preLoaderRoute: typeof AuthSubPayAppsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/saas': {
      id: '/_auth/saas'
      path: '/saas'
      fullPath: '/saas'
      preLoaderRoute: typeof AuthSaasRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recurring-journals': {
      id: '/_auth/recurring-journals'
      path: '/recurring-journals'
      fullPath: '/recurring-journals'
      preLoaderRoute: typeof AuthRecurringJournalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recurring-charges': {
      id: '/_auth/recurring-charges'
      path: '/recurring-charges'
      fullPath: '/recurring-charges'
      preLoaderRoute: typeof AuthRecurringChargesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recognition': {
      id: '/_auth/recognition'
      path: '/recognition'
      fullPath: '/recognition'
      preLoaderRoute: typeof AuthRecognitionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rate-sheets': {
      id: '/_auth/rate-sheets'
      path: '/rate-sheets'
      fullPath: '/rate-sheets'
      preLoaderRoute: typeof AuthRateSheetsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects': {
      id: '/_auth/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/project-executive': {
      id: '/_auth/project-executive'
      path: '/project-executive'
      fullPath: '/project-executive'
      preLoaderRoute: typeof AuthProjectExecutiveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/progress-billings': {
      id: '/_auth/progress-billings'
      path: '/progress-billings'
      fullPath: '/progress-billings'
      preLoaderRoute: typeof AuthProgressBillingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/periods': {
      id: '/_auth/periods'
      path: '/periods'
      fullPath: '/periods'
      preLoaderRoute: typeof AuthPeriodsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l3': {
      id: '/_auth/payroll-l3'
      path: '/payroll-l3'
      fullPath: '/payroll-l3'
      preLoaderRoute: typeof AuthPayrollL3RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l2': {
      id: '/_auth/payroll-l2'
      path: '/payroll-l2'
      fullPath: '/payroll-l2'
      preLoaderRoute: typeof AuthPayrollL2RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments': {
      id: '/_auth/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthPaymentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/lien-waivers': {
      id: '/_auth/lien-waivers'
      path: '/lien-waivers'
      fullPath: '/lien-waivers'
      preLoaderRoute: typeof AuthLienWaiversRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journals': {
      id: '/_auth/journals'
      path: '/journals'
      fullPath: '/journals'
      preLoaderRoute: typeof AuthJournalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/job-cost': {
      id: '/_auth/job-cost'
      path: '/job-cost'
      fullPath: '/job-cost'
      preLoaderRoute: typeof AuthJobCostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/intercompany': {
      id: '/_auth/intercompany'
      path: '/intercompany'
      fullPath: '/intercompany'
      preLoaderRoute: typeof AuthIntercompanyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/income-statement': {
      id: '/_auth/income-statement'
      path: '/income-statement'
      fullPath: '/income-statement'
      preLoaderRoute: typeof AuthIncomeStatementRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/imports': {
      id: '/_auth/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof AuthImportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hospitality': {
      id: '/_auth/hospitality'
      path: '/hospitality'
      fullPath: '/hospitality'
      preLoaderRoute: typeof AuthHospitalityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/help': {
      id: '/_auth/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthHelpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gl': {
      id: '/_auth/gl'
      path: '/gl'
      fullPath: '/gl'
      preLoaderRoute: typeof AuthGlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/fx-rates': {
      id: '/_auth/fx-rates'
      path: '/fx-rates'
      fullPath: '/fx-rates'
      preLoaderRoute: typeof AuthFxRatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/expenses': {
      id: '/_auth/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AuthExpensesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/equipment': {
      id: '/_auth/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof AuthEquipmentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/enterprise-accounting': {
      id: '/_auth/enterprise-accounting'
      path: '/enterprise-accounting'
      fullPath: '/enterprise-accounting'
      preLoaderRoute: typeof AuthEnterpriseAccountingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/employees': {
      id: '/_auth/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/data-migration': {
      id: '/_auth/data-migration'
      path: '/data-migration'
      fullPath: '/data-migration'
      preLoaderRoute: typeof AuthDataMigrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cost-codes': {
      id: '/_auth/cost-codes'
      path: '/cost-codes'
      fullPath: '/cost-codes'
      preLoaderRoute: typeof AuthCostCodesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cost-code-templates': {
      id: '/_auth/cost-code-templates'
      path: '/cost-code-templates'
      fullPath: '/cost-code-templates'
      preLoaderRoute: typeof AuthCostCodeTemplatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contract-to-cash': {
      id: '/_auth/contract-to-cash'
      path: '/contract-to-cash'
      fullPath: '/contract-to-cash'
      preLoaderRoute: typeof AuthContractToCashRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts': {
      id: '/_auth/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthContactsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/compliance': {
      id: '/_auth/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AuthComplianceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/close': {
      id: '/_auth/close'
      path: '/close'
      fullPath: '/close'
      preLoaderRoute: typeof AuthCloseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/chat-history': {
      id: '/_auth/chat-history'
      path: '/chat-history'
      fullPath: '/chat-history'
      preLoaderRoute: typeof AuthChatHistoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/chat': {
      id: '/_auth/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthChatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-orders': {
      id: '/_auth/change-orders'
      path: '/change-orders'
      fullPath: '/change-orders'
      preLoaderRoute: typeof AuthChangeOrdersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cfo-advisor': {
      id: '/_auth/cfo-advisor'
      path: '/cfo-advisor'
      fullPath: '/cfo-advisor'
      preLoaderRoute: typeof AuthCfoAdvisorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cash-flow': {
      id: '/_auth/cash-flow'
      path: '/cash-flow'
      fullPath: '/cash-flow'
      preLoaderRoute: typeof AuthCashFlowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cap-table': {
      id: '/_auth/cap-table'
      path: '/cap-table'
      fullPath: '/cap-table'
      preLoaderRoute: typeof AuthCapTableRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bills-intake': {
      id: '/_auth/bills-intake'
      path: '/bills-intake'
      fullPath: '/bills-intake'
      preLoaderRoute: typeof AuthBillsIntakeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank-accounts': {
      id: '/_auth/bank-accounts'
      path: '/bank-accounts'
      fullPath: '/bank-accounts'
      preLoaderRoute: typeof AuthBankAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/balance-sheet': {
      id: '/_auth/balance-sheet'
      path: '/balance-sheet'
      fullPath: '/balance-sheet'
      preLoaderRoute: typeof AuthBalanceSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit-log': {
      id: '/_auth/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthAuditLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assets': {
      id: '/_auth/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthAssetsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ar': {
      id: '/_auth/ar'
      path: '/ar'
      fullPath: '/ar'
      preLoaderRoute: typeof AuthArRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/approvals': {
      id: '/_auth/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/api-spend': {
      id: '/_auth/api-spend'
      path: '/api-spend'
      fullPath: '/api-spend'
      preLoaderRoute: typeof AuthApiSpendRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ap': {
      id: '/_auth/ap'
      path: '/ap'
      fullPath: '/ap'
      preLoaderRoute: typeof AuthApRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents': {
      id: '/_auth/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthAgentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounts': {
      id: '/_auth/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendors/': {
      id: '/_auth/vendors/'
      path: '/vendors'
      fullPath: '/vendors/'
      preLoaderRoute: typeof AuthVendorsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tm-tickets/': {
      id: '/_auth/tm-tickets/'
      path: '/'
      fullPath: '/tm-tickets/'
      preLoaderRoute: typeof AuthTmTicketsIndexRouteImport
      parentRoute: typeof AuthTmTicketsRoute
    }
    '/_auth/tm-invoices/': {
      id: '/_auth/tm-invoices/'
      path: '/'
      fullPath: '/tm-invoices/'
      preLoaderRoute: typeof AuthTmInvoicesIndexRouteImport
      parentRoute: typeof AuthTmInvoicesRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/saas/': {
      id: '/_auth/saas/'
      path: '/'
      fullPath: '/saas/'
      preLoaderRoute: typeof AuthSaasIndexRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/reports/': {
      id: '/_auth/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthReportsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rate-sheets/': {
      id: '/_auth/rate-sheets/'
      path: '/'
      fullPath: '/rate-sheets/'
      preLoaderRoute: typeof AuthRateSheetsIndexRouteImport
      parentRoute: typeof AuthRateSheetsRoute
    }
    '/_auth/purchase-orders/': {
      id: '/_auth/purchase-orders/'
      path: '/purchase-orders'
      fullPath: '/purchase-orders/'
      preLoaderRoute: typeof AuthPurchaseOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/': {
      id: '/_auth/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthProjectsIndexRouteImport
      parentRoute: typeof AuthProjectsRoute
    }
    '/_auth/progress-billings/': {
      id: '/_auth/progress-billings/'
      path: '/'
      fullPath: '/progress-billings/'
      preLoaderRoute: typeof AuthProgressBillingsIndexRouteImport
      parentRoute: typeof AuthProgressBillingsRoute
    }
    '/_auth/periods/': {
      id: '/_auth/periods/'
      path: '/'
      fullPath: '/periods/'
      preLoaderRoute: typeof AuthPeriodsIndexRouteImport
      parentRoute: typeof AuthPeriodsRoute
    }
    '/_auth/payroll-l3/': {
      id: '/_auth/payroll-l3/'
      path: '/'
      fullPath: '/payroll-l3/'
      preLoaderRoute: typeof AuthPayrollL3IndexRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payments/': {
      id: '/_auth/payments/'
      path: '/'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthPaymentsIndexRouteImport
      parentRoute: typeof AuthPaymentsRoute
    }
    '/_auth/onboarding/': {
      id: '/_auth/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthOnboardingIndexRouteImport
      parentRoute: typeof AuthOnboardingRoute
    }
    '/_auth/journals/': {
      id: '/_auth/journals/'
      path: '/'
      fullPath: '/journals/'
      preLoaderRoute: typeof AuthJournalsIndexRouteImport
      parentRoute: typeof AuthJournalsRoute
    }
    '/_auth/invoices/': {
      id: '/_auth/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthInvoicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/intercompany/': {
      id: '/_auth/intercompany/'
      path: '/'
      fullPath: '/intercompany/'
      preLoaderRoute: typeof AuthIntercompanyIndexRouteImport
      parentRoute: typeof AuthIntercompanyRoute
    }
    '/_auth/hospitality/': {
      id: '/_auth/hospitality/'
      path: '/'
      fullPath: '/hospitality/'
      preLoaderRoute: typeof AuthHospitalityIndexRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/equipment/': {
      id: '/_auth/equipment/'
      path: '/'
      fullPath: '/equipment/'
      preLoaderRoute: typeof AuthEquipmentIndexRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/customers/': {
      id: '/_auth/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthCustomersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contracts/': {
      id: '/_auth/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AuthContractsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contract-work-packages/': {
      id: '/_auth/contract-work-packages/'
      path: '/contract-work-packages'
      fullPath: '/contract-work-packages/'
      preLoaderRoute: typeof AuthContractWorkPackagesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/concrete-plant/': {
      id: '/_auth/concrete-plant/'
      path: '/concrete-plant'
      fullPath: '/concrete-plant/'
      preLoaderRoute: typeof AuthConcretePlantIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/close/': {
      id: '/_auth/close/'
      path: '/'
      fullPath: '/close/'
      preLoaderRoute: typeof AuthCloseIndexRouteImport
      parentRoute: typeof AuthCloseRoute
    }
    '/_auth/bank-rec/': {
      id: '/_auth/bank-rec/'
      path: '/bank-rec'
      fullPath: '/bank-rec/'
      preLoaderRoute: typeof AuthBankRecIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank-accounts/': {
      id: '/_auth/bank-accounts/'
      path: '/'
      fullPath: '/bank-accounts/'
      preLoaderRoute: typeof AuthBankAccountsIndexRouteImport
      parentRoute: typeof AuthBankAccountsRoute
    }
    '/_auth/approvals/': {
      id: '/_auth/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AuthApprovalsIndexRouteImport
      parentRoute: typeof AuthApprovalsRoute
    }
    '/_auth/vendors/merge-tool': {
      id: '/_auth/vendors/merge-tool'
      path: '/vendors/merge-tool'
      fullPath: '/vendors/merge-tool'
      preLoaderRoute: typeof AuthVendorsMergeToolRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendors/$vendorId': {
      id: '/_auth/vendors/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/vendors/$vendorId'
      preLoaderRoute: typeof AuthVendorsVendorIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tm-tickets/new': {
      id: '/_auth/tm-tickets/new'
      path: '/new'
      fullPath: '/tm-tickets/new'
      preLoaderRoute: typeof AuthTmTicketsNewRouteImport
      parentRoute: typeof AuthTmTicketsRoute
    }
    '/_auth/tm-tickets/$ticketId': {
      id: '/_auth/tm-tickets/$ticketId'
      path: '/$ticketId'
      fullPath: '/tm-tickets/$ticketId'
      preLoaderRoute: typeof AuthTmTicketsTicketIdRouteImport
      parentRoute: typeof AuthTmTicketsRoute
    }
    '/_auth/tm-invoices/new': {
      id: '/_auth/tm-invoices/new'
      path: '/new'
      fullPath: '/tm-invoices/new'
      preLoaderRoute: typeof AuthTmInvoicesNewRouteImport
      parentRoute: typeof AuthTmInvoicesRoute
    }
    '/_auth/tm-invoices/$invoiceId': {
      id: '/_auth/tm-invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/tm-invoices/$invoiceId'
      preLoaderRoute: typeof AuthTmInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthTmInvoicesRoute
    }
    '/_auth/sub-pay-apps/$payAppId': {
      id: '/_auth/sub-pay-apps/$payAppId'
      path: '/$payAppId'
      fullPath: '/sub-pay-apps/$payAppId'
      preLoaderRoute: typeof AuthSubPayAppsPayAppIdRouteImport
      parentRoute: typeof AuthSubPayAppsRoute
    }
    '/_auth/settings/team': {
      id: '/_auth/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthSettingsTeamRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/tax': {
      id: '/_auth/settings/tax'
      path: '/tax'
      fullPath: '/settings/tax'
      preLoaderRoute: typeof AuthSettingsTaxRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/shopify': {
      id: '/_auth/settings/shopify'
      path: '/shopify'
      fullPath: '/settings/shopify'
      preLoaderRoute: typeof AuthSettingsShopifyRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/numbering': {
      id: '/_auth/settings/numbering'
      path: '/numbering'
      fullPath: '/settings/numbering'
      preLoaderRoute: typeof AuthSettingsNumberingRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/mcp': {
      id: '/_auth/settings/mcp'
      path: '/mcp'
      fullPath: '/settings/mcp'
      preLoaderRoute: typeof AuthSettingsMcpRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/integrations': {
      id: '/_auth/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthSettingsIntegrationsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/imports-quickbooks': {
      id: '/_auth/settings/imports-quickbooks'
      path: '/imports-quickbooks'
      fullPath: '/settings/imports-quickbooks'
      preLoaderRoute: typeof AuthSettingsImportsQuickbooksRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/entities': {
      id: '/_auth/settings/entities'
      path: '/entities'
      fullPath: '/settings/entities'
      preLoaderRoute: typeof AuthSettingsEntitiesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/dimensions': {
      id: '/_auth/settings/dimensions'
      path: '/dimensions'
      fullPath: '/settings/dimensions'
      preLoaderRoute: typeof AuthSettingsDimensionsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/currency': {
      id: '/_auth/settings/currency'
      path: '/currency'
      fullPath: '/settings/currency'
      preLoaderRoute: typeof AuthSettingsCurrencyRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/crm': {
      id: '/_auth/settings/crm'
      path: '/crm'
      fullPath: '/settings/crm'
      preLoaderRoute: typeof AuthSettingsCrmRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/bank-connections': {
      id: '/_auth/settings/bank-connections'
      path: '/bank-connections'
      fullPath: '/settings/bank-connections'
      preLoaderRoute: typeof AuthSettingsBankConnectionsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/backups': {
      id: '/_auth/settings/backups'
      path: '/backups'
      fullPath: '/settings/backups'
      preLoaderRoute: typeof AuthSettingsBackupsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/api-keys': {
      id: '/_auth/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthSettingsApiKeysRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/api-costs': {
      id: '/_auth/settings/api-costs'
      path: '/api-costs'
      fullPath: '/settings/api-costs'
      preLoaderRoute: typeof AuthSettingsApiCostsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/about': {
      id: '/_auth/settings/about'
      path: '/about'
      fullPath: '/settings/about'
      preLoaderRoute: typeof AuthSettingsAboutRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/saas/vendor-watch': {
      id: '/_auth/saas/vendor-watch'
      path: '/vendor-watch'
      fullPath: '/saas/vendor-watch'
      preLoaderRoute: typeof AuthSaasVendorWatchRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/variable-consideration': {
      id: '/_auth/saas/variable-consideration'
      path: '/variable-consideration'
      fullPath: '/saas/variable-consideration'
      preLoaderRoute: typeof AuthSaasVariableConsiderationRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/payroll-sync': {
      id: '/_auth/saas/payroll-sync'
      path: '/payroll-sync'
      fullPath: '/saas/payroll-sync'
      preLoaderRoute: typeof AuthSaasPayrollSyncRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/metrics': {
      id: '/_auth/saas/metrics'
      path: '/metrics'
      fullPath: '/saas/metrics'
      preLoaderRoute: typeof AuthSaasMetricsRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/crm': {
      id: '/_auth/saas/crm'
      path: '/crm'
      fullPath: '/saas/crm'
      preLoaderRoute: typeof AuthSaasCrmRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/cohorts': {
      id: '/_auth/saas/cohorts'
      path: '/cohorts'
      fullPath: '/saas/cohorts'
      preLoaderRoute: typeof AuthSaasCohortsRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/reports/wip': {
      id: '/_auth/reports/wip'
      path: '/reports/wip'
      fullPath: '/reports/wip'
      preLoaderRoute: typeof AuthReportsWipRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/tax-depreciation': {
      id: '/_auth/reports/tax-depreciation'
      path: '/reports/tax-depreciation'
      fullPath: '/reports/tax-depreciation'
      preLoaderRoute: typeof AuthReportsTaxDepreciationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/sub-retention': {
      id: '/_auth/reports/sub-retention'
      path: '/reports/sub-retention'
      fullPath: '/reports/sub-retention'
      preLoaderRoute: typeof AuthReportsSubRetentionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/sub-pay-app-aging': {
      id: '/_auth/reports/sub-pay-app-aging'
      path: '/reports/sub-pay-app-aging'
      fullPath: '/reports/sub-pay-app-aging'
      preLoaderRoute: typeof AuthReportsSubPayAppAgingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/sub-draw-history': {
      id: '/_auth/reports/sub-draw-history'
      path: '/reports/sub-draw-history'
      fullPath: '/reports/sub-draw-history'
      preLoaderRoute: typeof AuthReportsSubDrawHistoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/cost-code-rollup': {
      id: '/_auth/reports/cost-code-rollup'
      path: '/reports/cost-code-rollup'
      fullPath: '/reports/cost-code-rollup'
      preLoaderRoute: typeof AuthReportsCostCodeRollupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/consolidated': {
      id: '/_auth/reports/consolidated'
      path: '/reports/consolidated'
      fullPath: '/reports/consolidated'
      preLoaderRoute: typeof AuthReportsConsolidatedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/committed-cost': {
      id: '/_auth/reports/committed-cost'
      path: '/reports/committed-cost'
      fullPath: '/reports/committed-cost'
      preLoaderRoute: typeof AuthReportsCommittedCostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/charts': {
      id: '/_auth/reports/charts'
      path: '/reports/charts'
      fullPath: '/reports/charts'
      preLoaderRoute: typeof AuthReportsChartsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/build': {
      id: '/_auth/reports/build'
      path: '/reports/build'
      fullPath: '/reports/build'
      preLoaderRoute: typeof AuthReportsBuildRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/book-tax-difference': {
      id: '/_auth/reports/book-tax-difference'
      path: '/reports/book-tax-difference'
      fullPath: '/reports/book-tax-difference'
      preLoaderRoute: typeof AuthReportsBookTaxDifferenceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/asset-rollforward': {
      id: '/_auth/reports/asset-rollforward'
      path: '/reports/asset-rollforward'
      fullPath: '/reports/asset-rollforward'
      preLoaderRoute: typeof AuthReportsAssetRollforwardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/ar-aging': {
      id: '/_auth/reports/ar-aging'
      path: '/reports/ar-aging'
      fullPath: '/reports/ar-aging'
      preLoaderRoute: typeof AuthReportsArAgingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/ap-aging': {
      id: '/_auth/reports/ap-aging'
      path: '/reports/ap-aging'
      fullPath: '/reports/ap-aging'
      preLoaderRoute: typeof AuthReportsApAgingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/$reportId': {
      id: '/_auth/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AuthReportsReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rate-sheets/new': {
      id: '/_auth/rate-sheets/new'
      path: '/new'
      fullPath: '/rate-sheets/new'
      preLoaderRoute: typeof AuthRateSheetsNewRouteImport
      parentRoute: typeof AuthRateSheetsRoute
    }
    '/_auth/rate-sheets/$rateSheetId': {
      id: '/_auth/rate-sheets/$rateSheetId'
      path: '/$rateSheetId'
      fullPath: '/rate-sheets/$rateSheetId'
      preLoaderRoute: typeof AuthRateSheetsRateSheetIdRouteImport
      parentRoute: typeof AuthRateSheetsRoute
    }
    '/_auth/purchase-orders/new': {
      id: '/_auth/purchase-orders/new'
      path: '/purchase-orders/new'
      fullPath: '/purchase-orders/new'
      preLoaderRoute: typeof AuthPurchaseOrdersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/purchase-orders/$poId': {
      id: '/_auth/purchase-orders/$poId'
      path: '/purchase-orders/$poId'
      fullPath: '/purchase-orders/$poId'
      preLoaderRoute: typeof AuthPurchaseOrdersPoIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/$projectId': {
      id: '/_auth/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthProjectsProjectIdRouteImport
      parentRoute: typeof AuthProjectsRoute
    }
    '/_auth/progress-billings/$pbId': {
      id: '/_auth/progress-billings/$pbId'
      path: '/$pbId'
      fullPath: '/progress-billings/$pbId'
      preLoaderRoute: typeof AuthProgressBillingsPbIdRouteImport
      parentRoute: typeof AuthProgressBillingsRoute
    }
    '/_auth/payroll/year-end': {
      id: '/_auth/payroll/year-end'
      path: '/payroll/year-end'
      fullPath: '/payroll/year-end'
      preLoaderRoute: typeof AuthPayrollYearEndRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/tax-deposits': {
      id: '/_auth/payroll/tax-deposits'
      path: '/payroll/tax-deposits'
      fullPath: '/payroll/tax-deposits'
      preLoaderRoute: typeof AuthPayrollTaxDepositsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/setup': {
      id: '/_auth/payroll/setup'
      path: '/payroll/setup'
      fullPath: '/payroll/setup'
      preLoaderRoute: typeof AuthPayrollSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/pay-runs': {
      id: '/_auth/payroll/pay-runs'
      path: '/payroll/pay-runs'
      fullPath: '/payroll/pay-runs'
      preLoaderRoute: typeof AuthPayrollPayRunsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/iris-submissions': {
      id: '/_auth/payroll/iris-submissions'
      path: '/payroll/iris-submissions'
      fullPath: '/payroll/iris-submissions'
      preLoaderRoute: typeof AuthPayrollIrisSubmissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/employees': {
      id: '/_auth/payroll/employees'
      path: '/payroll/employees'
      fullPath: '/payroll/employees'
      preLoaderRoute: typeof AuthPayrollEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/earning-codes': {
      id: '/_auth/payroll/earning-codes'
      path: '/payroll/earning-codes'
      fullPath: '/payroll/earning-codes'
      preLoaderRoute: typeof AuthPayrollEarningCodesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/deduction-codes': {
      id: '/_auth/payroll/deduction-codes'
      path: '/payroll/deduction-codes'
      fullPath: '/payroll/deduction-codes'
      preLoaderRoute: typeof AuthPayrollDeductionCodesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/contractors': {
      id: '/_auth/payroll/contractors'
      path: '/payroll/contractors'
      fullPath: '/payroll/contractors'
      preLoaderRoute: typeof AuthPayrollContractorsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/wage-determinations': {
      id: '/_auth/payroll-l4/wage-determinations'
      path: '/payroll-l4/wage-determinations'
      fullPath: '/payroll-l4/wage-determinations'
      preLoaderRoute: typeof AuthPayrollL4WageDeterminationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/submissions': {
      id: '/_auth/payroll-l4/submissions'
      path: '/payroll-l4/submissions'
      fullPath: '/payroll-l4/submissions'
      preLoaderRoute: typeof AuthPayrollL4SubmissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/compliance': {
      id: '/_auth/payroll-l4/compliance'
      path: '/payroll-l4/compliance'
      fullPath: '/payroll-l4/compliance'
      preLoaderRoute: typeof AuthPayrollL4ComplianceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/certified-payroll-reports': {
      id: '/_auth/payroll-l4/certified-payroll-reports'
      path: '/payroll-l4/certified-payroll-reports'
      fullPath: '/payroll-l4/certified-payroll-reports'
      preLoaderRoute: typeof AuthPayrollL4CertifiedPayrollReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/apprentice-programs': {
      id: '/_auth/payroll-l4/apprentice-programs'
      path: '/payroll-l4/apprentice-programs'
      fullPath: '/payroll-l4/apprentice-programs'
      preLoaderRoute: typeof AuthPayrollL4ApprenticeProgramsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l3/working-rules': {
      id: '/_auth/payroll-l3/working-rules'
      path: '/working-rules'
      fullPath: '/payroll-l3/working-rules'
      preLoaderRoute: typeof AuthPayrollL3WorkingRulesRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/remittance': {
      id: '/_auth/payroll-l3/remittance'
      path: '/remittance'
      fullPath: '/payroll-l3/remittance'
      preLoaderRoute: typeof AuthPayrollL3RemittanceRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/memberships': {
      id: '/_auth/payroll-l3/memberships'
      path: '/memberships'
      fullPath: '/payroll-l3/memberships'
      preLoaderRoute: typeof AuthPayrollL3MembershipsRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/gl-setup': {
      id: '/_auth/payroll-l3/gl-setup'
      path: '/gl-setup'
      fullPath: '/payroll-l3/gl-setup'
      preLoaderRoute: typeof AuthPayrollL3GlSetupRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/fringe-funds': {
      id: '/_auth/payroll-l3/fringe-funds'
      path: '/fringe-funds'
      fullPath: '/payroll-l3/fringe-funds'
      preLoaderRoute: typeof AuthPayrollL3FringeFundsRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/contracts': {
      id: '/_auth/payroll-l3/contracts'
      path: '/contracts'
      fullPath: '/payroll-l3/contracts'
      preLoaderRoute: typeof AuthPayrollL3ContractsRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/compliance-alerts': {
      id: '/_auth/payroll-l3/compliance-alerts'
      path: '/compliance-alerts'
      fullPath: '/payroll-l3/compliance-alerts'
      preLoaderRoute: typeof AuthPayrollL3ComplianceAlertsRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/classification-queue': {
      id: '/_auth/payroll-l3/classification-queue'
      path: '/classification-queue'
      fullPath: '/payroll-l3/classification-queue'
      preLoaderRoute: typeof AuthPayrollL3ClassificationQueueRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/cbas': {
      id: '/_auth/payroll-l3/cbas'
      path: '/cbas'
      fullPath: '/payroll-l3/cbas'
      preLoaderRoute: typeof AuthPayrollL3CbasRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l3/apprentice-compliance': {
      id: '/_auth/payroll-l3/apprentice-compliance'
      path: '/apprentice-compliance'
      fullPath: '/payroll-l3/apprentice-compliance'
      preLoaderRoute: typeof AuthPayrollL3ApprenticeComplianceRouteImport
      parentRoute: typeof AuthPayrollL3Route
    }
    '/_auth/payroll-l2/workers-comp': {
      id: '/_auth/payroll-l2/workers-comp'
      path: '/workers-comp'
      fullPath: '/payroll-l2/workers-comp'
      preLoaderRoute: typeof AuthPayrollL2WorkersCompRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/timesheet-feed': {
      id: '/_auth/payroll-l2/timesheet-feed'
      path: '/timesheet-feed'
      fullPath: '/payroll-l2/timesheet-feed'
      preLoaderRoute: typeof AuthPayrollL2TimesheetFeedRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/retro-pay': {
      id: '/_auth/payroll-l2/retro-pay'
      path: '/retro-pay'
      fullPath: '/payroll-l2/retro-pay'
      preLoaderRoute: typeof AuthPayrollL2RetroPayRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/ot-rules': {
      id: '/_auth/payroll-l2/ot-rules'
      path: '/ot-rules'
      fullPath: '/payroll-l2/ot-rules'
      preLoaderRoute: typeof AuthPayrollL2OtRulesRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/forms': {
      id: '/_auth/payroll-l2/forms'
      path: '/forms'
      fullPath: '/payroll-l2/forms'
      preLoaderRoute: typeof AuthPayrollL2FormsRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/flagged': {
      id: '/_auth/payroll-l2/flagged'
      path: '/flagged'
      fullPath: '/payroll-l2/flagged'
      preLoaderRoute: typeof AuthPayrollL2FlaggedRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/expenses': {
      id: '/_auth/payroll-l2/expenses'
      path: '/expenses'
      fullPath: '/payroll-l2/expenses'
      preLoaderRoute: typeof AuthPayrollL2ExpensesRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/equipment': {
      id: '/_auth/payroll-l2/equipment'
      path: '/equipment'
      fullPath: '/payroll-l2/equipment'
      preLoaderRoute: typeof AuthPayrollL2EquipmentRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/differentials': {
      id: '/_auth/payroll-l2/differentials'
      path: '/differentials'
      fullPath: '/payroll-l2/differentials'
      preLoaderRoute: typeof AuthPayrollL2DifferentialsRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/crafts': {
      id: '/_auth/payroll-l2/crafts'
      path: '/crafts'
      fullPath: '/payroll-l2/crafts'
      preLoaderRoute: typeof AuthPayrollL2CraftsRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/burden': {
      id: '/_auth/payroll-l2/burden'
      path: '/burden'
      fullPath: '/payroll-l2/burden'
      preLoaderRoute: typeof AuthPayrollL2BurdenRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/anomalies': {
      id: '/_auth/payroll-l2/anomalies'
      path: '/anomalies'
      fullPath: '/payroll-l2/anomalies'
      preLoaderRoute: typeof AuthPayrollL2AnomaliesRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/allowances': {
      id: '/_auth/payroll-l2/allowances'
      path: '/allowances'
      fullPath: '/payroll-l2/allowances'
      preLoaderRoute: typeof AuthPayrollL2AllowancesRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payments/check-run': {
      id: '/_auth/payments/check-run'
      path: '/check-run'
      fullPath: '/payments/check-run'
      preLoaderRoute: typeof AuthPaymentsCheckRunRouteImport
      parentRoute: typeof AuthPaymentsRoute
    }
    '/_auth/payments/$paymentId': {
      id: '/_auth/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof AuthPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthPaymentsRoute
    }
    '/_auth/onboarding/setup': {
      id: '/_auth/onboarding/setup'
      path: '/setup'
      fullPath: '/onboarding/setup'
      preLoaderRoute: typeof AuthOnboardingSetupRouteImport
      parentRoute: typeof AuthOnboardingRoute
    }
    '/_auth/onboarding/complete': {
      id: '/_auth/onboarding/complete'
      path: '/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof AuthOnboardingCompleteRouteImport
      parentRoute: typeof AuthOnboardingRoute
    }
    '/_auth/lien-waivers_/templates': {
      id: '/_auth/lien-waivers_/templates'
      path: '/lien-waivers/templates'
      fullPath: '/lien-waivers/templates'
      preLoaderRoute: typeof AuthLienWaiversTemplatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journals/new': {
      id: '/_auth/journals/new'
      path: '/new'
      fullPath: '/journals/new'
      preLoaderRoute: typeof AuthJournalsNewRouteImport
      parentRoute: typeof AuthJournalsRoute
    }
    '/_auth/journals/$journalId': {
      id: '/_auth/journals/$journalId'
      path: '/$journalId'
      fullPath: '/journals/$journalId'
      preLoaderRoute: typeof AuthJournalsJournalIdRouteImport
      parentRoute: typeof AuthJournalsRoute
    }
    '/_auth/intercompany/transactions': {
      id: '/_auth/intercompany/transactions'
      path: '/transactions'
      fullPath: '/intercompany/transactions'
      preLoaderRoute: typeof AuthIntercompanyTransactionsRouteImport
      parentRoute: typeof AuthIntercompanyRoute
    }
    '/_auth/hospitality/title-31': {
      id: '/_auth/hospitality/title-31'
      path: '/title-31'
      fullPath: '/hospitality/title-31'
      preLoaderRoute: typeof AuthHospitalityTitle31RouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/revenue-centers': {
      id: '/_auth/hospitality/revenue-centers'
      path: '/revenue-centers'
      fullPath: '/hospitality/revenue-centers'
      preLoaderRoute: typeof AuthHospitalityRevenueCentersRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/night-audit': {
      id: '/_auth/hospitality/night-audit'
      path: '/night-audit'
      fullPath: '/hospitality/night-audit'
      preLoaderRoute: typeof AuthHospitalityNightAuditRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/lodging': {
      id: '/_auth/hospitality/lodging'
      path: '/lodging'
      fullPath: '/hospitality/lodging'
      preLoaderRoute: typeof AuthHospitalityLodgingRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/gaming-tax': {
      id: '/_auth/hospitality/gaming-tax'
      path: '/gaming-tax'
      fullPath: '/hospitality/gaming-tax'
      preLoaderRoute: typeof AuthHospitalityGamingTaxRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/gaming': {
      id: '/_auth/hospitality/gaming'
      path: '/gaming'
      fullPath: '/hospitality/gaming'
      preLoaderRoute: typeof AuthHospitalityGamingRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/fpa': {
      id: '/_auth/hospitality/fpa'
      path: '/fpa'
      fullPath: '/hospitality/fpa'
      preLoaderRoute: typeof AuthHospitalityFpaRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/fnb': {
      id: '/_auth/hospitality/fnb'
      path: '/fnb'
      fullPath: '/hospitality/fnb'
      preLoaderRoute: typeof AuthHospitalityFnbRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/flash': {
      id: '/_auth/hospitality/flash'
      path: '/flash'
      fullPath: '/hospitality/flash'
      preLoaderRoute: typeof AuthHospitalityFlashRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/hospitality/filings': {
      id: '/_auth/hospitality/filings'
      path: '/filings'
      fullPath: '/hospitality/filings'
      preLoaderRoute: typeof AuthHospitalityFilingsRouteImport
      parentRoute: typeof AuthHospitalityRoute
    }
    '/_auth/fpa/budget': {
      id: '/_auth/fpa/budget'
      path: '/fpa/budget'
      fullPath: '/fpa/budget'
      preLoaderRoute: typeof AuthFpaBudgetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/equipment/rental-links': {
      id: '/_auth/equipment/rental-links'
      path: '/rental-links'
      fullPath: '/equipment/rental-links'
      preLoaderRoute: typeof AuthEquipmentRentalLinksRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/equipment/cost-postings': {
      id: '/_auth/equipment/cost-postings'
      path: '/cost-postings'
      fullPath: '/equipment/cost-postings'
      preLoaderRoute: typeof AuthEquipmentCostPostingsRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/equipment/cost-posting': {
      id: '/_auth/equipment/cost-posting'
      path: '/cost-posting'
      fullPath: '/equipment/cost-posting'
      preLoaderRoute: typeof AuthEquipmentCostPostingRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/equipment/$equipmentId': {
      id: '/_auth/equipment/$equipmentId'
      path: '/$equipmentId'
      fullPath: '/equipment/$equipmentId'
      preLoaderRoute: typeof AuthEquipmentEquipmentIdRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/direct-expense/new': {
      id: '/_auth/direct-expense/new'
      path: '/direct-expense/new'
      fullPath: '/direct-expense/new'
      preLoaderRoute: typeof AuthDirectExpenseNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers/$customerId': {
      id: '/_auth/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthCustomersCustomerIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contracts/$contractId': {
      id: '/_auth/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof AuthContractsContractIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contract-work-packages/$packageId': {
      id: '/_auth/contract-work-packages/$packageId'
      path: '/contract-work-packages/$packageId'
      fullPath: '/contract-work-packages/$packageId'
      preLoaderRoute: typeof AuthContractWorkPackagesPackageIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/concrete-plant/operations': {
      id: '/_auth/concrete-plant/operations'
      path: '/concrete-plant/operations'
      fullPath: '/concrete-plant/operations'
      preLoaderRoute: typeof AuthConcretePlantOperationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/concrete-plant/material-to-margin': {
      id: '/_auth/concrete-plant/material-to-margin'
      path: '/concrete-plant/material-to-margin'
      fullPath: '/concrete-plant/material-to-margin'
      preLoaderRoute: typeof AuthConcretePlantMaterialToMarginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/concrete-plant/load-to-cash': {
      id: '/_auth/concrete-plant/load-to-cash'
      path: '/concrete-plant/load-to-cash'
      fullPath: '/concrete-plant/load-to-cash'
      preLoaderRoute: typeof AuthConcretePlantLoadToCashRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/close/templates': {
      id: '/_auth/close/templates'
      path: '/templates'
      fullPath: '/close/templates'
      preLoaderRoute: typeof AuthCloseTemplatesRouteImport
      parentRoute: typeof AuthCloseRoute
    }
    '/_auth/close/$periodId': {
      id: '/_auth/close/$periodId'
      path: '/$periodId'
      fullPath: '/close/$periodId'
      preLoaderRoute: typeof AuthClosePeriodIdRouteImport
      parentRoute: typeof AuthCloseRoute
    }
    '/_auth/bank-rec/$recId': {
      id: '/_auth/bank-rec/$recId'
      path: '/bank-rec/$recId'
      fullPath: '/bank-rec/$recId'
      preLoaderRoute: typeof AuthBankRecRecIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank-accounts/$bankAccountId': {
      id: '/_auth/bank-accounts/$bankAccountId'
      path: '/$bankAccountId'
      fullPath: '/bank-accounts/$bankAccountId'
      preLoaderRoute: typeof AuthBankAccountsBankAccountIdRouteImport
      parentRoute: typeof AuthBankAccountsRoute
    }
    '/_auth/approvals/policies': {
      id: '/_auth/approvals/policies'
      path: '/policies'
      fullPath: '/approvals/policies'
      preLoaderRoute: typeof AuthApprovalsPoliciesRouteImport
      parentRoute: typeof AuthApprovalsRoute
    }
    '/_auth/approvals/analytics': {
      id: '/_auth/approvals/analytics'
      path: '/analytics'
      fullPath: '/approvals/analytics'
      preLoaderRoute: typeof AuthApprovalsAnalyticsRouteImport
      parentRoute: typeof AuthApprovalsRoute
    }
    '/_auth/ap/autopilot': {
      id: '/_auth/ap/autopilot'
      path: '/autopilot'
      fullPath: '/ap/autopilot'
      preLoaderRoute: typeof AuthApAutopilotRouteImport
      parentRoute: typeof AuthApRoute
    }
    '/_auth/admin/usage': {
      id: '/_auth/admin/usage'
      path: '/admin/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AuthAdminUsageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendors/$vendorId/': {
      id: '/_auth/vendors/$vendorId/'
      path: '/'
      fullPath: '/vendors/$vendorId/'
      preLoaderRoute: typeof AuthVendorsVendorIdIndexRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/hospitality/lodging/': {
      id: '/_auth/hospitality/lodging/'
      path: '/'
      fullPath: '/hospitality/lodging/'
      preLoaderRoute: typeof AuthHospitalityLodgingIndexRouteImport
      parentRoute: typeof AuthHospitalityLodgingRoute
    }
    '/_auth/equipment/cost-postings/': {
      id: '/_auth/equipment/cost-postings/'
      path: '/'
      fullPath: '/equipment/cost-postings/'
      preLoaderRoute: typeof AuthEquipmentCostPostingsIndexRouteImport
      parentRoute: typeof AuthEquipmentCostPostingsRoute
    }
    '/_auth/vendors/$vendorId/subcontracts': {
      id: '/_auth/vendors/$vendorId/subcontracts'
      path: '/subcontracts'
      fullPath: '/vendors/$vendorId/subcontracts'
      preLoaderRoute: typeof AuthVendorsVendorIdSubcontractsRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/qualification': {
      id: '/_auth/vendors/$vendorId/qualification'
      path: '/qualification'
      fullPath: '/vendors/$vendorId/qualification'
      preLoaderRoute: typeof AuthVendorsVendorIdQualificationRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/pos': {
      id: '/_auth/vendors/$vendorId/pos'
      path: '/pos'
      fullPath: '/vendors/$vendorId/pos'
      preLoaderRoute: typeof AuthVendorsVendorIdPosRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/payments': {
      id: '/_auth/vendors/$vendorId/payments'
      path: '/payments'
      fullPath: '/vendors/$vendorId/payments'
      preLoaderRoute: typeof AuthVendorsVendorIdPaymentsRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/lien-waivers': {
      id: '/_auth/vendors/$vendorId/lien-waivers'
      path: '/lien-waivers'
      fullPath: '/vendors/$vendorId/lien-waivers'
      preLoaderRoute: typeof AuthVendorsVendorIdLienWaiversRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/autopilot': {
      id: '/_auth/vendors/$vendorId/autopilot'
      path: '/autopilot'
      fullPath: '/vendors/$vendorId/autopilot'
      preLoaderRoute: typeof AuthVendorsVendorIdAutopilotRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/addresses': {
      id: '/_auth/vendors/$vendorId/addresses'
      path: '/addresses'
      fullPath: '/vendors/$vendorId/addresses'
      preLoaderRoute: typeof AuthVendorsVendorIdAddressesRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/vendors/$vendorId/activity': {
      id: '/_auth/vendors/$vendorId/activity'
      path: '/activity'
      fullPath: '/vendors/$vendorId/activity'
      preLoaderRoute: typeof AuthVendorsVendorIdActivityRouteImport
      parentRoute: typeof AuthVendorsVendorIdRoute
    }
    '/_auth/settings/permissions/me': {
      id: '/_auth/settings/permissions/me'
      path: '/permissions/me'
      fullPath: '/settings/permissions/me'
      preLoaderRoute: typeof AuthSettingsPermissionsMeRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/saas/subscriptions/$subId': {
      id: '/_auth/saas/subscriptions/$subId'
      path: '/subscriptions/$subId'
      fullPath: '/saas/subscriptions/$subId'
      preLoaderRoute: typeof AuthSaasSubscriptionsSubIdRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/saas/plans/$planId': {
      id: '/_auth/saas/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/saas/plans/$planId'
      preLoaderRoute: typeof AuthSaasPlansPlanIdRouteImport
      parentRoute: typeof AuthSaasRoute
    }
    '/_auth/projects/$projectId/gmp': {
      id: '/_auth/projects/$projectId/gmp'
      path: '/gmp'
      fullPath: '/projects/$projectId/gmp'
      preLoaderRoute: typeof AuthProjectsProjectIdGmpRouteImport
      parentRoute: typeof AuthProjectsProjectIdRoute
    }
    '/_auth/periods/$periodId/checklist': {
      id: '/_auth/periods/$periodId/checklist'
      path: '/$periodId/checklist'
      fullPath: '/periods/$periodId/checklist'
      preLoaderRoute: typeof AuthPeriodsPeriodIdChecklistRouteImport
      parentRoute: typeof AuthPeriodsRoute
    }
    '/_auth/payroll/pay-runs_/$payRunId': {
      id: '/_auth/payroll/pay-runs_/$payRunId'
      path: '/payroll/pay-runs/$payRunId'
      fullPath: '/payroll/pay-runs/$payRunId'
      preLoaderRoute: typeof AuthPayrollPayRunsPayRunIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/employees_/$employeeId': {
      id: '/_auth/payroll/employees_/$employeeId'
      path: '/payroll/employees/$employeeId'
      fullPath: '/payroll/employees/$employeeId'
      preLoaderRoute: typeof AuthPayrollEmployeesEmployeeIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/contractors_/$contractorId': {
      id: '/_auth/payroll/contractors_/$contractorId'
      path: '/payroll/contractors/$contractorId'
      fullPath: '/payroll/contractors/$contractorId'
      preLoaderRoute: typeof AuthPayrollContractorsContractorIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/wage-determinations_/$wdId': {
      id: '/_auth/payroll-l4/wage-determinations_/$wdId'
      path: '/payroll-l4/wage-determinations/$wdId'
      fullPath: '/payroll-l4/wage-determinations/$wdId'
      preLoaderRoute: typeof AuthPayrollL4WageDeterminationsWdIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l4/certified-payroll-reports_/$reportId': {
      id: '/_auth/payroll-l4/certified-payroll-reports_/$reportId'
      path: '/payroll-l4/certified-payroll-reports/$reportId'
      fullPath: '/payroll-l4/certified-payroll-reports/$reportId'
      preLoaderRoute: typeof AuthPayrollL4CertifiedPayrollReportsReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll-l2/labor-event_/$eventId': {
      id: '/_auth/payroll-l2/labor-event_/$eventId'
      path: '/labor-event/$eventId'
      fullPath: '/payroll-l2/labor-event/$eventId'
      preLoaderRoute: typeof AuthPayrollL2LaborEventEventIdRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/expenses_/new': {
      id: '/_auth/payroll-l2/expenses_/new'
      path: '/expenses/new'
      fullPath: '/payroll-l2/expenses/new'
      preLoaderRoute: typeof AuthPayrollL2ExpensesNewRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/earned-value_/$projectId': {
      id: '/_auth/payroll-l2/earned-value_/$projectId'
      path: '/earned-value/$projectId'
      fullPath: '/payroll-l2/earned-value/$projectId'
      preLoaderRoute: typeof AuthPayrollL2EarnedValueProjectIdRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll-l2/compliance-gate_/$payRunId': {
      id: '/_auth/payroll-l2/compliance-gate_/$payRunId'
      path: '/compliance-gate/$payRunId'
      fullPath: '/payroll-l2/compliance-gate/$payRunId'
      preLoaderRoute: typeof AuthPayrollL2ComplianceGatePayRunIdRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/invoices/ar/new': {
      id: '/_auth/invoices/ar/new'
      path: '/invoices/ar/new'
      fullPath: '/invoices/ar/new'
      preLoaderRoute: typeof AuthInvoicesArNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ar/$invoiceId': {
      id: '/_auth/invoices/ar/$invoiceId'
      path: '/invoices/ar/$invoiceId'
      fullPath: '/invoices/ar/$invoiceId'
      preLoaderRoute: typeof AuthInvoicesArInvoiceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ap/new': {
      id: '/_auth/invoices/ap/new'
      path: '/invoices/ap/new'
      fullPath: '/invoices/ap/new'
      preLoaderRoute: typeof AuthInvoicesApNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/ap/$invoiceId': {
      id: '/_auth/invoices/ap/$invoiceId'
      path: '/invoices/ap/$invoiceId'
      fullPath: '/invoices/ap/$invoiceId'
      preLoaderRoute: typeof AuthInvoicesApInvoiceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hospitality/lodging/folio-ar': {
      id: '/_auth/hospitality/lodging/folio-ar'
      path: '/folio-ar'
      fullPath: '/hospitality/lodging/folio-ar'
      preLoaderRoute: typeof AuthHospitalityLodgingFolioArRouteImport
      parentRoute: typeof AuthHospitalityLodgingRoute
    }
    '/_auth/hospitality/gaming/markers': {
      id: '/_auth/hospitality/gaming/markers'
      path: '/markers'
      fullPath: '/hospitality/gaming/markers'
      preLoaderRoute: typeof AuthHospitalityGamingMarkersRouteImport
      parentRoute: typeof AuthHospitalityGamingRoute
    }
    '/_auth/hospitality/gaming/floor': {
      id: '/_auth/hospitality/gaming/floor'
      path: '/floor'
      fullPath: '/hospitality/gaming/floor'
      preLoaderRoute: typeof AuthHospitalityGamingFloorRouteImport
      parentRoute: typeof AuthHospitalityGamingRoute
    }
    '/_auth/hospitality/fnb/tronc': {
      id: '/_auth/hospitality/fnb/tronc'
      path: '/tronc'
      fullPath: '/hospitality/fnb/tronc'
      preLoaderRoute: typeof AuthHospitalityFnbTroncRouteImport
      parentRoute: typeof AuthHospitalityFnbRoute
    }
    '/_auth/hospitality/fnb/performance': {
      id: '/_auth/hospitality/fnb/performance'
      path: '/performance'
      fullPath: '/hospitality/fnb/performance'
      preLoaderRoute: typeof AuthHospitalityFnbPerformanceRouteImport
      parentRoute: typeof AuthHospitalityFnbRoute
    }
    '/_auth/help_/docs/$': {
      id: '/_auth/help_/docs/$'
      path: '/help/docs/$'
      fullPath: '/help/docs/$'
      preLoaderRoute: typeof AuthHelpDocsSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/equipment/reports/variance': {
      id: '/_auth/equipment/reports/variance'
      path: '/reports/variance'
      fullPath: '/equipment/reports/variance'
      preLoaderRoute: typeof AuthEquipmentReportsVarianceRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/equipment/reports/cost-by-job': {
      id: '/_auth/equipment/reports/cost-by-job'
      path: '/reports/cost-by-job'
      fullPath: '/equipment/reports/cost-by-job'
      preLoaderRoute: typeof AuthEquipmentReportsCostByJobRouteImport
      parentRoute: typeof AuthEquipmentRoute
    }
    '/_auth/equipment/cost-postings/$postingId': {
      id: '/_auth/equipment/cost-postings/$postingId'
      path: '/$postingId'
      fullPath: '/equipment/cost-postings/$postingId'
      preLoaderRoute: typeof AuthEquipmentCostPostingsPostingIdRouteImport
      parentRoute: typeof AuthEquipmentCostPostingsRoute
    }
    '/_auth/payroll/employees_/$employeeId/': {
      id: '/_auth/payroll/employees_/$employeeId/'
      path: '/'
      fullPath: '/payroll/employees/$employeeId/'
      preLoaderRoute: typeof AuthPayrollEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof AuthPayrollEmployeesEmployeeIdRoute
    }
    '/_auth/payroll/year-end_/w3/$year': {
      id: '/_auth/payroll/year-end_/w3/$year'
      path: '/payroll/year-end/w3/$year'
      fullPath: '/payroll/year-end/w3/$year'
      preLoaderRoute: typeof AuthPayrollYearEndW3YearRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/year-end_/w2/$year': {
      id: '/_auth/payroll/year-end_/w2/$year'
      path: '/payroll/year-end/w2/$year'
      fullPath: '/payroll/year-end/w2/$year'
      preLoaderRoute: typeof AuthPayrollYearEndW2YearRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/year-end_/940/$year': {
      id: '/_auth/payroll/year-end_/940/$year'
      path: '/payroll/year-end/940/$year'
      fullPath: '/payroll/year-end/940/$year'
      preLoaderRoute: typeof AuthPayrollYearEnd940YearRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/year-end_/1099-nec/$year': {
      id: '/_auth/payroll/year-end_/1099-nec/$year'
      path: '/payroll/year-end/1099-nec/$year'
      fullPath: '/payroll/year-end/1099-nec/$year'
      preLoaderRoute: typeof AuthPayrollYearEnd1099NecYearRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/year-end_/1099-misc/$year': {
      id: '/_auth/payroll/year-end_/1099-misc/$year'
      path: '/payroll/year-end/1099-misc/$year'
      fullPath: '/payroll/year-end/1099-misc/$year'
      preLoaderRoute: typeof AuthPayrollYearEnd1099MiscYearRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/employees_/$employeeId/w4': {
      id: '/_auth/payroll/employees_/$employeeId/w4'
      path: '/w4'
      fullPath: '/payroll/employees/$employeeId/w4'
      preLoaderRoute: typeof AuthPayrollEmployeesEmployeeIdW4RouteImport
      parentRoute: typeof AuthPayrollEmployeesEmployeeIdRoute
    }
    '/_auth/payroll-l2/employees_/$employeeId/rates': {
      id: '/_auth/payroll-l2/employees_/$employeeId/rates'
      path: '/employees/$employeeId/rates'
      fullPath: '/payroll-l2/employees/$employeeId/rates'
      preLoaderRoute: typeof AuthPayrollL2EmployeesEmployeeIdRatesRouteImport
      parentRoute: typeof AuthPayrollL2Route
    }
    '/_auth/payroll/year-end_/941/$year/$quarter': {
      id: '/_auth/payroll/year-end_/941/$year/$quarter'
      path: '/payroll/year-end/941/$year/$quarter'
      fullPath: '/payroll/year-end/941/$year/$quarter'
      preLoaderRoute: typeof AuthPayrollYearEnd941YearQuarterRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthApRouteChildren {
  AuthApAutopilotRoute: typeof AuthApAutopilotRoute
}

const AuthApRouteChildren: AuthApRouteChildren = {
  AuthApAutopilotRoute: AuthApAutopilotRoute,
}

const AuthApRouteWithChildren =
  AuthApRoute._addFileChildren(AuthApRouteChildren)

interface AuthApprovalsRouteChildren {
  AuthApprovalsAnalyticsRoute: typeof AuthApprovalsAnalyticsRoute
  AuthApprovalsPoliciesRoute: typeof AuthApprovalsPoliciesRoute
  AuthApprovalsIndexRoute: typeof AuthApprovalsIndexRoute
}

const AuthApprovalsRouteChildren: AuthApprovalsRouteChildren = {
  AuthApprovalsAnalyticsRoute: AuthApprovalsAnalyticsRoute,
  AuthApprovalsPoliciesRoute: AuthApprovalsPoliciesRoute,
  AuthApprovalsIndexRoute: AuthApprovalsIndexRoute,
}

const AuthApprovalsRouteWithChildren = AuthApprovalsRoute._addFileChildren(
  AuthApprovalsRouteChildren,
)

interface AuthBankAccountsRouteChildren {
  AuthBankAccountsBankAccountIdRoute: typeof AuthBankAccountsBankAccountIdRoute
  AuthBankAccountsIndexRoute: typeof AuthBankAccountsIndexRoute
}

const AuthBankAccountsRouteChildren: AuthBankAccountsRouteChildren = {
  AuthBankAccountsBankAccountIdRoute: AuthBankAccountsBankAccountIdRoute,
  AuthBankAccountsIndexRoute: AuthBankAccountsIndexRoute,
}

const AuthBankAccountsRouteWithChildren =
  AuthBankAccountsRoute._addFileChildren(AuthBankAccountsRouteChildren)

interface AuthCloseRouteChildren {
  AuthClosePeriodIdRoute: typeof AuthClosePeriodIdRoute
  AuthCloseTemplatesRoute: typeof AuthCloseTemplatesRoute
  AuthCloseIndexRoute: typeof AuthCloseIndexRoute
}

const AuthCloseRouteChildren: AuthCloseRouteChildren = {
  AuthClosePeriodIdRoute: AuthClosePeriodIdRoute,
  AuthCloseTemplatesRoute: AuthCloseTemplatesRoute,
  AuthCloseIndexRoute: AuthCloseIndexRoute,
}

const AuthCloseRouteWithChildren = AuthCloseRoute._addFileChildren(
  AuthCloseRouteChildren,
)

interface AuthEquipmentCostPostingsRouteChildren {
  AuthEquipmentCostPostingsPostingIdRoute: typeof AuthEquipmentCostPostingsPostingIdRoute
  AuthEquipmentCostPostingsIndexRoute: typeof AuthEquipmentCostPostingsIndexRoute
}

const AuthEquipmentCostPostingsRouteChildren: AuthEquipmentCostPostingsRouteChildren =
  {
    AuthEquipmentCostPostingsPostingIdRoute:
      AuthEquipmentCostPostingsPostingIdRoute,
    AuthEquipmentCostPostingsIndexRoute: AuthEquipmentCostPostingsIndexRoute,
  }

const AuthEquipmentCostPostingsRouteWithChildren =
  AuthEquipmentCostPostingsRoute._addFileChildren(
    AuthEquipmentCostPostingsRouteChildren,
  )

interface AuthEquipmentRouteChildren {
  AuthEquipmentEquipmentIdRoute: typeof AuthEquipmentEquipmentIdRoute
  AuthEquipmentCostPostingRoute: typeof AuthEquipmentCostPostingRoute
  AuthEquipmentCostPostingsRoute: typeof AuthEquipmentCostPostingsRouteWithChildren
  AuthEquipmentRentalLinksRoute: typeof AuthEquipmentRentalLinksRoute
  AuthEquipmentIndexRoute: typeof AuthEquipmentIndexRoute
  AuthEquipmentReportsCostByJobRoute: typeof AuthEquipmentReportsCostByJobRoute
  AuthEquipmentReportsVarianceRoute: typeof AuthEquipmentReportsVarianceRoute
}

const AuthEquipmentRouteChildren: AuthEquipmentRouteChildren = {
  AuthEquipmentEquipmentIdRoute: AuthEquipmentEquipmentIdRoute,
  AuthEquipmentCostPostingRoute: AuthEquipmentCostPostingRoute,
  AuthEquipmentCostPostingsRoute: AuthEquipmentCostPostingsRouteWithChildren,
  AuthEquipmentRentalLinksRoute: AuthEquipmentRentalLinksRoute,
  AuthEquipmentIndexRoute: AuthEquipmentIndexRoute,
  AuthEquipmentReportsCostByJobRoute: AuthEquipmentReportsCostByJobRoute,
  AuthEquipmentReportsVarianceRoute: AuthEquipmentReportsVarianceRoute,
}

const AuthEquipmentRouteWithChildren = AuthEquipmentRoute._addFileChildren(
  AuthEquipmentRouteChildren,
)

interface AuthHospitalityFnbRouteChildren {
  AuthHospitalityFnbPerformanceRoute: typeof AuthHospitalityFnbPerformanceRoute
  AuthHospitalityFnbTroncRoute: typeof AuthHospitalityFnbTroncRoute
}

const AuthHospitalityFnbRouteChildren: AuthHospitalityFnbRouteChildren = {
  AuthHospitalityFnbPerformanceRoute: AuthHospitalityFnbPerformanceRoute,
  AuthHospitalityFnbTroncRoute: AuthHospitalityFnbTroncRoute,
}

const AuthHospitalityFnbRouteWithChildren =
  AuthHospitalityFnbRoute._addFileChildren(AuthHospitalityFnbRouteChildren)

interface AuthHospitalityGamingRouteChildren {
  AuthHospitalityGamingFloorRoute: typeof AuthHospitalityGamingFloorRoute
  AuthHospitalityGamingMarkersRoute: typeof AuthHospitalityGamingMarkersRoute
}

const AuthHospitalityGamingRouteChildren: AuthHospitalityGamingRouteChildren = {
  AuthHospitalityGamingFloorRoute: AuthHospitalityGamingFloorRoute,
  AuthHospitalityGamingMarkersRoute: AuthHospitalityGamingMarkersRoute,
}

const AuthHospitalityGamingRouteWithChildren =
  AuthHospitalityGamingRoute._addFileChildren(
    AuthHospitalityGamingRouteChildren,
  )

interface AuthHospitalityLodgingRouteChildren {
  AuthHospitalityLodgingFolioArRoute: typeof AuthHospitalityLodgingFolioArRoute
  AuthHospitalityLodgingIndexRoute: typeof AuthHospitalityLodgingIndexRoute
}

const AuthHospitalityLodgingRouteChildren: AuthHospitalityLodgingRouteChildren =
  {
    AuthHospitalityLodgingFolioArRoute: AuthHospitalityLodgingFolioArRoute,
    AuthHospitalityLodgingIndexRoute: AuthHospitalityLodgingIndexRoute,
  }

const AuthHospitalityLodgingRouteWithChildren =
  AuthHospitalityLodgingRoute._addFileChildren(
    AuthHospitalityLodgingRouteChildren,
  )

interface AuthHospitalityRouteChildren {
  AuthHospitalityFilingsRoute: typeof AuthHospitalityFilingsRoute
  AuthHospitalityFlashRoute: typeof AuthHospitalityFlashRoute
  AuthHospitalityFnbRoute: typeof AuthHospitalityFnbRouteWithChildren
  AuthHospitalityFpaRoute: typeof AuthHospitalityFpaRoute
  AuthHospitalityGamingRoute: typeof AuthHospitalityGamingRouteWithChildren
  AuthHospitalityGamingTaxRoute: typeof AuthHospitalityGamingTaxRoute
  AuthHospitalityLodgingRoute: typeof AuthHospitalityLodgingRouteWithChildren
  AuthHospitalityNightAuditRoute: typeof AuthHospitalityNightAuditRoute
  AuthHospitalityRevenueCentersRoute: typeof AuthHospitalityRevenueCentersRoute
  AuthHospitalityTitle31Route: typeof AuthHospitalityTitle31Route
  AuthHospitalityIndexRoute: typeof AuthHospitalityIndexRoute
}

const AuthHospitalityRouteChildren: AuthHospitalityRouteChildren = {
  AuthHospitalityFilingsRoute: AuthHospitalityFilingsRoute,
  AuthHospitalityFlashRoute: AuthHospitalityFlashRoute,
  AuthHospitalityFnbRoute: AuthHospitalityFnbRouteWithChildren,
  AuthHospitalityFpaRoute: AuthHospitalityFpaRoute,
  AuthHospitalityGamingRoute: AuthHospitalityGamingRouteWithChildren,
  AuthHospitalityGamingTaxRoute: AuthHospitalityGamingTaxRoute,
  AuthHospitalityLodgingRoute: AuthHospitalityLodgingRouteWithChildren,
  AuthHospitalityNightAuditRoute: AuthHospitalityNightAuditRoute,
  AuthHospitalityRevenueCentersRoute: AuthHospitalityRevenueCentersRoute,
  AuthHospitalityTitle31Route: AuthHospitalityTitle31Route,
  AuthHospitalityIndexRoute: AuthHospitalityIndexRoute,
}

const AuthHospitalityRouteWithChildren = AuthHospitalityRoute._addFileChildren(
  AuthHospitalityRouteChildren,
)

interface AuthIntercompanyRouteChildren {
  AuthIntercompanyTransactionsRoute: typeof AuthIntercompanyTransactionsRoute
  AuthIntercompanyIndexRoute: typeof AuthIntercompanyIndexRoute
}

const AuthIntercompanyRouteChildren: AuthIntercompanyRouteChildren = {
  AuthIntercompanyTransactionsRoute: AuthIntercompanyTransactionsRoute,
  AuthIntercompanyIndexRoute: AuthIntercompanyIndexRoute,
}

const AuthIntercompanyRouteWithChildren =
  AuthIntercompanyRoute._addFileChildren(AuthIntercompanyRouteChildren)

interface AuthJournalsRouteChildren {
  AuthJournalsJournalIdRoute: typeof AuthJournalsJournalIdRoute
  AuthJournalsNewRoute: typeof AuthJournalsNewRoute
  AuthJournalsIndexRoute: typeof AuthJournalsIndexRoute
}

const AuthJournalsRouteChildren: AuthJournalsRouteChildren = {
  AuthJournalsJournalIdRoute: AuthJournalsJournalIdRoute,
  AuthJournalsNewRoute: AuthJournalsNewRoute,
  AuthJournalsIndexRoute: AuthJournalsIndexRoute,
}

const AuthJournalsRouteWithChildren = AuthJournalsRoute._addFileChildren(
  AuthJournalsRouteChildren,
)

interface AuthOnboardingRouteChildren {
  AuthOnboardingCompleteRoute: typeof AuthOnboardingCompleteRoute
  AuthOnboardingSetupRoute: typeof AuthOnboardingSetupRoute
  AuthOnboardingIndexRoute: typeof AuthOnboardingIndexRoute
}

const AuthOnboardingRouteChildren: AuthOnboardingRouteChildren = {
  AuthOnboardingCompleteRoute: AuthOnboardingCompleteRoute,
  AuthOnboardingSetupRoute: AuthOnboardingSetupRoute,
  AuthOnboardingIndexRoute: AuthOnboardingIndexRoute,
}

const AuthOnboardingRouteWithChildren = AuthOnboardingRoute._addFileChildren(
  AuthOnboardingRouteChildren,
)

interface AuthPaymentsRouteChildren {
  AuthPaymentsPaymentIdRoute: typeof AuthPaymentsPaymentIdRoute
  AuthPaymentsCheckRunRoute: typeof AuthPaymentsCheckRunRoute
  AuthPaymentsIndexRoute: typeof AuthPaymentsIndexRoute
}

const AuthPaymentsRouteChildren: AuthPaymentsRouteChildren = {
  AuthPaymentsPaymentIdRoute: AuthPaymentsPaymentIdRoute,
  AuthPaymentsCheckRunRoute: AuthPaymentsCheckRunRoute,
  AuthPaymentsIndexRoute: AuthPaymentsIndexRoute,
}

const AuthPaymentsRouteWithChildren = AuthPaymentsRoute._addFileChildren(
  AuthPaymentsRouteChildren,
)

interface AuthPayrollL2RouteChildren {
  AuthPayrollL2AllowancesRoute: typeof AuthPayrollL2AllowancesRoute
  AuthPayrollL2AnomaliesRoute: typeof AuthPayrollL2AnomaliesRoute
  AuthPayrollL2BurdenRoute: typeof AuthPayrollL2BurdenRoute
  AuthPayrollL2CraftsRoute: typeof AuthPayrollL2CraftsRoute
  AuthPayrollL2DifferentialsRoute: typeof AuthPayrollL2DifferentialsRoute
  AuthPayrollL2EquipmentRoute: typeof AuthPayrollL2EquipmentRoute
  AuthPayrollL2ExpensesRoute: typeof AuthPayrollL2ExpensesRoute
  AuthPayrollL2FlaggedRoute: typeof AuthPayrollL2FlaggedRoute
  AuthPayrollL2FormsRoute: typeof AuthPayrollL2FormsRoute
  AuthPayrollL2OtRulesRoute: typeof AuthPayrollL2OtRulesRoute
  AuthPayrollL2RetroPayRoute: typeof AuthPayrollL2RetroPayRoute
  AuthPayrollL2TimesheetFeedRoute: typeof AuthPayrollL2TimesheetFeedRoute
  AuthPayrollL2WorkersCompRoute: typeof AuthPayrollL2WorkersCompRoute
  AuthPayrollL2ComplianceGatePayRunIdRoute: typeof AuthPayrollL2ComplianceGatePayRunIdRoute
  AuthPayrollL2EarnedValueProjectIdRoute: typeof AuthPayrollL2EarnedValueProjectIdRoute
  AuthPayrollL2ExpensesNewRoute: typeof AuthPayrollL2ExpensesNewRoute
  AuthPayrollL2LaborEventEventIdRoute: typeof AuthPayrollL2LaborEventEventIdRoute
  AuthPayrollL2EmployeesEmployeeIdRatesRoute: typeof AuthPayrollL2EmployeesEmployeeIdRatesRoute
}

const AuthPayrollL2RouteChildren: AuthPayrollL2RouteChildren = {
  AuthPayrollL2AllowancesRoute: AuthPayrollL2AllowancesRoute,
  AuthPayrollL2AnomaliesRoute: AuthPayrollL2AnomaliesRoute,
  AuthPayrollL2BurdenRoute: AuthPayrollL2BurdenRoute,
  AuthPayrollL2CraftsRoute: AuthPayrollL2CraftsRoute,
  AuthPayrollL2DifferentialsRoute: AuthPayrollL2DifferentialsRoute,
  AuthPayrollL2EquipmentRoute: AuthPayrollL2EquipmentRoute,
  AuthPayrollL2ExpensesRoute: AuthPayrollL2ExpensesRoute,
  AuthPayrollL2FlaggedRoute: AuthPayrollL2FlaggedRoute,
  AuthPayrollL2FormsRoute: AuthPayrollL2FormsRoute,
  AuthPayrollL2OtRulesRoute: AuthPayrollL2OtRulesRoute,
  AuthPayrollL2RetroPayRoute: AuthPayrollL2RetroPayRoute,
  AuthPayrollL2TimesheetFeedRoute: AuthPayrollL2TimesheetFeedRoute,
  AuthPayrollL2WorkersCompRoute: AuthPayrollL2WorkersCompRoute,
  AuthPayrollL2ComplianceGatePayRunIdRoute:
    AuthPayrollL2ComplianceGatePayRunIdRoute,
  AuthPayrollL2EarnedValueProjectIdRoute:
    AuthPayrollL2EarnedValueProjectIdRoute,
  AuthPayrollL2ExpensesNewRoute: AuthPayrollL2ExpensesNewRoute,
  AuthPayrollL2LaborEventEventIdRoute: AuthPayrollL2LaborEventEventIdRoute,
  AuthPayrollL2EmployeesEmployeeIdRatesRoute:
    AuthPayrollL2EmployeesEmployeeIdRatesRoute,
}

const AuthPayrollL2RouteWithChildren = AuthPayrollL2Route._addFileChildren(
  AuthPayrollL2RouteChildren,
)

interface AuthPayrollL3RouteChildren {
  AuthPayrollL3ApprenticeComplianceRoute: typeof AuthPayrollL3ApprenticeComplianceRoute
  AuthPayrollL3CbasRoute: typeof AuthPayrollL3CbasRoute
  AuthPayrollL3ClassificationQueueRoute: typeof AuthPayrollL3ClassificationQueueRoute
  AuthPayrollL3ComplianceAlertsRoute: typeof AuthPayrollL3ComplianceAlertsRoute
  AuthPayrollL3ContractsRoute: typeof AuthPayrollL3ContractsRoute
  AuthPayrollL3FringeFundsRoute: typeof AuthPayrollL3FringeFundsRoute
  AuthPayrollL3GlSetupRoute: typeof AuthPayrollL3GlSetupRoute
  AuthPayrollL3MembershipsRoute: typeof AuthPayrollL3MembershipsRoute
  AuthPayrollL3RemittanceRoute: typeof AuthPayrollL3RemittanceRoute
  AuthPayrollL3WorkingRulesRoute: typeof AuthPayrollL3WorkingRulesRoute
  AuthPayrollL3IndexRoute: typeof AuthPayrollL3IndexRoute
}

const AuthPayrollL3RouteChildren: AuthPayrollL3RouteChildren = {
  AuthPayrollL3ApprenticeComplianceRoute:
    AuthPayrollL3ApprenticeComplianceRoute,
  AuthPayrollL3CbasRoute: AuthPayrollL3CbasRoute,
  AuthPayrollL3ClassificationQueueRoute: AuthPayrollL3ClassificationQueueRoute,
  AuthPayrollL3ComplianceAlertsRoute: AuthPayrollL3ComplianceAlertsRoute,
  AuthPayrollL3ContractsRoute: AuthPayrollL3ContractsRoute,
  AuthPayrollL3FringeFundsRoute: AuthPayrollL3FringeFundsRoute,
  AuthPayrollL3GlSetupRoute: AuthPayrollL3GlSetupRoute,
  AuthPayrollL3MembershipsRoute: AuthPayrollL3MembershipsRoute,
  AuthPayrollL3RemittanceRoute: AuthPayrollL3RemittanceRoute,
  AuthPayrollL3WorkingRulesRoute: AuthPayrollL3WorkingRulesRoute,
  AuthPayrollL3IndexRoute: AuthPayrollL3IndexRoute,
}

const AuthPayrollL3RouteWithChildren = AuthPayrollL3Route._addFileChildren(
  AuthPayrollL3RouteChildren,
)

interface AuthPeriodsRouteChildren {
  AuthPeriodsIndexRoute: typeof AuthPeriodsIndexRoute
  AuthPeriodsPeriodIdChecklistRoute: typeof AuthPeriodsPeriodIdChecklistRoute
}

const AuthPeriodsRouteChildren: AuthPeriodsRouteChildren = {
  AuthPeriodsIndexRoute: AuthPeriodsIndexRoute,
  AuthPeriodsPeriodIdChecklistRoute: AuthPeriodsPeriodIdChecklistRoute,
}

const AuthPeriodsRouteWithChildren = AuthPeriodsRoute._addFileChildren(
  AuthPeriodsRouteChildren,
)

interface AuthProgressBillingsRouteChildren {
  AuthProgressBillingsPbIdRoute: typeof AuthProgressBillingsPbIdRoute
  AuthProgressBillingsIndexRoute: typeof AuthProgressBillingsIndexRoute
}

const AuthProgressBillingsRouteChildren: AuthProgressBillingsRouteChildren = {
  AuthProgressBillingsPbIdRoute: AuthProgressBillingsPbIdRoute,
  AuthProgressBillingsIndexRoute: AuthProgressBillingsIndexRoute,
}

const AuthProgressBillingsRouteWithChildren =
  AuthProgressBillingsRoute._addFileChildren(AuthProgressBillingsRouteChildren)

interface AuthProjectsProjectIdRouteChildren {
  AuthProjectsProjectIdGmpRoute: typeof AuthProjectsProjectIdGmpRoute
}

const AuthProjectsProjectIdRouteChildren: AuthProjectsProjectIdRouteChildren = {
  AuthProjectsProjectIdGmpRoute: AuthProjectsProjectIdGmpRoute,
}

const AuthProjectsProjectIdRouteWithChildren =
  AuthProjectsProjectIdRoute._addFileChildren(
    AuthProjectsProjectIdRouteChildren,
  )

interface AuthProjectsRouteChildren {
  AuthProjectsProjectIdRoute: typeof AuthProjectsProjectIdRouteWithChildren
  AuthProjectsIndexRoute: typeof AuthProjectsIndexRoute
}

const AuthProjectsRouteChildren: AuthProjectsRouteChildren = {
  AuthProjectsProjectIdRoute: AuthProjectsProjectIdRouteWithChildren,
  AuthProjectsIndexRoute: AuthProjectsIndexRoute,
}

const AuthProjectsRouteWithChildren = AuthProjectsRoute._addFileChildren(
  AuthProjectsRouteChildren,
)

interface AuthRateSheetsRouteChildren {
  AuthRateSheetsRateSheetIdRoute: typeof AuthRateSheetsRateSheetIdRoute
  AuthRateSheetsNewRoute: typeof AuthRateSheetsNewRoute
  AuthRateSheetsIndexRoute: typeof AuthRateSheetsIndexRoute
}

const AuthRateSheetsRouteChildren: AuthRateSheetsRouteChildren = {
  AuthRateSheetsRateSheetIdRoute: AuthRateSheetsRateSheetIdRoute,
  AuthRateSheetsNewRoute: AuthRateSheetsNewRoute,
  AuthRateSheetsIndexRoute: AuthRateSheetsIndexRoute,
}

const AuthRateSheetsRouteWithChildren = AuthRateSheetsRoute._addFileChildren(
  AuthRateSheetsRouteChildren,
)

interface AuthSaasRouteChildren {
  AuthSaasCohortsRoute: typeof AuthSaasCohortsRoute
  AuthSaasCrmRoute: typeof AuthSaasCrmRoute
  AuthSaasMetricsRoute: typeof AuthSaasMetricsRoute
  AuthSaasPayrollSyncRoute: typeof AuthSaasPayrollSyncRoute
  AuthSaasVariableConsiderationRoute: typeof AuthSaasVariableConsiderationRoute
  AuthSaasVendorWatchRoute: typeof AuthSaasVendorWatchRoute
  AuthSaasIndexRoute: typeof AuthSaasIndexRoute
  AuthSaasPlansPlanIdRoute: typeof AuthSaasPlansPlanIdRoute
  AuthSaasSubscriptionsSubIdRoute: typeof AuthSaasSubscriptionsSubIdRoute
}

const AuthSaasRouteChildren: AuthSaasRouteChildren = {
  AuthSaasCohortsRoute: AuthSaasCohortsRoute,
  AuthSaasCrmRoute: AuthSaasCrmRoute,
  AuthSaasMetricsRoute: AuthSaasMetricsRoute,
  AuthSaasPayrollSyncRoute: AuthSaasPayrollSyncRoute,
  AuthSaasVariableConsiderationRoute: AuthSaasVariableConsiderationRoute,
  AuthSaasVendorWatchRoute: AuthSaasVendorWatchRoute,
  AuthSaasIndexRoute: AuthSaasIndexRoute,
  AuthSaasPlansPlanIdRoute: AuthSaasPlansPlanIdRoute,
  AuthSaasSubscriptionsSubIdRoute: AuthSaasSubscriptionsSubIdRoute,
}

const AuthSaasRouteWithChildren = AuthSaasRoute._addFileChildren(
  AuthSaasRouteChildren,
)

interface AuthSettingsRouteChildren {
  AuthSettingsAboutRoute: typeof AuthSettingsAboutRoute
  AuthSettingsApiCostsRoute: typeof AuthSettingsApiCostsRoute
  AuthSettingsApiKeysRoute: typeof AuthSettingsApiKeysRoute
  AuthSettingsBackupsRoute: typeof AuthSettingsBackupsRoute
  AuthSettingsBankConnectionsRoute: typeof AuthSettingsBankConnectionsRoute
  AuthSettingsCrmRoute: typeof AuthSettingsCrmRoute
  AuthSettingsCurrencyRoute: typeof AuthSettingsCurrencyRoute
  AuthSettingsDimensionsRoute: typeof AuthSettingsDimensionsRoute
  AuthSettingsEntitiesRoute: typeof AuthSettingsEntitiesRoute
  AuthSettingsImportsQuickbooksRoute: typeof AuthSettingsImportsQuickbooksRoute
  AuthSettingsIntegrationsRoute: typeof AuthSettingsIntegrationsRoute
  AuthSettingsMcpRoute: typeof AuthSettingsMcpRoute
  AuthSettingsNumberingRoute: typeof AuthSettingsNumberingRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthSettingsShopifyRoute: typeof AuthSettingsShopifyRoute
  AuthSettingsTaxRoute: typeof AuthSettingsTaxRoute
  AuthSettingsTeamRoute: typeof AuthSettingsTeamRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
  AuthSettingsPermissionsMeRoute: typeof AuthSettingsPermissionsMeRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsAboutRoute: AuthSettingsAboutRoute,
  AuthSettingsApiCostsRoute: AuthSettingsApiCostsRoute,
  AuthSettingsApiKeysRoute: AuthSettingsApiKeysRoute,
  AuthSettingsBackupsRoute: AuthSettingsBackupsRoute,
  AuthSettingsBankConnectionsRoute: AuthSettingsBankConnectionsRoute,
  AuthSettingsCrmRoute: AuthSettingsCrmRoute,
  AuthSettingsCurrencyRoute: AuthSettingsCurrencyRoute,
  AuthSettingsDimensionsRoute: AuthSettingsDimensionsRoute,
  AuthSettingsEntitiesRoute: AuthSettingsEntitiesRoute,
  AuthSettingsImportsQuickbooksRoute: AuthSettingsImportsQuickbooksRoute,
  AuthSettingsIntegrationsRoute: AuthSettingsIntegrationsRoute,
  AuthSettingsMcpRoute: AuthSettingsMcpRoute,
  AuthSettingsNumberingRoute: AuthSettingsNumberingRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthSettingsShopifyRoute: AuthSettingsShopifyRoute,
  AuthSettingsTaxRoute: AuthSettingsTaxRoute,
  AuthSettingsTeamRoute: AuthSettingsTeamRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
  AuthSettingsPermissionsMeRoute: AuthSettingsPermissionsMeRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthSubPayAppsRouteChildren {
  AuthSubPayAppsPayAppIdRoute: typeof AuthSubPayAppsPayAppIdRoute
}

const AuthSubPayAppsRouteChildren: AuthSubPayAppsRouteChildren = {
  AuthSubPayAppsPayAppIdRoute: AuthSubPayAppsPayAppIdRoute,
}

const AuthSubPayAppsRouteWithChildren = AuthSubPayAppsRoute._addFileChildren(
  AuthSubPayAppsRouteChildren,
)

interface AuthTmInvoicesRouteChildren {
  AuthTmInvoicesInvoiceIdRoute: typeof AuthTmInvoicesInvoiceIdRoute
  AuthTmInvoicesNewRoute: typeof AuthTmInvoicesNewRoute
  AuthTmInvoicesIndexRoute: typeof AuthTmInvoicesIndexRoute
}

const AuthTmInvoicesRouteChildren: AuthTmInvoicesRouteChildren = {
  AuthTmInvoicesInvoiceIdRoute: AuthTmInvoicesInvoiceIdRoute,
  AuthTmInvoicesNewRoute: AuthTmInvoicesNewRoute,
  AuthTmInvoicesIndexRoute: AuthTmInvoicesIndexRoute,
}

const AuthTmInvoicesRouteWithChildren = AuthTmInvoicesRoute._addFileChildren(
  AuthTmInvoicesRouteChildren,
)

interface AuthTmTicketsRouteChildren {
  AuthTmTicketsTicketIdRoute: typeof AuthTmTicketsTicketIdRoute
  AuthTmTicketsNewRoute: typeof AuthTmTicketsNewRoute
  AuthTmTicketsIndexRoute: typeof AuthTmTicketsIndexRoute
}

const AuthTmTicketsRouteChildren: AuthTmTicketsRouteChildren = {
  AuthTmTicketsTicketIdRoute: AuthTmTicketsTicketIdRoute,
  AuthTmTicketsNewRoute: AuthTmTicketsNewRoute,
  AuthTmTicketsIndexRoute: AuthTmTicketsIndexRoute,
}

const AuthTmTicketsRouteWithChildren = AuthTmTicketsRoute._addFileChildren(
  AuthTmTicketsRouteChildren,
)

interface AuthVendorsVendorIdRouteChildren {
  AuthVendorsVendorIdActivityRoute: typeof AuthVendorsVendorIdActivityRoute
  AuthVendorsVendorIdAddressesRoute: typeof AuthVendorsVendorIdAddressesRoute
  AuthVendorsVendorIdAutopilotRoute: typeof AuthVendorsVendorIdAutopilotRoute
  AuthVendorsVendorIdLienWaiversRoute: typeof AuthVendorsVendorIdLienWaiversRoute
  AuthVendorsVendorIdPaymentsRoute: typeof AuthVendorsVendorIdPaymentsRoute
  AuthVendorsVendorIdPosRoute: typeof AuthVendorsVendorIdPosRoute
  AuthVendorsVendorIdQualificationRoute: typeof AuthVendorsVendorIdQualificationRoute
  AuthVendorsVendorIdSubcontractsRoute: typeof AuthVendorsVendorIdSubcontractsRoute
  AuthVendorsVendorIdIndexRoute: typeof AuthVendorsVendorIdIndexRoute
}

const AuthVendorsVendorIdRouteChildren: AuthVendorsVendorIdRouteChildren = {
  AuthVendorsVendorIdActivityRoute: AuthVendorsVendorIdActivityRoute,
  AuthVendorsVendorIdAddressesRoute: AuthVendorsVendorIdAddressesRoute,
  AuthVendorsVendorIdAutopilotRoute: AuthVendorsVendorIdAutopilotRoute,
  AuthVendorsVendorIdLienWaiversRoute: AuthVendorsVendorIdLienWaiversRoute,
  AuthVendorsVendorIdPaymentsRoute: AuthVendorsVendorIdPaymentsRoute,
  AuthVendorsVendorIdPosRoute: AuthVendorsVendorIdPosRoute,
  AuthVendorsVendorIdQualificationRoute: AuthVendorsVendorIdQualificationRoute,
  AuthVendorsVendorIdSubcontractsRoute: AuthVendorsVendorIdSubcontractsRoute,
  AuthVendorsVendorIdIndexRoute: AuthVendorsVendorIdIndexRoute,
}

const AuthVendorsVendorIdRouteWithChildren =
  AuthVendorsVendorIdRoute._addFileChildren(AuthVendorsVendorIdRouteChildren)

interface AuthPayrollEmployeesEmployeeIdRouteChildren {
  AuthPayrollEmployeesEmployeeIdW4Route: typeof AuthPayrollEmployeesEmployeeIdW4Route
  AuthPayrollEmployeesEmployeeIdIndexRoute: typeof AuthPayrollEmployeesEmployeeIdIndexRoute
}

const AuthPayrollEmployeesEmployeeIdRouteChildren: AuthPayrollEmployeesEmployeeIdRouteChildren =
  {
    AuthPayrollEmployeesEmployeeIdW4Route:
      AuthPayrollEmployeesEmployeeIdW4Route,
    AuthPayrollEmployeesEmployeeIdIndexRoute:
      AuthPayrollEmployeesEmployeeIdIndexRoute,
  }

const AuthPayrollEmployeesEmployeeIdRouteWithChildren =
  AuthPayrollEmployeesEmployeeIdRoute._addFileChildren(
    AuthPayrollEmployeesEmployeeIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthAccountsRoute: typeof AuthAccountsRoute
  AuthAgentsRoute: typeof AuthAgentsRoute
  AuthApRoute: typeof AuthApRouteWithChildren
  AuthApiSpendRoute: typeof AuthApiSpendRoute
  AuthApprovalsRoute: typeof AuthApprovalsRouteWithChildren
  AuthArRoute: typeof AuthArRoute
  AuthAssetsRoute: typeof AuthAssetsRoute
  AuthAuditLogRoute: typeof AuthAuditLogRoute
  AuthBalanceSheetRoute: typeof AuthBalanceSheetRoute
  AuthBankAccountsRoute: typeof AuthBankAccountsRouteWithChildren
  AuthBillsIntakeRoute: typeof AuthBillsIntakeRoute
  AuthCapTableRoute: typeof AuthCapTableRoute
  AuthCashFlowRoute: typeof AuthCashFlowRoute
  AuthCfoAdvisorRoute: typeof AuthCfoAdvisorRoute
  AuthChangeOrdersRoute: typeof AuthChangeOrdersRoute
  AuthChatRoute: typeof AuthChatRoute
  AuthChatHistoryRoute: typeof AuthChatHistoryRoute
  AuthCloseRoute: typeof AuthCloseRouteWithChildren
  AuthComplianceRoute: typeof AuthComplianceRoute
  AuthContactsRoute: typeof AuthContactsRoute
  AuthContractToCashRoute: typeof AuthContractToCashRoute
  AuthCostCodeTemplatesRoute: typeof AuthCostCodeTemplatesRoute
  AuthCostCodesRoute: typeof AuthCostCodesRoute
  AuthDataMigrationRoute: typeof AuthDataMigrationRoute
  AuthEmployeesRoute: typeof AuthEmployeesRoute
  AuthEnterpriseAccountingRoute: typeof AuthEnterpriseAccountingRoute
  AuthEquipmentRoute: typeof AuthEquipmentRouteWithChildren
  AuthExpensesRoute: typeof AuthExpensesRoute
  AuthFxRatesRoute: typeof AuthFxRatesRoute
  AuthGlRoute: typeof AuthGlRoute
  AuthHelpRoute: typeof AuthHelpRoute
  AuthHospitalityRoute: typeof AuthHospitalityRouteWithChildren
  AuthImportsRoute: typeof AuthImportsRoute
  AuthIncomeStatementRoute: typeof AuthIncomeStatementRoute
  AuthIntercompanyRoute: typeof AuthIntercompanyRouteWithChildren
  AuthJobCostRoute: typeof AuthJobCostRoute
  AuthJournalsRoute: typeof AuthJournalsRouteWithChildren
  AuthLienWaiversRoute: typeof AuthLienWaiversRoute
  AuthOnboardingRoute: typeof AuthOnboardingRouteWithChildren
  AuthPaymentsRoute: typeof AuthPaymentsRouteWithChildren
  AuthPayrollL2Route: typeof AuthPayrollL2RouteWithChildren
  AuthPayrollL3Route: typeof AuthPayrollL3RouteWithChildren
  AuthPeriodsRoute: typeof AuthPeriodsRouteWithChildren
  AuthProgressBillingsRoute: typeof AuthProgressBillingsRouteWithChildren
  AuthProjectExecutiveRoute: typeof AuthProjectExecutiveRoute
  AuthProjectsRoute: typeof AuthProjectsRouteWithChildren
  AuthRateSheetsRoute: typeof AuthRateSheetsRouteWithChildren
  AuthRecognitionRoute: typeof AuthRecognitionRoute
  AuthRecurringChargesRoute: typeof AuthRecurringChargesRoute
  AuthRecurringJournalsRoute: typeof AuthRecurringJournalsRoute
  AuthSaasRoute: typeof AuthSaasRouteWithChildren
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthSubPayAppsRoute: typeof AuthSubPayAppsRouteWithChildren
  AuthSubcontractsRoute: typeof AuthSubcontractsRoute
  AuthTimeRoute: typeof AuthTimeRoute
  AuthTmInvoicesRoute: typeof AuthTmInvoicesRouteWithChildren
  AuthTmTicketsRoute: typeof AuthTmTicketsRouteWithChildren
  AuthTrialBalanceRoute: typeof AuthTrialBalanceRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdminUsageRoute: typeof AuthAdminUsageRoute
  AuthBankRecRecIdRoute: typeof AuthBankRecRecIdRoute
  AuthConcretePlantLoadToCashRoute: typeof AuthConcretePlantLoadToCashRoute
  AuthConcretePlantMaterialToMarginRoute: typeof AuthConcretePlantMaterialToMarginRoute
  AuthConcretePlantOperationsRoute: typeof AuthConcretePlantOperationsRoute
  AuthContractWorkPackagesPackageIdRoute: typeof AuthContractWorkPackagesPackageIdRoute
  AuthContractsContractIdRoute: typeof AuthContractsContractIdRoute
  AuthCustomersCustomerIdRoute: typeof AuthCustomersCustomerIdRoute
  AuthDirectExpenseNewRoute: typeof AuthDirectExpenseNewRoute
  AuthFpaBudgetRoute: typeof AuthFpaBudgetRoute
  AuthLienWaiversTemplatesRoute: typeof AuthLienWaiversTemplatesRoute
  AuthPayrollL4ApprenticeProgramsRoute: typeof AuthPayrollL4ApprenticeProgramsRoute
  AuthPayrollL4CertifiedPayrollReportsRoute: typeof AuthPayrollL4CertifiedPayrollReportsRoute
  AuthPayrollL4ComplianceRoute: typeof AuthPayrollL4ComplianceRoute
  AuthPayrollL4SubmissionsRoute: typeof AuthPayrollL4SubmissionsRoute
  AuthPayrollL4WageDeterminationsRoute: typeof AuthPayrollL4WageDeterminationsRoute
  AuthPayrollContractorsRoute: typeof AuthPayrollContractorsRoute
  AuthPayrollDeductionCodesRoute: typeof AuthPayrollDeductionCodesRoute
  AuthPayrollEarningCodesRoute: typeof AuthPayrollEarningCodesRoute
  AuthPayrollEmployeesRoute: typeof AuthPayrollEmployeesRoute
  AuthPayrollIrisSubmissionsRoute: typeof AuthPayrollIrisSubmissionsRoute
  AuthPayrollPayRunsRoute: typeof AuthPayrollPayRunsRoute
  AuthPayrollSetupRoute: typeof AuthPayrollSetupRoute
  AuthPayrollTaxDepositsRoute: typeof AuthPayrollTaxDepositsRoute
  AuthPayrollYearEndRoute: typeof AuthPayrollYearEndRoute
  AuthPurchaseOrdersPoIdRoute: typeof AuthPurchaseOrdersPoIdRoute
  AuthPurchaseOrdersNewRoute: typeof AuthPurchaseOrdersNewRoute
  AuthReportsReportIdRoute: typeof AuthReportsReportIdRoute
  AuthReportsApAgingRoute: typeof AuthReportsApAgingRoute
  AuthReportsArAgingRoute: typeof AuthReportsArAgingRoute
  AuthReportsAssetRollforwardRoute: typeof AuthReportsAssetRollforwardRoute
  AuthReportsBookTaxDifferenceRoute: typeof AuthReportsBookTaxDifferenceRoute
  AuthReportsBuildRoute: typeof AuthReportsBuildRoute
  AuthReportsChartsRoute: typeof AuthReportsChartsRoute
  AuthReportsCommittedCostRoute: typeof AuthReportsCommittedCostRoute
  AuthReportsConsolidatedRoute: typeof AuthReportsConsolidatedRoute
  AuthReportsCostCodeRollupRoute: typeof AuthReportsCostCodeRollupRoute
  AuthReportsSubDrawHistoryRoute: typeof AuthReportsSubDrawHistoryRoute
  AuthReportsSubPayAppAgingRoute: typeof AuthReportsSubPayAppAgingRoute
  AuthReportsSubRetentionRoute: typeof AuthReportsSubRetentionRoute
  AuthReportsTaxDepreciationRoute: typeof AuthReportsTaxDepreciationRoute
  AuthReportsWipRoute: typeof AuthReportsWipRoute
  AuthVendorsVendorIdRoute: typeof AuthVendorsVendorIdRouteWithChildren
  AuthVendorsMergeToolRoute: typeof AuthVendorsMergeToolRoute
  AuthBankRecIndexRoute: typeof AuthBankRecIndexRoute
  AuthConcretePlantIndexRoute: typeof AuthConcretePlantIndexRoute
  AuthContractWorkPackagesIndexRoute: typeof AuthContractWorkPackagesIndexRoute
  AuthContractsIndexRoute: typeof AuthContractsIndexRoute
  AuthCustomersIndexRoute: typeof AuthCustomersIndexRoute
  AuthInvoicesIndexRoute: typeof AuthInvoicesIndexRoute
  AuthPurchaseOrdersIndexRoute: typeof AuthPurchaseOrdersIndexRoute
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute
  AuthVendorsIndexRoute: typeof AuthVendorsIndexRoute
  AuthHelpDocsSplatRoute: typeof AuthHelpDocsSplatRoute
  AuthInvoicesApInvoiceIdRoute: typeof AuthInvoicesApInvoiceIdRoute
  AuthInvoicesApNewRoute: typeof AuthInvoicesApNewRoute
  AuthInvoicesArInvoiceIdRoute: typeof AuthInvoicesArInvoiceIdRoute
  AuthInvoicesArNewRoute: typeof AuthInvoicesArNewRoute
  AuthPayrollL4CertifiedPayrollReportsReportIdRoute: typeof AuthPayrollL4CertifiedPayrollReportsReportIdRoute
  AuthPayrollL4WageDeterminationsWdIdRoute: typeof AuthPayrollL4WageDeterminationsWdIdRoute
  AuthPayrollContractorsContractorIdRoute: typeof AuthPayrollContractorsContractorIdRoute
  AuthPayrollEmployeesEmployeeIdRoute: typeof AuthPayrollEmployeesEmployeeIdRouteWithChildren
  AuthPayrollPayRunsPayRunIdRoute: typeof AuthPayrollPayRunsPayRunIdRoute
  AuthPayrollYearEnd1099MiscYearRoute: typeof AuthPayrollYearEnd1099MiscYearRoute
  AuthPayrollYearEnd1099NecYearRoute: typeof AuthPayrollYearEnd1099NecYearRoute
  AuthPayrollYearEnd940YearRoute: typeof AuthPayrollYearEnd940YearRoute
  AuthPayrollYearEndW2YearRoute: typeof AuthPayrollYearEndW2YearRoute
  AuthPayrollYearEndW3YearRoute: typeof AuthPayrollYearEndW3YearRoute
  AuthPayrollYearEnd941YearQuarterRoute: typeof AuthPayrollYearEnd941YearQuarterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountsRoute: AuthAccountsRoute,
  AuthAgentsRoute: AuthAgentsRoute,
  AuthApRoute: AuthApRouteWithChildren,
  AuthApiSpendRoute: AuthApiSpendRoute,
  AuthApprovalsRoute: AuthApprovalsRouteWithChildren,
  AuthArRoute: AuthArRoute,
  AuthAssetsRoute: AuthAssetsRoute,
  AuthAuditLogRoute: AuthAuditLogRoute,
  AuthBalanceSheetRoute: AuthBalanceSheetRoute,
  AuthBankAccountsRoute: AuthBankAccountsRouteWithChildren,
  AuthBillsIntakeRoute: AuthBillsIntakeRoute,
  AuthCapTableRoute: AuthCapTableRoute,
  AuthCashFlowRoute: AuthCashFlowRoute,
  AuthCfoAdvisorRoute: AuthCfoAdvisorRoute,
  AuthChangeOrdersRoute: AuthChangeOrdersRoute,
  AuthChatRoute: AuthChatRoute,
  AuthChatHistoryRoute: AuthChatHistoryRoute,
  AuthCloseRoute: AuthCloseRouteWithChildren,
  AuthComplianceRoute: AuthComplianceRoute,
  AuthContactsRoute: AuthContactsRoute,
  AuthContractToCashRoute: AuthContractToCashRoute,
  AuthCostCodeTemplatesRoute: AuthCostCodeTemplatesRoute,
  AuthCostCodesRoute: AuthCostCodesRoute,
  AuthDataMigrationRoute: AuthDataMigrationRoute,
  AuthEmployeesRoute: AuthEmployeesRoute,
  AuthEnterpriseAccountingRoute: AuthEnterpriseAccountingRoute,
  AuthEquipmentRoute: AuthEquipmentRouteWithChildren,
  AuthExpensesRoute: AuthExpensesRoute,
  AuthFxRatesRoute: AuthFxRatesRoute,
  AuthGlRoute: AuthGlRoute,
  AuthHelpRoute: AuthHelpRoute,
  AuthHospitalityRoute: AuthHospitalityRouteWithChildren,
  AuthImportsRoute: AuthImportsRoute,
  AuthIncomeStatementRoute: AuthIncomeStatementRoute,
  AuthIntercompanyRoute: AuthIntercompanyRouteWithChildren,
  AuthJobCostRoute: AuthJobCostRoute,
  AuthJournalsRoute: AuthJournalsRouteWithChildren,
  AuthLienWaiversRoute: AuthLienWaiversRoute,
  AuthOnboardingRoute: AuthOnboardingRouteWithChildren,
  AuthPaymentsRoute: AuthPaymentsRouteWithChildren,
  AuthPayrollL2Route: AuthPayrollL2RouteWithChildren,
  AuthPayrollL3Route: AuthPayrollL3RouteWithChildren,
  AuthPeriodsRoute: AuthPeriodsRouteWithChildren,
  AuthProgressBillingsRoute: AuthProgressBillingsRouteWithChildren,
  AuthProjectExecutiveRoute: AuthProjectExecutiveRoute,
  AuthProjectsRoute: AuthProjectsRouteWithChildren,
  AuthRateSheetsRoute: AuthRateSheetsRouteWithChildren,
  AuthRecognitionRoute: AuthRecognitionRoute,
  AuthRecurringChargesRoute: AuthRecurringChargesRoute,
  AuthRecurringJournalsRoute: AuthRecurringJournalsRoute,
  AuthSaasRoute: AuthSaasRouteWithChildren,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthSubPayAppsRoute: AuthSubPayAppsRouteWithChildren,
  AuthSubcontractsRoute: AuthSubcontractsRoute,
  AuthTimeRoute: AuthTimeRoute,
  AuthTmInvoicesRoute: AuthTmInvoicesRouteWithChildren,
  AuthTmTicketsRoute: AuthTmTicketsRouteWithChildren,
  AuthTrialBalanceRoute: AuthTrialBalanceRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdminUsageRoute: AuthAdminUsageRoute,
  AuthBankRecRecIdRoute: AuthBankRecRecIdRoute,
  AuthConcretePlantLoadToCashRoute: AuthConcretePlantLoadToCashRoute,
  AuthConcretePlantMaterialToMarginRoute:
    AuthConcretePlantMaterialToMarginRoute,
  AuthConcretePlantOperationsRoute: AuthConcretePlantOperationsRoute,
  AuthContractWorkPackagesPackageIdRoute:
    AuthContractWorkPackagesPackageIdRoute,
  AuthContractsContractIdRoute: AuthContractsContractIdRoute,
  AuthCustomersCustomerIdRoute: AuthCustomersCustomerIdRoute,
  AuthDirectExpenseNewRoute: AuthDirectExpenseNewRoute,
  AuthFpaBudgetRoute: AuthFpaBudgetRoute,
  AuthLienWaiversTemplatesRoute: AuthLienWaiversTemplatesRoute,
  AuthPayrollL4ApprenticeProgramsRoute: AuthPayrollL4ApprenticeProgramsRoute,
  AuthPayrollL4CertifiedPayrollReportsRoute:
    AuthPayrollL4CertifiedPayrollReportsRoute,
  AuthPayrollL4ComplianceRoute: AuthPayrollL4ComplianceRoute,
  AuthPayrollL4SubmissionsRoute: AuthPayrollL4SubmissionsRoute,
  AuthPayrollL4WageDeterminationsRoute: AuthPayrollL4WageDeterminationsRoute,
  AuthPayrollContractorsRoute: AuthPayrollContractorsRoute,
  AuthPayrollDeductionCodesRoute: AuthPayrollDeductionCodesRoute,
  AuthPayrollEarningCodesRoute: AuthPayrollEarningCodesRoute,
  AuthPayrollEmployeesRoute: AuthPayrollEmployeesRoute,
  AuthPayrollIrisSubmissionsRoute: AuthPayrollIrisSubmissionsRoute,
  AuthPayrollPayRunsRoute: AuthPayrollPayRunsRoute,
  AuthPayrollSetupRoute: AuthPayrollSetupRoute,
  AuthPayrollTaxDepositsRoute: AuthPayrollTaxDepositsRoute,
  AuthPayrollYearEndRoute: AuthPayrollYearEndRoute,
  AuthPurchaseOrdersPoIdRoute: AuthPurchaseOrdersPoIdRoute,
  AuthPurchaseOrdersNewRoute: AuthPurchaseOrdersNewRoute,
  AuthReportsReportIdRoute: AuthReportsReportIdRoute,
  AuthReportsApAgingRoute: AuthReportsApAgingRoute,
  AuthReportsArAgingRoute: AuthReportsArAgingRoute,
  AuthReportsAssetRollforwardRoute: AuthReportsAssetRollforwardRoute,
  AuthReportsBookTaxDifferenceRoute: AuthReportsBookTaxDifferenceRoute,
  AuthReportsBuildRoute: AuthReportsBuildRoute,
  AuthReportsChartsRoute: AuthReportsChartsRoute,
  AuthReportsCommittedCostRoute: AuthReportsCommittedCostRoute,
  AuthReportsConsolidatedRoute: AuthReportsConsolidatedRoute,
  AuthReportsCostCodeRollupRoute: AuthReportsCostCodeRollupRoute,
  AuthReportsSubDrawHistoryRoute: AuthReportsSubDrawHistoryRoute,
  AuthReportsSubPayAppAgingRoute: AuthReportsSubPayAppAgingRoute,
  AuthReportsSubRetentionRoute: AuthReportsSubRetentionRoute,
  AuthReportsTaxDepreciationRoute: AuthReportsTaxDepreciationRoute,
  AuthReportsWipRoute: AuthReportsWipRoute,
  AuthVendorsVendorIdRoute: AuthVendorsVendorIdRouteWithChildren,
  AuthVendorsMergeToolRoute: AuthVendorsMergeToolRoute,
  AuthBankRecIndexRoute: AuthBankRecIndexRoute,
  AuthConcretePlantIndexRoute: AuthConcretePlantIndexRoute,
  AuthContractWorkPackagesIndexRoute: AuthContractWorkPackagesIndexRoute,
  AuthContractsIndexRoute: AuthContractsIndexRoute,
  AuthCustomersIndexRoute: AuthCustomersIndexRoute,
  AuthInvoicesIndexRoute: AuthInvoicesIndexRoute,
  AuthPurchaseOrdersIndexRoute: AuthPurchaseOrdersIndexRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
  AuthVendorsIndexRoute: AuthVendorsIndexRoute,
  AuthHelpDocsSplatRoute: AuthHelpDocsSplatRoute,
  AuthInvoicesApInvoiceIdRoute: AuthInvoicesApInvoiceIdRoute,
  AuthInvoicesApNewRoute: AuthInvoicesApNewRoute,
  AuthInvoicesArInvoiceIdRoute: AuthInvoicesArInvoiceIdRoute,
  AuthInvoicesArNewRoute: AuthInvoicesArNewRoute,
  AuthPayrollL4CertifiedPayrollReportsReportIdRoute:
    AuthPayrollL4CertifiedPayrollReportsReportIdRoute,
  AuthPayrollL4WageDeterminationsWdIdRoute:
    AuthPayrollL4WageDeterminationsWdIdRoute,
  AuthPayrollContractorsContractorIdRoute:
    AuthPayrollContractorsContractorIdRoute,
  AuthPayrollEmployeesEmployeeIdRoute:
    AuthPayrollEmployeesEmployeeIdRouteWithChildren,
  AuthPayrollPayRunsPayRunIdRoute: AuthPayrollPayRunsPayRunIdRoute,
  AuthPayrollYearEnd1099MiscYearRoute: AuthPayrollYearEnd1099MiscYearRoute,
  AuthPayrollYearEnd1099NecYearRoute: AuthPayrollYearEnd1099NecYearRoute,
  AuthPayrollYearEnd940YearRoute: AuthPayrollYearEnd940YearRoute,
  AuthPayrollYearEndW2YearRoute: AuthPayrollYearEndW2YearRoute,
  AuthPayrollYearEndW3YearRoute: AuthPayrollYearEndW3YearRoute,
  AuthPayrollYearEnd941YearQuarterRoute: AuthPayrollYearEnd941YearQuarterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  CallbackRoute: CallbackRoute,
  HandoffRoute: HandoffRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ReviewBudgetRoute: ReviewBudgetRoute,
  PortalTokenRoute: PortalTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
